import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    'en': {
         // investments main
        "Equilibrata": "Competitive",
        "Ospite_med_fav": "Away_med_fav",
        "Ospite_min_fav": "Away_min_fav",
        "Casa_med_fav": "Home_med_fav",
        "Casa_min_fav": "Home_min_fav",
        "Ospite_max_fav": "Away_max_fav",
        "Casa_max_fav":"Home_max_fav",


        "Sort By League": "Sort By League",
        "Sort By Time": "Sort By Time",
        "Data saved successfully": "Data saved successfully",
        "Time ": "Time",
        "Cancel ": "Cancel",
        "Add ": "Add",
        "Operation by All leagues": "Operation by All leagues",
        "Operation by single leagues": "Operation by single leagues",
        "no strategy tips": "no strategy tips",
        /* Modal elements */
        'Match': 'Match',
        'Select Match': 'Select Match',
        'Coming Up': 'Coming Up',
        'Competition': 'Competition',
        'Open': 'Open',
        // 'General Filters': 'General Filters',
        'Odd Filters': 'Odd Filters',
        'Odds': 'Odds',
        'Total Live Stats': 'Total Live Stats',
        'Last 10 minutes Live Stats': 'Last 10 minutes Live Stats',
        'atk chart': 'atk chart',
        'Cancel': 'Cancel',
        'Select': 'Select',
        'Enter the Odd': 'Enter the Odd',
        'Enter the Stake': 'Enter the Stake',
        'pre-match Odd': 'pre-match Odd',
        'Responsability': 'Responsability',
        'Bookmaker': 'Bookmaker',
        'Correct Score': 'Correct Score',
        'Enter CS Odd': 'Enter CS Odd',
        'Enter CS Stake': 'Enter CS Stake',
        'Stake to cover': 'Stake to cover',
        'CS Odds': 'CS Odds',
        'Back': 'Back', 
        'Lay': 'Lay',
        'Total Matched': 'Total Matched',
        'Select Risk Trading': 'Select Risk Trading',
        'Easy': 'Easy',
        'Medium': 'Medium',
        'Risky': 'Risky',
        'Select Strategy': 'Select Strategy',
        'Alerts': 'Alerts',
        'Events': 'Events',
        'Odd': 'Odd',
        'Min': 'Min',
        'Score': 'Score',
        'Strategy': 'Strategy',
        'C': 'C',
        'Messages': 'Messages',
        'Cash out bar': 'Cash out bar',
        'Insert Odd and Stake': 'Insert Odd and Stake',
        'Max profit': 'Max profit',
        'Current Profit': 'Current Profit',
        'Correct Score bar': 'Correct Score bar',
        'Insert CS Odd and Stake': 'Insert CS Odd and Stake',
        'Equalization Bar': 'Equalization Bar',
        'cold stats': 'cold stats',
        'CLICK HERE TO LOAD COLD STATS': 'CLICK HERE TO LOAD COLD STATS',
        'team analysis': 'team analysis',
        'CLICK HERE TO LOAD TEAM ANALYSIS DATA.': 'CLICK HERE TO LOAD TEAM ANALYSIS DATA.',
        'Responsibility': 'responsibility',
        'Lay X': 'X Lay',
        'Back X': 'X Back',
        'Lay 1': '1 Lay',
        'Lay 2': '2 Lay',
        'Back Over 0.5': 'Over 0.5',
        'Back Over 1.5': 'Over 1.5',
        'Back Over 2.5': 'Over 2.5',
        'Back Under 2.5': 'Under 2.5',
        'Back Under 3.5': 'Under 3.5',
        'Alert Stats FT': 'Alert Stats FT',
        'Select CS': 'Select CS',
        'Save Data': 'Save Data',
        'Delete Data': 'Delete Data',
        coming_up_main: 'coming up',
        'NS': 'non started',


        /* === homepage === */
        'Welcome to Goal Traders by Sospeso!': 'Welcome to Goal Traders by Sospeso!',
        'Welcome!': 'Welcome!',
        'How to start ?': 'How to start ?',
        'It is important to start with the right foot: for a better trading experience have a look on user’s video tutorial.': 'It is important to start with the right foot: for a better trading experience have a look on user’s video tutorial.',
        'Click here': 'Click here',
        'What’s new ?': 'What’s new ?',
        'The best platform tool for sport trading is here! Goal Traders by Sospeso is always updated to give you the best that you can have. We will let you know here if some updating is coming soon…': 'The best platform tool for sport trading is here! Goal Traders by Sospeso is always updated to give you the best that you can have. We will let you know here if some updating is coming soon…',
        'Let’s keep in touch': 'Let’s keep in touch',
        'For every support that you need you can contact us to:': 'For every support that you need you can contact us to:',
        'supporto.info@nicoladefontetipster.com': 'supporto.info@nicoladefontetipster.com',
        'Our social channels': 'Our social channels',

        /* === feedpage === */
        'Refresh': 'Refresh',
        /* Posts */
        'Posted': 'Posted',
        'Public': 'Public Tip',
        'Private': 'Private Tip',
        'Tips': 'Tips',
        'Odd': 'Odd',
        'Stake pts': 'Stake pts',
        'Strategy': 'Strategy',
        'Cash out details': 'Cash Out details',
        'Tip Cash Out': 'Tip Cashed out',
        'Cover Cash Out': 'Cover Cashed out',
        'Current profit': 'Current profit',
        'Note': 'Note',
        'write here your comment': 'write here your comment',
        'Post Comment': 'post comment',
        'PTS (total)': 'PTS (total)',
        /* Tooltips Buttons */
        'Like this tip': 'Like this tip',
        'You already liked this tip': 'You already liked this tip',
        'Follow this tip': 'Follow this tip',
        'You already followed this tip': 'You already followed this tip',
        'Follow this tipster': 'Follow this tipster',
        'You already followed this tipster': 'You already followed this tipster',
        /* Auto */
        'Auto': 'Auto',
        'Auto cash out (TIP)': 'Auto cash out (TIP)',
        'Auto cash out (COVER)': 'Auto cash out (COVER)',
        'profit pts': 'profit pts',
        'profit %': 'profit %',
        'stop loss %': 'stop loss %',
        'next odd (higher than)': 'next odd (higher than)',
        'next odd (lower than)': 'next odd (lower than)',
        'minute': 'minute',
        'score': 'score',
        'attempt to accept (Max:10)': 'attempt to accept (Max:10)',
        'OK': 'OK',
        'Cancel': 'Cancel',
        'Clean': 'Clean',

        /* === userpage === */
        'Filter': 'Filter',
        'type string': 'type string...',
        'User': 'User',
        'Total Tips': 'Total Tips',
        'Pending Tips': 'Pending tips',
        'ROI%': 'Roi %',
        'Profit pts': 'Profit pts',
        'W/Rate': 'W/Rate',
        'Followers': 'Followers',
        'Follow': 'Follow',

        /* === top bar menu === */
        /* Bell menu */
        'Notifications': 'Notifications',
        'Updates': 'Updates',
        'Messages': 'Messages',
        'Settled Tips': 'Settled Tips',
        'Comments': 'Comments',
        /* User menu */
        'My Tips and Stats': 'My Tips and Stats',
        'Settings': 'Settings',
        'Profile': 'Profile',        
        'Payments': 'Payments',
        'Logout': 'Logout',

        /* === usersetting === */
        'Default Bf com': 'Default betfair tax',
        'Goal sound': 'Goal sound',
        'New alert sound': 'Alert sound',
        'Currency': 'Currency',
        'Language': 'Language',
        'Timezone': 'Timezone',
        'Update': 'Update',

        /* === post a tip === */
        'Date': 'Date',
        'Country': 'Country',
        'League': 'League',
        'Event': 'Event',
        'Prediction type available': 'Prediction type available',
        'Status': 'Status',
        'Score': 'Score',
        'Odd': 'Odd',
        'Stake': 'Stake',
        'Visibility': 'Visibility',
        'Add to Strategy': 'Add to Strategy',
        'Note': 'Note',
        'Last Updated': 'Last Updated',
        'Reset': 'Reset',
        'Post tip': 'Post Tip',
        /* Date input fields */
        'select...': ' select...',
        'Today': 'Today',
        'Tomorrow': 'Tomorrow',
        'Live Events': 'Live Events',
        'Private': 'Private',
        'Public': 'Public',

        /* === usertipPost === */
         'Tips': 'Tips',
        'Profit PTs': 'Profit PTs',
        'ROI %': 'ROI %',
        'W/Rate': 'W/Rate',
        'Followers': 'Followers',
        'My tips': 'My tips',
        'Strategies': 'Strategies',
        'Stats': 'Stats',
        'Options': 'Options',
        'Pending Tips': 'Pending Tips',
        'Settled Tips': 'Settled Tips',
        'Create a strategy': 'Create a strategy',
        'Name': 'Name',
        'Description': 'Description',
        'e.g.strategy 43': 'e.g.strategy 43',
        'e.g.This strategy is for testing over 2.5 at half time when the home team is leadig at half time': 'e.g.This strategy is for testing over 2.5 at half time when the home team is leadig at half time',
        'Create': ' Create',
        'Strategy list': 'Strategy list',
        'Filter': 'Filter',
        'type string': 'type string',
        'Stats': 'Stats',
        'Details': 'Details',
        'Delete': 'Delete',
        'Strategy name': 'Strategy name',
        'Stats': 'Stats',
        'Stats by league': 'Stats by league',
        'Reset details': 'Reset details',
        'Reset Count': 'Reset Count',
        'Reset stat': ' Reset stat',

        /* === league stats === */
        'League': 'League',
        'Match Result %': 'Match Result %',
        'Average Goals': 'Average Goals',
        'Fist Half Overs %': 'Fist Half Overs %',
        'Full Match Overs %': 'Full Match Overs %',
        'Goal Bands [% of matches with at least one goal in time period': 'Goal Bands [% of matches with at least one goal in time period',
        'First To Score': 'First To Score',
        'Country': 'Country',
        'League': 'League',
        'Tier': 'Tier',
        'Matches': 'Matches',
        'Home': 'Home',
        'Draw': 'Draw',
        'Away': 'Away',
        'Total': 'Total',
        '0.5 FH': '0.5 FH',
        '1.5 FH': '1.5 FH',
        '2.5 FH': '2.5 FH',
        'Bts': 'Bts',
        'H Win': 'H Win',
        'A Win': 'A Win',
        'League Data by Start Price': 'League Data by Start Price',
        'H_StrongFav': ' H_StrongFav',
        'H_MediumFav': ' H_MediumFav',
        'H_SmallFav': ' H_SmallFav',
        'SuperCompetative': ' SuperCompetative',
        'A_StrongFav': ' A_StrongFav',
        'A_MediumFav': ' A_MediumFav',
        'A_SmallFav': ' A_SmallFav',
        '15 minutes': '15 minutes',
        '30 minutes': '30 minutes',
        '45 minutes': '45 minutes',
        '60 minutes': '60 minutes',
        '75 minutes': '75 minutes',
        'all': 'all',
        'scorelines that lead to more goals': 'scorelines that lead to more goals',
        'Shots on Target to Goal Averages': 'Shots on Target to Goal Averages',
        'Goal+ Home': 'Goal+ Home',
        'Goal+ Away': 'Goal+ Away',
        'Shot On Target': 'Shot On Target',
        'Goal Avg': 'Goal Avg',
        'Fixture': 'Fixture',
        'Date': 'Date',
        'Label': 'Label',
        'Odds': 'Odds',
        'Goal Times': 'Goal Times',
        'Red': 'Red',
        'Cards?': 'Cards?',
        'BTTS': 'BTTS',
        'Results': 'Results',
        'HT': 'HT',
        'FT': 'FT',
        'Home': 'Home',
        'Draw': 'Draw',
        'Away': 'Away',
        'Y': 'Y',
        'N': 'N',

        /* === membership page === */
        'This page is not allowed for your current membership plan.': 'This page is not allowed for your current membership plan.',
        'Please upgrade your plan': 'Please upgrade your plan',
        'here': 'here',
        'or contact the administrator': 'or contact the administrator',
        'Upgrade plan': 'Upgrade plan',

        /* === money management page === */
        'Create money management': 'Create money management',
        'Insert a name': 'Insert a name',
        'Starting Bank': 'Starting bank',
        'Target profit': 'Target profit',
        'Stop Losses': 'Stop loss',
        'Currency': 'Currency',
        'Management name': 'Management Name',
        'Add': 'Add',
        'Money manangement list': 'Money manangement list',
        'Name': 'Name',
        'Starting Bank(€)': 'Starting Bank(€)',
        'Target Profit(%)': 'Target Profit(%)',
        'Stop Loss(%)': 'Stop Loss(%)',
        'P / L %': 'P / L %',
        'Actions': 'Actions',
        'View': 'View',
        'Delete': 'Delete',
        //detail
        'Money management detail': 'Money management detail',
        'Detail': 'Detail',
        'moneyDetail': 'Detail',
        'Starting Bank': 'Starting Bank',
        'Target Profit': 'Target Profit',
        'Today in profits': 'Today in profits',
        'Daily stop losses': 'Daily stop losses',
        'Today losses': 'Today losses',
        'Current Bank': 'Current Bank',
        'Profit / Losses': 'Profit / Losses',
        'Trades in profits': 'Trades in profits',
        'Best profit': 'Best profit',
        'Trades losses': 'Trades losses',
        'Worse loss': 'Worse loss',
        'Today in profits': 'Today in profits',
        'Today losses': 'Today losses',
        'round stake values 0,50 multiple': 'round stake values 0,50 multiple',
        'Index': 'Index',
        'Events': 'Events',
        'Date': 'Date',
        'Current Bank': 'Current Bank',
        'Stake (points)': 'Stake (points)',
        'Back/Lay': 'Back/Lay',
        'Odd': 'Odd',
        'Stake': 'Stake',
        'Profit': 'Profit',
        'Risk': 'Risk',
        'Real Profit': 'Real Profit',
        'Balance': 'Balance',
        'Edit': 'Edit',
        'Back': 'Back',
        'Lay': 'Lay',

        /* === league table === */
        'Please select...': 'Please select...',
        'Full': 'Full',
        'Home - Away': 'Home - Away',
        'First Half': 'First Half',
        'Second Half': 'Second Half',
        'Form - Overall': 'Form - Overall',
        'Form - 3 Matches': 'Form - 3 Matches',
        'Form - 6 Matches': 'Form - 6 Matches',
        'Home Attack v Away Defence': 'Home Attack v Away Defence',
        'Home Defence v Away Attack': 'Home Defence v Away Attack',
        'Team': 'Team',
        'Home Attack': 'Home Attack',
        'Away Attack': 'Away Attack',
        'Away Defence': 'Away Defence',
        'Home Defence': 'Home Defence',
        'Points': 'Points',

        /* === coldstats === */
        'Search fixtures for today': ' Search fixtures for today ',
        'Search fixtures for tomorrow': ' Search fixtures for tomorrow ',
        'Search fixtures for ': 'Search fixtures for ',
        'Monday': 'monday ',
        'Tuesday': 'tuesday ',
        'Wednesday': 'wednesday ',
        'Thursday': 'thursday ',
        'Fryday': 'fryday ',
        'Saturday': 'saturday ',
        'Sunday': 'sunday ',
        'Competition': 'Competition',
        'Time': 'Time',
        'Team': 'Team',
        'H': 'H',
        'A': 'A',
        'Scored': 'Scored',
        'Conc.': 'Conc.',
        'Average': 'Average',
        'Filters': 'Filters',
        'Red Card': 'Red card',
        'FH': 'FH',
        'SH': 'SH',
        'Show last': 'Show last',
        'ALL': 'All',
        'days': 'days',
        'Home Lineup': 'Home lineup',
        'All': 'All',
        'Away Lineup': 'Away lineup',
        'All': 'All',
        'HomeTeam': 'Home team',
        'AwayTeam': 'Away team',
        'vs All': 'vs All',
        'vs High rank': 'vs high rank',
        'vs middle-high rank': 'vs middle-high rank',
        'vs middle-low rank': 'vs middle-low rank',
        'vs low rank': 'vs low rank',
        'FH goals Scored:': 'FH goals Scored:',
        'home': 'home',
        'away': 'away',
        'probability': 'probability',
        'SH goals Scored:': 'SH goals Scored:',
        'D': 'D',
        'First': 'First',
        'Last': 'Last',
        'H 1st': 'H 1st',
        'D 1st': 'D 1st',
        'A 1st': 'A 1st',
        'H 2nd': 'H 2nd',
        'D 2nd': 'D 2nd',
        'A 2nd': 'A 2nd',
        'Total': 'Total',
        'Pos': 'Pos',
        'H/A': 'H/A',
        'Swing': 'Gap',
        'FH': 'FH',
        'SH': 'SH',
        'Attack': 'Attack',
        'Defense': 'Defense',
        'Form': 'Form',
        'H/A Form': 'H/A form',

        /* Modal elements */

        'Details': 'Details',
        'Home': 'Home',
        'Away': 'Away',
        'FH': 'FH',
        'FT': 'FT',
        'Full Score Table': 'Full score table',
        'Standings': 'Standings',
        'P': 'P',
        'W': 'W',
        'D': 'D',
        'L': 'L',
        'F': 'F',
        'A': 'A',
        'GD': 'GD',       

         /* === valuestats === */
        'matches': 'matches',        
        'BTS': 'BTS',
        '1 year': '1 year',
        '3 years': '3 years',
        '10 years': '10 years',
        'Bet365 odds': 'Bet365 Odds',
        'Betfair prices': 'Betfair Odds',
        'Recent form': 'Recent form',

        /* Tool Tip */

        'True Odd': 'True odd',
        'Stat': 'Stat',

        /* === profile === */
        'Username': 'Username',
        'Select Avatar': 'Select avatar',
        'Alias': 'Alias',
        'Save changes': 'Save changes',    
        /* Avatar modal window */
        'Select avatar': 'Select avatar',
        'Save': 'Save',

        /* === nav dashboard === */
        'General Filters': 'General filters',
        'Cup': 'Cup',
        'Back': 'Back',
        'Lay': 'Lay',
        'Double Tips': 'Double tips',
        'Odd Filters': 'Odd filters',
        'Matched Filters': 'Matched filters',
        'Commissions': 'Taxes',
        'Add all events': 'Add all events',
        'Clear': 'Clear',
        'Clear ended events': 'Clear ended events',

        /* Table Labels*/

        'Match': 'Matches',
        'Tot. matched': 'Tot. matched',
        'Pre Odd': 'Pre odd',
        'Pdd': 'Odd',
        'Back': 'Back',
        'Lay': 'Lay',
        'Status': 'Status',
        'Minute': 'Minute',
        'Score': 'Score',
        'Gain/Losses': 'Gain/Losses',

        /* Table inside fields */

        'Back': 'Back',
        'Lay': 'Lay',
        'Closed': 'Closed',
        "Close": "Close",
        'Live': 'Live',
        'Suspended': 'Suspended',
        'Coming up': 'Coming up',

        /* === livestats === */
        'Scheduled Games': 'Scheduled Games',
        'LIVE Games': 'LIVE Games',
        'Finished Games': 'Finished Games',
        'My Games': 'My Games',
        'Result': 'Score',
        'Total Game': 'Total Game',
        'Last 10 minutes': 'Last 10 minutes',
        'Odds': 'Odds',
        'Next goal': 'Next goal',
        'Next Goal': 'Next Goal',
        'Matches': 'Matches',
        'Last Updated': 'Last Updated',

        /* modal window */

        'Historical Stats': 'Historical Stats',
        'Avg Stats Per Game': 'Avg Stats Per Game',
        'Chart': 'Chart',
        'Odds': 'Odds',

        /* === navbar === */
        'Auto Tip/Cash': 'Auto Tip/Cash',
        'Dashboard': 'Dashboard',
        'Sospeso': 'Sospeso',
        'Live stats': 'Live stats',
        'Admin settings': 'Admin settings',
        'Cold Stats': 'Cold Stats',
        'Cold Stats1': 'Cold Stats',
        'Search stats': 'Search stats',
        'Team Analysis': 'Team Analysis',
        'Today': 'Today',
        'Money Manage': 'Money Manage',
        'Page Settings': 'Page Settings',
        'User List': 'User List',
        'User List Page': 'User List Page',
        'Main': 'Sospeso WEB',
        'liveStatsNew': 'Live stats',
        'Live Stats Analysis 1': 'Search stats',
        'AdminView': 'Admin settings',
        'Page Setting': 'Page Setting',
        'Feed Page': 'Alerts',

        'League Table': 'League tables',
        'Value stats data': 'Value bets',
        'Live Stats Analysis': 'Live Stats Analysis',
        'Historic Data': 'Historic Odds',
        'Nav Dashboard': 'Sospeso Dashboard',
        'League Stats': 'League Stats', 

        /* === label tooltip === */
        ' H ': 'Home team',
        ' A ': 'Away team',
        ' P ': 'Played matches for local team at home and played matches for visitor team away.',
        ' 0 - 0 ': 'Percentage of matches that went 0 - 0 for local team at home and for visitor team away.',
        ' Ov. 1.5 ': 'Percentage of matches that went over than 1.5 total goals for local team at home and for visitor team away.',
        ' Ov. 2.5 ': 'Percentage of matches that went over than 2.5 total goals for local team at home and for visitor team away.',
        ' Ov. 3.5 ': 'Percentage of matches that went over than 3.5 total goals for local team at home and for visitor team away.',
        ' Scored ': 'Percentage of the matches that a team scored at aleast a goal, local team at home and visitor team away.',
        ' Conc ': 'Percentage of the matches that a team conceded at aleast a goal, local team at home and visitor team away.',
        ' BTS ': 'Percentage of the matches that both teams scored a goal, local team at home and visitor team away.',
        ' 1 + 1st ': 'Percentage of the matches with at least 1 goal in the first half, local team at home and visitor team away.',
        ' 2 + 1st ': 'Percentage of the matches with at least 2 goals in the first half, local team at home and visitor team away.',
        ' 1 + 2st ': 'Percentage of the matches with at least 1 goal in the second half, local team at home and visitor team away.',
        ' 2 + 2st ': 'Percentage of the matches with at least 2 goals in the second half, local team at home and visitor team away.',
        ' Red card ': 'To filter the matches with at least a Red card, on first or second half or on both halves.',
        ' Show last ': 'To filter the last matches played',
        ' Home lineup ': 'To filter the matches played by the local team with a particular lineup',
        ' Away lineup ': 'To filter the matches played by the visitor team with a particular lineup',
        ' Home team ': 'To filter the matches played by the local team against visitor team with a particular rank',
        ' Away team ': 'To filter the matches played by the visitor team against local team with a particular rank',

        ' G+ ': 'Amount of goals scored by the local team at home and visitor team away',
        ' G- ': 'Amount of goals conceded by the local team at home and visitor team away',
        ' 0 - 15 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 16 - 30 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 31 - 45 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 46 - 60 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 61 - 75 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 76 - 90 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' GS1 ': 'Percentage of goals scored in the first half by the local team at home and visitor team away',
        ' GS2 ': 'Percentage of goals scored in the second half by the local team at home and visitor team away',
        ' GC1 ': 'Percentage of goals conceded in the first half by the local team at home and visitor team away',
        ' GC2 ': 'Percentage of goals conceded in the second half by the local team at home and visitor team away',
        ' 40+ ': 'Percentage of matches in which they scored at least 1 goal in the last 5 minutes of the first half',
        ' 85+ ': 'Percentage of matches in which they scored at least 1 goal in the last 5 minutes of the second half',
        ' H_AVG ': 'Average between percentages of matches won by the local team at home and lost by the visitor team away.',
        ' D_AVG ': 'Average between percentages of matches drawn by the local team at home and drawn by the visitor team away.',
        ' A_AVG ': 'Average between percentages of matches lost by the local team at home and won by the visitor team away.',
        ' 1-0 ': 'Average between percentages of matches that went on 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 1-1 ': 'Average between percentages of matches that went on 1-1 after starting 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 2-0 ': 'Average between percentages of matches that went on 2-0 after starting 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 0-1 ': 'Average between percentages of matches that went on 0-1 allowed by local team at home and scored by the visitor team away.',
        ' 1-1_2 ': 'Average between percentages of matches that went on 1-1 after starting 0-1 allowed by local team at home and scored by visitor team away.',
        ' 0-2 ': 'Average between percentages of matches that went on 0-2 after starting 0-1 allowed by local team at home and scored by visitor team away.',
        ' First ': 'Percentages of matches in which a team scores the first goal, local team at home and visitor team away',
        ' Last ': 'Percentages of matches in which a team scores the last goal, local team at home and visitor team away',
        ' 2+ ': 'Average between percentages of matches that went 2 goals ahead at any moment of the game, scored for local team and allowed for visitor team',
        ' 2- ': 'Average between percentages of matches that went 2 goals down at any moment of the game, conceded for local team and scored for visitor team',
        ' H 1st ': 'Average between percentages of matches won in the first half by the local team at home and lost by the visitor team away.',
        ' D 1st ': 'Average between percentages of matches drawn in the first half by the local team at home and drawn by the visitor team away.',
        ' A 1st ': 'Average between percentages of matches lost in the first half by the local team at home and won by the visitor team away.',
        ' H 2nd ': 'Average between percentages of matches won in the second half by the local team at home and lost by the visitor team away.',
        ' D 2nd ': 'Average between percentages of matches drawn in the second half by the local team at home and drawn by the visitor team away.',
        ' A 2nd ': 'Average between percentages of matches lost in the second half by the local team at home and won by the visitor team away.',
        'Current ranking position': 'Current ranking position',
        ' H/A ': 'Virtual ranking position considering matches played at home by the local team, and matches played away by the visitor team only',
        ' Gap1 ': 'Its the virtual gap between the current ranking and H/A Ranking',
        ' FH ': 'Virtual ranking position considering matches results at the end of the first half',
        ' Gap2 ': 'Its the virtual gap between the current ranking and FH Ranking',
        ' SH ': 'Virtual ranking position considering matches results at the end of the second half',
        ' Gap3 ': 'Its the virtual gap between current ranking and SH Ranking',
        ' Attack ': 'Virtual ranking position considering the higher number of goals scored by a team',
        ' Defense ': 'Virtual ranking position considering the smaller number of goals allowed by a team',
        ' Form ': 'Virtual ranking position considering the points won in the last 6 matches, overall',
        ' H/A form ': 'Virtual ranking position considering the points won in the last 6 matches, at home by local team and away by visitor team ',

        /* modal window - Standing tab */

        ' # ': 'Ranking position',
        ' PM ': 'Played matches',
        ' W ': 'Victories',
        ' D ': 'Draws',
        ' L ': 'Lost',
        ' F ': 'Goals scored',
        ' GA ': 'Goals allowed',
        ' GD ': 'Goal difference',
        ' PW ': 'Points won',



        /* Player Roles tooltips */

        'GK': 'Goalkeeper',
        'DEF': 'Defender',
        'MID': 'Midfielder',
        'FWD': 'Forward',

        'GK': 'Goalkeeper',
        'RB': 'Right fullback',
        'CB': 'Center back',
        'LB': 'Left fullback',
        'DM': 'Defending midfielder',
        'CM': 'Central midfielder',
        'RM': 'Right midfielder',
        'LM': 'Left midfielder',
        'AM': 'Attacking midfielder',
        'LW': 'Left winger',
        'RW': 'Right winger',
        'SS': 'Second striker',
        'CF': 'Central forward',

        /* pre match table - Home */
        /* pre match table - Away */

        'Lineup (pre): ': 'Lineup of the team before the match starts',
        'Lineup (live): ': 'Lineup of the team in play',
        'Used:': 'Amount and percentage of the times that such lineup has been used in the last events',
        'Manual: ': 'Select manually the lineup in case is not available',
        ' S.Role ': 'Specific Roles of the lineup',
        ' M.R ': 'Main roles of the lineup',
        ' Line Up Home ': 'List of the players on the pitch for home team',
        ' Line Up Away ': 'List of the players on the pitch for away team',
        ' Sub ': 'minute of substitution',
        ' Market Value ': 'current price value on market for each player',
        ' P.M.Role ': 'Main role of the player',
        ' Primary_Role ': 'Primary specific role of the player',
        ' Alt.Role1 ': 'Alternative role of the player',
        ' Alt.Role2 ': 'Alternative role of the player',
        ' PreRate ': 'Average index of performance of the player pre-match',
        ' LiveRate ': 'Index of performance of the player inplay, it changes color if a player is playing better (green) or worse (red) than usual',
        ' Titularity % ': "Percentage of the appearances in the current season, beside it there's total events amount",

        /* Home Bench */
        /* Away Bench */

        ' Rating ': 'Average index of performance of the player pre-match',
        ' Goal ': 'Amount of goals scored in the current season by the player, with incisivity percentage',
        ' Assist ': 'Amount of assistance provided by the player in the current season',
        ' S_Role ': 'Primary specific role of the player',

        /* Home Team Rating by unit */
        /* Away Team Rating by unit */

        ' average rate pre ': 'Average rating of each unit pre match',
        ' average rate live ': 'Average rating of each unit in play',
        ' Diff rate pre/live % ': 'Difference between pre match and live rating units',

        /* Home VS Away teams by unit */

        ' Pre ': 'Pre-match rating comparison between teams units',
        ' Live ': 'Inplay rating comparison between teams units',
        ' Diff ': 'Inplay comparison of the differences between pre match and live rating units of the teams',

        /* Total */

        ' On ': 'Shots on target',
        ' Off ': 'Shots off target',
        ' Blk ': 'Shots blocked',
        ' In ': 'Shots inside the penalty area',
        ' Out ': 'Shots outside the penalty area',
        ' Cnr ': 'Corners',
        ' DA ': 'Dangerous attacks',
        ' Poss ': 'Ball possesion',
        ' Red ': 'Red cards',
        ' Yel ': 'Yellow cards',
        ' Sbst ': 'Substitutions',
        ' Ini ': 'Incisivity index, can be negative or positive depending on the past average incisivity',
        ' PFM ': 'Performance index, can be negative or positive depending on the past average performances',
        
        ' Goal ': 'Goals scored',
        ' Rtg ': 'Rating, attack and forcing index',

        /* Other labels */

        ' 1 X 2 ': 'Home, draw or away final time chances, with current odds and values',
        ' O / U ': 'nexts Over and Under chances, with currents odds and values',
        ' Next Goal ': 'Next goal chances for home, away or none',
        ' GB (%) ': 'Chances to have a goal in the nexts time bands',

        /* Modal - historical stats */

        ' Avg Stats Per Game ': 'Average statistics of the matches played',

        ' P-Number ': 'Number of matches played at home for home team, and away for visitor team',        
        ' On ': 'Shots on target',
        ' Off ': 'Shots off target',
        ' Blk ': 'Shots blocked',
        ' In ': 'Shots inside the penalty area',
        ' Out ': 'Shots outside the penalty area',
        ' Cnr ': 'Corners',
        ' DA ': 'Dangerous attacks',
        ' Pos ': 'Ball possesion',
        ' Pas ': 'Passagges',
        ' Acc ': 'Passagges accuracy',
        ' Atk ': 'Total attacks',
        ' Ofs ': 'Offsides',
        ' Sav ': 'Saves by the defense',
        ' Sbst ': 'Substitutions',
        ' Fou ': 'Fouls',
        ' G_att ': 'Goal attempts',
        ' Safe ': 'Ball safe',
        ' Rtg ': 'Rating, attack and forcing index',

        // coldstats filters
        "League filter": "League filter",
        "Leagues": "Leagues",
        "Matches percentage": "Matches percentage",
        "Type to search": "Type to search",
        "All leagues": "All leagues",
        "Prediction filter": "Prediction filter",
        "Time bands filter": "Time bands filter",
        "Score filter": "Score filter",
        "League table filter": "League table filter",
        "Home": "Home",
        "Away": "Away",
        "Home, Away": "Home, Away",
        "Home = Away": "Home = Away",
        "Home OR Away": "Home OR Away",
        "Home AND Away": "Home AND Away",
        "Home > Away": "Home > Away",
        "Home < Away": "Home < Away",
        "Home OR Away > Home OR Away": "Home OR Away > Home OR Away",
        "None": "None",

        "Advanced search": "Advanced search",
        "Search filters": "Search filters",
        "Clear filters": "Clear filters", 

        // log in component
        "subscribe now!": "subscribe now!",
        "Forgot password? Reset here": "Forgot password? Reset here",
        "incorrect password, please try again or reset it": "incorrect password, please try again or reset it",
        "this username does not exist, please try with another one": "this username does not exist, please try with another one",
        "this account has expired, please subscribe from the link below": "this account has expired, please subscribe from the link below",

        // cold stats filter
        'Create preset': 'Create preset',
        'Load preset': 'Load preset',
        'Filter name': 'Filter name',
        'Save Filter': 'Save Filter',
        'Saved filters list': 'Saved filters list',
        'Load Filter': 'Load Filter',
        'Delete Filter': 'Delete Filter',
        'Edit Filter': 'Edit Filter',
        'Update Filter': 'Update Filter',
        "Edit filter name": "Edit filter name",
        "Filtered list": "Filtered list",
        "choose filters": "choose filters",

        "Sorry, no alerts available at the moment, please try later": "Sorry, no alerts available at the moment, please try later",
        "Sorry, no tips available at the moment, please try later": "Sorry, no tips available at the moment, please try later",
        "Post your tip now!": "Post your tip now!",
        'Settings and profile options': 'Settings and profile options',
        "Don't ask more in future": "Don't ask more in future",

        "Time min": "Time min",
        "Time max": "Time max",

        "operational": "operational",

        "home(A), away(B)": "home(A), away(B)",
        "favourite(A), underdog(B)": "favourite(A), underdog(B)",
        "winning(A), losing(B)": "winning(A), losing(B)",

        "sum greater than": "sum greater than",
        "sum minor than": "sum minor than",
        "diff greater than": "diff greater than",
        "diff minor than": "diff minor than",

        "Save to My Game": "Save to My Game",
        "Hide search": "Hide search",
        "Apply filters": "Apply filters",
        "Hide load preset": "Hide load preset",
        "Hide create preset": "Hide create preset",

        "HOW TO RECEIVE ROBOT ALERTS": "HOW TO RECEIVE ROBOT ALERTS",
        "Be sure to follow the next steps using a device which has installed Telegram app. Can be any device: PC, smartphone or anything else.": "Be sure to follow the next steps using a device which has installed Telegram app. Can be any device: PC, smartphone or anything else.",
        "To get your telegram user ID please click on the following link:": "To get your telegram user ID please click on the following link:",
        "Click on 'Send message'. Then write '/start'. You'll see your ID which is composed by 9 numbers.": "Click on 'Send message'. Then write '/start'. You'll see your ID which is composed by 9 numbers.",
        "Copy the ID number and put it in the 'telegram user ID' form above.": "Copy the ID number and put it in the 'telegram user ID' form above.",
        "Then save button below": "Then turn on 'active nofitication' button and  click on the 'Save' button below.",
        "Please click on the link below to access to 'Goal Traders RoBot' and receive alerts from the robots:": "Please click on the link below to access to 'Goal Traders RoBot' and receive alerts from the robots:",
        "Then, click on 'Send message', then write '/start', alerts will come soon as they are available.": "Then, click on 'Send message', then write '/start', alerts will come soon as they are available.",
        "For further help please watch the video in the tutorials area:": "For further help please watch the video in the tutorials area:",
        "You can stop/start to receive notification at any time just turning off/on the button 'active notification' above.": "You can stop/start to receive notification at any time just turning off/on the button 'active notification' above.",
        'Active notification': 'Active notification',

        "home fh": "home fh",
        "draw fh": "draw fh",
        "away fh": "away fh",
        "Second Half Overs %": "Second Half Overs %",
        "0.5 SH": "0.5 SH",
        "1.5 SH": "1.5 SH",
        "2.5 SH": "2.5 SH",
        "1st goal avg min": "1st goal avg min",

        //financial strategy page
        "Back increment %": "Back increment %",
        "Lay increment %": "Lay increment %",
        "min odd": "min odd",
        "max odd": "max odd",
        "tot bets filtered": "tot bets filtered",
        "liability": "liability",
        "payout": "payout",
        "Swap Result": "Swap Result",
        "Without CO": "Without CO",
        "Leverage stake": "Leverage stake",
        "start bankroll": "start bankroll",
        "size %": "size %",
        "Gross profit": "Gross profit",
        "Gross loss": "Gross loss",
        "Profit factor": "Profit factor",
        "DDMAX %": "DDMAX %",
        "Net Profit": "Net Profit",
        "investimento": "investimento",
        "ROI": "ROI",
        "ROE": "ROE",
        "Avg Odd": "Avg Odd",
        "W/Rate": "W/Rate",
        "Single bets list": "Single bets list",
        "tip": "tip",
        "cover": "cover",
        "Post Date": "Post Date",
        "P/L Points": "P/L Points",
        "P/L Leverage stake": "P/L Leverage stake",
        "P/L compounding": "P/L compounding",
        "Lay (Payout)": "Lay (Payout)",
        "Lay (liability)": "Lay (liability)",
        "Prediction": "Prediction",
        "Bet Side": "Bet Side",
        "tip/cover": "tip/cover",
        "Entry min": "Entry min",
        "Cash out": "Cash out",
        "Bet 365 Entry": "Bet 365 Entry",
        "Bet 365 CO Odds": "Bet 365 CO Odds",
        "stake": "stake",
        "Back Odd": "Back Odd",
        "Lay Odd": "Lay Odd",
        "Outcome": "Outcome",
        "Lay Risk": "Lay Risk",
        "Payout": "Payout",
        "liab stake": "liab stake",
        "liab risk": "liab risk",
        "Liability": "Liability",
        "current Bank": "current Bank",
        "stake Back": "stake Back",
        "draw Down": "draw Down",
        "stake Lay": "stake Lay",
        "lay risk": "lay risk",

        //weather report
        "Weather": "Weather",
        "Temperature": "Temperature",
        "Clouds": "Clouds",
        "Humidity": "Humidity",
        "Pressure": "Pressure",
        "Wind": "Wind",
        "Coordidates": "Coordidates",

        "clear sky": "clear sky",
        "few clouds": "few clouds",
        "scattered clouds": "scattered clouds",
        "broken clouds": "broken clouds",
        "shower rain": "shower rain",
        "rain": "rain",
        "thunderstorm": "thunderstorm",
        "snow": "snow",
        "mist": "mist",
        "clouds": "clouds",
        "moderate rain": "moderate rain",
        "haze": "haze",
        "light intensity shower rain": "light intensity shower rain",
        "light rain": "light rain",
        "overcast clouds": "overcast clouds",
        "light intensity drizzle": "light intensity drizzle",
        "fog": "fog",
        "heavy intensity rain": "heavy intensity rain",
        "thunderstorm with light rain": "thunderstorm with light rain",
        "thunderstorm with rain": "thunderstorm with rain",
        "drizzle": "drizzle",
        "heavy intensity drizzle": "heavy intensity drizzle",
        "light intensity drizzle rain": "light intensity drizzle rain",
        "drizzle rain": "drizzle rain",
        "heavy intensity drizzle rain": "heavy intensity drizzle rain",
        "shower rain and drizzle": "shower rain and drizzle",
        "heavy shower rain and drizzle": "heavy shower rain and drizzle",
        "shower drizzle": "shower drizzle",
        "light snow": "light snow",
        "snow": "snow",
        "heavy snow": "heavy snow",
        "sleet":"sleet",
        "light shower sleet": "light shower sleet",
        "shower sleet": "shower sleet",
        "light rain and snow": "light rain and snow",
        "rain and snow": "rain and snow",
        "light shower snow": "light shower snow",
        "shower snow": "shower snow",
        "heavy shower snow": "heavy shower snow",


        "Venue": "Venue",
        "name": "name",
        "surface": "surface", 
        "city": "city",
        "capacity": "capacity",
        "grass": "grass",

        "Home team coach": "Home team coach",
        "Away team coach": "Away team coach",
        "Common name": "Common name",
        "Nationality": "Nationality",

        //money management
        "Save progresses": "Save progresses",
        "Strategy Name": "Strategy Name",
        "Strikes left": "Strikes left",
        "New": "New",
        "Target": "Target",
        "richieste": "Strikes",
        "N. prese": "",
        "Success!": "Success!",
        "Create new money management data succesfully": "Create new money management data succesfully",
        "End": "End",
        "L ": "L",
        "Annulla": "Cancel",
        "Yes": "Yes",
        "No": "No",

        "Team vs Team": "Team vs Team",
        "Season": "Season",
        "Select Season...": "Select Season...",
        "Select League...": "Select League...",
        "Select Home...": "Select Home...",
        "Select Away...": "Select Away...",
        "Please select your teams": "Please select your teams",
        "current season": "current season",
        "last season": "last season",

        'Operations By League': 'Operations By League',
        "Sample": "Sample",
        "avg Odds Bet365": "avg Odds Bet365",
        "avg Entry odds": "avg Entry odds",
        "avg CO odds": "avg CO odds",
        "Entry": "Entry",
        "current": "current",
        "best": "best",
        "worst": "worst",
        "Profits in row": "Profits in row",
        "Losses in row": "Losses in row",
        "Last Bet (W or L)": "Last Bet (W or L)",
        "avg": "avg",
        "trend 1": "trend 1",
        "trend 2": "trend 2",

        //search stats page
        "Search filters": "Search filters",
        "League": "League",
        "Type to search": "Type to search",
        "Press enter to select": "CLick to select",
        "Press enter to remove": "Click to remove",
        "Season": "Season",
        "select season": "select season",
        "Current season": "Current season",
        "Last 2 seasons": "Last 2 seasons",
        "Last 3 seasons": "Last 3 seasons",
        "Last 4 seasons": "Last 4 seasons",
        "Last 5 seasons": "Last 5 seasons",
        "Team": "Team",
        "All teams": "All teams",
        "Selected":"Selected",
        "Role": "Home/Away",
        "Both": "Both",
        "Odds filters": "Odds filters",
        "Over odds": "Over odds",
        "Under odds": "Under odds",
        "Results Filter": "Market Filter",
        "From minute": "From minute",
        "To minute": "To minute",
        "Odd ": "Odd",
        "Even": "Even",
        "Score time Filter": "Score time Filter",
        "Result at 15'": "Result at 15'",
        "Result at 30'": "Result at 30'",
        "Result at HT'": "Result at HT'",
        "Result at 60'": "Result at 60'",
        "Result at 75'": "Result at 75'",
        "Result at FT'": "Result at FT'",
        "Home Score": "Home Score",
        "Away Score": "Away Score",
        "Home Live stats filter": "Home Live stats filter",
        "From": "From minute",
        "To": "To minute",
        "Away Live stats filter": "Away Live stats filter",
        "Get Data": "Get Data",
        "Results": "Results",
        "Sample Size": "Sample Size",
        "View Matches": "View Matches",
        "First Half and Second Half Markets": "First Half and Second Half Markets",
        "First Half Markets": "First Half Markets",
        "Match Odds (Half Time Market)": "Match Odds (Half Time Market)",
        "First Half goals 0.5": "First Half goals 0.5",
        "First Half goals 1.5": "First Half goals 1.5",
        "First Half goals 2.5": "First Half goals 2.5",
        "Probability%": "Probability%",
        "Half Time Score": "Half Time Score",
        "Home win": "Home win",
        "Away Win": "Away Win",
        "AUQ": "AUQ",
        "2nd Half Only": "2nd Half Only",
        "2nd Half Match Odd": "2nd Half Match Odd",
        "Full Match Markets": "Full Match Markets",
        "Full Time Main Markets": "Full Time Main Markets",
        "Main Odds": "Main Odds",
        "Next Goal": "Next Goal",
        "Yes": "Yes",
        "No": "No",
        "Over/Under 0.5": "Over/Under 0.5",
        "Over/Under 1.5": "Over/Under 1.5",
        "Over/Under 2.5": "Over/Under 2.5",
        "Over/Under 3.5": "Over/Under 3.5",
        "Over/Under 4.5": "Over/Under 4.5",
        "Correct Score": "Correct Score",
        "AOHW": "AOHW",
        "AOD": "AOD",
        "AOAW": "AOAW",
        "Stats by Segment Times": "Stats by Segment Times",
        "League stats": "League stats",
        "Filter": "Filter",
        "type string...": "type string...",
        "Avg Odd, ROI by Leagues": "Avg Odd, ROI by Leagues",
        "Avg Odd, ROI by Teams": "Avg Odd, ROI by Teams",
        "Next Games": "Next Games",
        "From date": "From date",
        "To date": "To date",
        "No items": "No items",
        "Chart and stats": "Chart and stats",
        "Market": "Market",
        "Home - FT": "Home - FT",
        "Away - FT": "Away - FT",
        "Draw - FT": "Draw - FT",
        "Home - HT": "Home - HT",
        "Away - HT": "Away - HT",
        "Draw - HT": "Draw - HT",
        "Over - 0.5 - FT": "Over - 0.5 - FT",
        "Over - 1.5 - FT": "Over - 1.5 - FT",
        "Over - 2.5 - FT": "Over - 2.5 - FT",
        "Over - 3.5 - FT": "Over - 3.5 - FT",
        "Under - 0.5 - FT": "Under - 0.5 - FT",
        "Under - 1.5 - FT": "Under - 1.5 - FT",
        "Under - 2.5 - FT": "Under - 2.5 - FT",
        "Under - 3.5 - FT": "Under - 3.5 - FT",
        "Over - 0.5 - HT": "Over - 0.5 - HT",
        "Over - 1.5 - HT": "Over - 1.5 - HT",
        "Under - 0.5 - HT": "Under - 0.5 - HT",
        "Under - 1.5 - HT": "Under - 1.5 - HT",
        "BTS - FT": "BTS - FT",
        "No BTS - FT": "No BTS - FT",
        "Filter": "Filter",
        "Apply": "Apply",
        "Cancel": "Cancel",
        "League table filter": "League table filter",
        "Team table filter": "Team table filter",
        "Total sample": "Total sample",
        "Operations per month": "Operations per month",
        "Avg Odd": "Avg Odd",
        "Profit PTS":"Profit PTS",

        //Historical data

        "Select date": "Select date",
        "from": "from",
        "to": "to",
        "year": "year",
        "month": "month",
        "day": "day",
        "League": "League",
        "select league": "select league",
        "Search": "Search",
        "Reset": "Reset",
        "Team": "Team",
        "Home/Away": "Home/Away",
        "select team": "select team",
        "Event Name": "Event Name",
        "select event": "select event",
        "Market Name": "Market Name",
        "select market": "select market",
        "MATCH_ODDS": "MATCH_ODDS",
        "HALF_TIME": "HALF_TIME",
        "FIRST_HALF_GOALS_05": "FIRST_HALF_GOALS_05",
        "OVER_UNDER_05": "OVER_UNDER_05",
        "OVER_UNDER_15": "OVER_UNDER_15",
        "OVER_UNDER_25": "OVER_UNDER_25",
        "OVER_UNDER_35": "OVER_UNDER_35",
        "event Name": "event Name",
        "event Id": "event Id",
        "Market Id": "Market Id",
        "Market Type": "Market Type",
        "League": "League",
        "Market Info": "Market Info",
        "Home": "Home",
        "Away": "Away",
        "Draw": "Draw",
        "Runner Id": "Runner Id",
        "Status": "Status",
        "InPlay": "InPlay",
        "Time": "Time",
        "Price": "Price",
        "OPEN": "OPEN",
        "SUSPENDED": "SUSPENDED",
        "false": "false",
        "true": "true",
        "Prematch": "Prematch",
        "First Half": "First Half",
        "Interval": "Interval",
        "Second Half": "Second Half",

        "Comparison filter Home/Away": "Comparison filter Home/Away",
        "Clear fields": "Clear fields",
        "Filter updated successfully": "Filter updated successfully",
        'Show firsts': 'Show firsts',

        "Investments": "Investments",

        //investments page
        "Favorite": "Favorite",
        "today": "today",
        "tomorrow": "tomorrow",
        'Competition ': 'Competition',
        "Time ": "Time",
        "event": "event",
        "Stats Last 10 Chance": "Stats Last 10 Chance",
        "Fav Label Best Bet": "Favourite Pts & Bet",
        "fav Label": "fav Label",
        "Match Odds": "Match Odds",

        "Fixture": "Fixture",
        "Home Back": "Home Back",
        "Home Lay": "Home Lay",
        "Draw Back": "Draw Back",
        "Draw Lay": "Draw Lay",
        "Away Back": "Away Back",  
        "Away Lay": "Away Lay",   
        
        //wrong to adjust the original labels -->> 
        "Bookie Pts and ROI": "Bookie Pts and ROI",
        "lay price is calculated by adding 3% onto back price":  "lay price is calculated by adding 3% onto back price",
        //end adjustments
        
        'Averages for League and Last 20, 10, 5 matches': 'Averages for League and Last 20, 10, 5 matches',
        "League Averages": "League Averages",
        "Team Favorite (Based on start odds)": "Team Favorite (Based on start odds)",
        "Implied Odds": "Implied Odds",
        "home": "home",
        "away": "away",
        "Chance": "Chance",
        "Last 20 matches - Long Term": "Last 20 matches - Long Term",
        "Last 10 matches - Medium Term:": "Last 10 matches - Medium Term",
        "Last 5 matches - Short Term": "Last 5 matches - Short Term",

        "LayHome": "LayHome",
        "LayAway": "LayAway",
        "BackHome": "BackHome",
        "BackAway": "BackAway",
        "LayDraw": "LayDraw",
        "BackDraw": "BackDraw",
    },

    'it': {
        // investments main
        "Equilibrata": "Equilibrata",
        "Ospite_med_fav": "Ospite_med_fav",
        "Ospite_min_fav": "Ospite_min_fav",
        "Casa_med_fav": "Casa_med_fav",
        "Casa_min_fav": "Casa_min_fav",
        "Ospite_max_fav": "Ospite_max_fav",
        "Casa_max_fav":"Casa_max_fav",

        "Sort By League": "per competizione",
        "Sort By Time": "per orario",
        "Data saved successfully": "Incontri aggiunti con successo!",
        "Time ": "per orario",
        "Cancel ": "Cancella",
        "Add ": "Inizio",
        "Operation by All leagues": "Operazioni per campionati totali",
        "Operation by single leagues": "Operazioni per campionati singoli",
        "no strategy tips": "tips senza strategia",
        'Match': 'Match',
        'Select Match': 'Seleziona Match',
        'Coming Up': 'in arrivo',
        'Competition': 'Competizione',
        'Open': 'Apri', 
        'Responsibility': 'responsabilità',
        'Lay X': 'Banca X',
        'Back X': 'Punta X',
        'Lay 1': 'Banca 1',
        'Lay 2': 'Banca 2',
        'Back Over 0.5': 'Over 0.5',
        'Back Over 1.5': 'Over 1.5',
        'Back Over 2.5': 'Over 2.5',
        'Back Under 2.5': 'Under 2.5',
        'Back Under 3.5': 'Under 3.5',
        'Alert Stats FT': 'Statistiche Segnali FT',
        'Select CS': 'Inserisci RE',
        'Save Data': 'Salva Dati',
        'Delete Data': 'Cancella Dati',
        coming_up_main: 'in arrivo',

       
        // 'General Filters': 'Filtri Generali',
        'Odd Filters': 'Filtri quote',
        'Odds': 'Quote',
        'Total Live Stats': 'Statistiche Live Totali',
        'Last 10 minutes Live Stats': 'Statistiche ultimi 10 min.',
        'atk chart': 'atk chart',
        'Cancel': 'Cancella',
        'Select': 'Inserisci',
        'Enter the Odd': 'Inserisci quota',
        'Enter the Stake': 'Inserisci stake',
        'pre-match Odd': 'Quota prepartita',
        'Responsability': 'Responsabilità',
        'Bookmaker': 'Bookmaker',
        'Correct Score': 'Risultato Esatto',
        'Enter CS Odd': 'Inserisci quota RE',
        'Enter CS Stake': 'Inserisci stake RE',
        'Stake to cover': 'stake copertura',
        'CS Odds': 'Quota RE',
        'Back': 'Punta', 
        'Lay': 'Banca',
        'Total Matched': 'Totali Abbinate',
        'Select Risk Trading': 'Seleziona Rischio Trading',
        'Easy': 'Basso',
        'Medium': 'Medio',
        'Risky': 'Alto',
        'Select Strategy': 'Seleziona Strategia',
        'Alerts': 'Segnali',
        'Events': 'Eventi',
        'Odd': 'Quota',
        'Min': 'Min',
        'Score': 'Punteggio',
        'Strategy': 'Strategia',
        'C': 'C',
        'Messages': 'Messaggi',
        'Cash out bar': 'Barra Cash out',
        'Insert Odd and Stake': 'Inserire Quota e Stake',
        'Max profit': 'Profitto massimo',
        'Current Profit': 'Profitto attuale',
        'Correct Score bar': 'Barra Risultato Esatto',
        'Insert CS Odd and Stake': 'Inserire Quota e Stake RE',
        'Equalization Bar': 'Barra equalizzazione',
        'cold stats': 'Statistiche prematch',
        'CLICK HERE TO LOAD COLD STATS': 'CLICCA QUA PER CARICARE LE STATISTICHE',
        'team analysis': 'Analisi Squadre',
        'CLICK HERE TO LOAD TEAM ANALYSIS DATA.': "CLICCA QUA PER CARICARE L'ANALISI SQUADRE.",

        /* === homepage ===*/
        'Welcome to Goal Traders by Sospeso!': 'Benvenuto in Goal Traders by Sospeso!',
        'Welcome!': 'Benvenuto!',
        'How to start ?': 'Da dove cominciare ?',
        'It is important to start with the right foot: for a better trading experience have a look on user’s video tutorial.': "È importante iniziare con il piede giusto: per una miglior esperienza di trading segui i video tutorials.",
        'Click here': 'Clicca qua',
        'What’s new ?': "Cosa c'è di nuovo",
        'The best platform tool for sport trading is here! Goal Traders by Sospeso is always updated to give you the best that you can have. We will let you know here if some updating is coming soon…': "La migliore piattaforma di statistiche per lo sport trading online è arrivata! Goal Traders by Sospeso è sempre in aggiornamento per darti i migliori strumenti che puoi avere. Tieni d'occhio questa sezione per sapere le prossime novità...",
        'Let’s keep in touch': 'Restiamo in contatto',
        'For every support that you need you can contact us to:': 'Per qualsiasi cosa tu abbia bisogno mandaci una mail a:',
        'supporto.info@nicoladefontetipster.com': 'supporto.info@nicoladefontetipster.com',
        'Our social channels': 'I nostri canali social',

        /* === feedpage ===*/
        'Refresh': 'Aggiorna',
        /* Posts */
        'Posted': 'Postato',
        'Public': 'Public',
        'Private': 'Private',
        'Tips': 'Segnale:',
        'Odd': 'Quota:',
        'Stake pts': 'Stake pts',
        'Strategy': 'Strategia',
        'Cash out details': 'Cash Out info',
        'Tip Cash Out': 'Tip Cashed out',
        'Cover Cash Out': 'Cover Cashed out',
        'Current profit': 'Profitto attuale',
        'Note': 'Note',
        'write here your comment': 'scrivi qua il tuo commento',
        'Post Comment': 'invia commento',
        'PTS (total)': 'PTS (totali)',
        /* Tooltips Buttons */
        'Like this tip': 'Mi piace questo segnale',
        'You already liked this tip': 'Questo segnale ti piace già',
        'Follow this tip': 'Segui questo segnale',
        'You already followed this tip': 'Stai già seguendo questo segnale',
        'Follow this tipster': 'Segui questo tipster',
        'You already followed this tipster': 'Stai già seguendo questo tipster tipster',
        /* Auto */
        'Auto': 'Auto',
        'Auto cash out (TIP)': 'Auto cashout (TIP)',
        'Auto cash out (COVER)': 'Auto cashout (COVER)',
        'profit pts': 'profit pts',
        'profit %': 'profit %',
        'stop loss %': 'stop loss %',
        'next odd (higher than)': 'prossima quota (maggiore di)',
        'next odd (lower than)': 'prossima quota (minore di)',
        'minute': 'minuto',
        'score': 'risultato',
        'attempt to accept (Max:10)': 'tentativi cashout (Max:10)',
        'OK': 'OK',
        'Cancel': 'Cancella',
        'Clean': 'Pulisci',

        /* === userpage === */
        'Filter': 'Filtra',
        'type string': 'ricerca...',
        'User': 'User',
        'Total Tips': 'Tips totali',
        'Pending Tips': 'Tips pendenti',
        'ROI%': 'Roi %',
        'Profit pts': 'Profit pts',
        'W/Rate': 'W/Rate',
        'Followers': 'Followers',
        'Follow': 'Segui',

        /* === top bar menu === */
        /* Bell menu */
        'Notifications': 'Notifiche',
        'Updates': 'Updates',
        'Messages': 'Messaggi',
        'Settled Tips': 'Tips definite',
        'Comments': 'Commenti',
        /* User menu */
        'My Tips and Stats': 'My Tips and Stats',
        'Settings': 'Settaggi',
        'Profile': 'Profilo',        
        'Payments': 'Pagamenti',
        'Logout': 'Disconnetti',

        /* === usersetting === */
        'Default Bf com': 'Commissione Betfair di default',
        'Goal sound': 'suono Goal',
        'New alert sound': 'suono Segnali',
        'Currency': 'Moneta',
        'Language': 'Lingua',
        'Timezone': 'Fuso orario',
        'Update': 'Aggiorna',

        /* === post a tip === */
        'Date': 'Data',
        'Country': 'Paese',
        'League': 'Lega',
        'Event': 'Evento',
        'Prediction type available': 'Segni disponibili',
        'Status': 'Stato',
        'Score': 'Score',
        'Odd': 'Quota',
        'Stake': 'Stake',
        'Visibility': 'Visibilità',
        'Add to Strategy': 'Aggiungi strategia',
        'Note': 'Note',
        'Last Updated': 'Ultimo aggiornamento',
        'Reset': 'Pulisci',
        'Post tip': 'Post Tip',
        /* Date input fields */
        'select...': ' seleziona...',
        'Today': 'Oggi',
        'Tomorrow': 'Domani',
        'Live Events': 'Eventi in live',
        'Private': 'Tip Privata',
        'Public': 'Tip Pubblica',

        /* === usertipPost === */
        'Tips': 'Tips',
        'Profit PTs': 'Profit PTs',
        'ROI %': 'ROI %',
        'W/Rate': 'W/Rate',
        'Followers': 'Followers',
        'My tips': 'My tips',
        'Strategies': 'Strategie',
        'Stats': 'Statistiche',
        'Options': 'Opzioni',
        'Pending Tips': 'Tips Pendenti',
        'Settled Tips': 'Tips Concluse',
        'Create a strategy': 'Crea una strategia',
        'Name': ' Nome',
        'Description': 'Descrizione',
        'e.g.strategy 43': 'esempio: strategia numero 43',
        'e.g.This strategy is for testing over 2.5 at half time when the home team is leadig at half time': 'esempio: questa strategia è per testare gli over 2.5 al primo tempo, etc...',
        'Create': 'Crea',
        'Strategy list': 'Lista strategie',
        'Filter': 'Filtra',
        'type string': 'scrivi',
        'Stats': 'Statistiche',
        'Details': 'Dettagli',
        'Delete': 'Elimina',
        'Strategy name': 'Nome Strategia',
        'Stats': 'Statistiche',
        'Stats by league': 'Statistiche per campionato',
        'Reset details': 'Dettagli Reset',
        'Reset Count': 'Numero Reset fatti',
        'Reset stat': ' Reset statistiche',

        /* === league stats === */
        'League': 'Campionato',
        'Match Result %': 'Risultato incontro %',
        'Average Goals': 'Media Goal',
        'Fist Half Overs %': 'Over primo tempo %',
        'Full Match Overs %': 'Over fine incontro %',
        'Goal Bands [% of matches with at least one goal in time period': 'Goal Intervalli [% di incontri con almeno un goal per ciascun intervallo]',
        'First To Score': 'Primo a segnare',
        'Country': 'Nazione',
        'League': 'Campionato',
        'Tier': 'Fascia',
        'Matches': 'Incontri',
        'home': 'home',
        'draw': 'pareggio',
        'away': 'fuori',
        'Total': 'Totali',
        '0.5 FH': '0.5 PT',
        '1.5 FH': '1.5 PT',
        '2.5 FH': '2.5 PT',
        'Bts': 'Bts',
        'H Win': 'H Win',
        'League Data by Start Price': 'Dati campionati per quote iniziali',
        'H_StrongFav': ' Casa_max_fav',
        'H_MediumFav': ' Casa_med_fav',
        'H_SmallFav': ' Casa_min_fav',
        'SuperCompetative': 'Equilibrata',
        'A_StrongFav': ' A_StrongFav',
        'A_MediumFav': ' A_MediumFav',
        'A_SmallFav': ' A_SmallFav',
        '15 minutes': '15 minuti',
        '30 minutes': '30 minuti',
        '45 minutes': '45 minuti',
        '60 minutes': '60 minuti',
        '75 minutes': '75 minuti',
        'all': 'all',
        'scorelines that lead to more goals': 'Risultati al primo tempo con goal successivi',
        'Shots on Target to Goal Averages': 'Tiri in porta e media goal ',
        'Goal+ Home': 'Goal+ Casa',
        'Goal+ Away': 'Goal+ Fuori',
        'Shot On Target': 'Tiri in porta',
        'Goal Avg': 'Media Goal',
        'Fixture': 'Incontri',
        'Date': 'Data',
        'Label': 'Tipo',
        'Odds': 'Quote',
        'Goal Times': 'Goal Times',
        'Red': 'Rosso',
        'Cards?': 'Cartellino?',
        'BTTS': 'BTTS',
        'Results': 'Risultati',
        'HT': 'PT',
        'FT': 'RF',
        'Home': 'Home',
        'Draw': 'Pareggio',
        'Away': 'Fuori',
        'Y': 'S',
        'N': 'N',

        /* === membership page === */
        'This page is not allowed for your current membership plan.': 'Questa pagina non è ccessibile con il tuo abbonamento attuale',
        'Please upgrade your plan': 'Passa ad un piano superiore da ',
        'here': 'qui',
        'or contact the administrator': " o contatta l'amministratore",
        'Upgrade plan': 'Upgrade abbonamento',

        /* === money management page === */
        'Create money management': 'Aggiungi money management',
        'Insert a name': 'Nome',
        'Starting Bank': 'Banca iniziale',
        'Target profit': 'Target profit',
        'Stop Losses': 'Stop loss',
        'Currency': 'Moneta',
        'Management name': 'Nome money management',
        'Add': 'Crea',
        'Money manangement list': 'Lista Money manangement',
        'Name': 'Nome',
        'Starting Bank(€)': 'Banca iniziale',
        'Target Profit(%)': 'Target Profit(%)',
        'Stop Loss(%)': 'Stop Loss(%)',
        'P / L %': 'P / L %',
        'Actions': 'Azioni',
        'View': 'Dettagli',
        'Delete': 'Cancella',
        // detal
        'Money management detail': 'Nome Money management',
        'Detail': 'Dettagli',
        'moneyDetail': 'Dettagli',
        'Starting Bank': 'Banca iniziale',
        'Target Profit': 'Target Profit',
        'Today in profits': 'Profitti oggi',
        'Daily stop losses': 'Stop loss giorn.',
        'Today losses': 'Perdite oggi',
        'Current bank': 'Banca attuale',
        'Profit / Losses': 'Profitti / Perdite',
        'Trades in profits': 'Trades in profitto',
        'Best profit': 'Max profitto',
        'Trades losses': 'Trades in perdita',
        'Worse loss': 'Max perdita',
        'Today in profits': 'Profitti oggi',
        'Today losses': 'Perdite oggi',
        'round stake values 0,50 multiple': 'arrotonda le puntate per multipli di 0,50',
        'Index': 'n°',
        'Events': 'Eventi',
        'Date': 'Data',
        'Current Bank': 'Banca attuale',
        'Stake (points)': 'Stake (points)',
        'Back/Lay': 'Punta / Banca',
        'Odd': 'Quota',
        'Stake': 'Stake',
        'Profit': 'Profitto',
        'Risk': 'Rischio',
        'Real Profit': 'Profitto reale',
        'Balance': 'Bilancio',
        'Edit': 'Mod.',
        'Back': 'Punta',
        'Lay': 'Banca',

        /* === league table === */
        'Please select...': 'seleziona...',
        'Full': 'Tutto',
        'Home - Away': 'Casa - Fuori',
        'First Half': 'Primo tempo',
        'Second Half': 'Secondo tempo',
        'Form - Overall': 'Forma - totale',
        'Form - 3 Matches': 'Forma - 3 incontri',
        'Form - 6 Matches': 'Forma - 6 incontri',
        'Home Attack v Away Defence': 'Attacco Casa v Difesa Fuori',
        'Home Defence v Away Attack': 'Difesa Casa v Attacco Fuori',
        'Team': 'Squadra',
        'Home Attack': 'Attacco casa',
        'Away Attack': 'Attacco fuori',
        'Away Defence': 'Difesa fuori',
        'Home Defence': 'Difesa casa',
        'Points': 'Punti',

        /* === coldstats === */
        'Search fixtures for today': ' cerca incontri per oggi ',
        'Search fixtures for tomorrow': ' cerca incontri per domani ',
        'Search fixtures for ': ' cerca incontri per ',
        'Monday': 'lunedì ',
        'Tuesday': 'martedì ',
        'Wednesday': 'mercoledì ',
        'Thursday': 'giovedì ',
        'Fryday': 'venerdì ',
        'Saturday': 'sabato ',
        'Sunday': 'domenica ',
        'Competition': 'per competizione',
        'Time': 'per orario',
        'Team': 'Squadra',
        'H': 'C',
        'A': 'T',
        'Scored': 'Fatti',
        'Conc.': 'Conces.',
        'Average': 'Media',
        'Filters': 'Filtri',
        'Red Card': 'Espulsioni',
        'FH': 'PT',
        'SH': 'ST',
        'Show last': 'Mostra ultimi',
        'ALL': 'Tutti',
        'days': 'giornate',
        'Home Lineup': 'Formaz Casa',
        'All': 'Tutti',
        'Away Lineup': 'Formaz Trasf',
        
        'HomeTeam': 'Casa',
        'AwayTeam': 'Trasferta',
        'vs All': 'vs Tutti',
        'vs High rank': 'vs alta class',
        'vs middle-high rank': 'vs medio-alta class',
        'vs middle-low rank': 'vs medio-bassa class',
        'vs low rank': 'vs bassa class',
        'FH goals Scored:': 'PT goals segnati:',
        'home': 'home',
        'away': 'trasferta',
        'probability': 'probabilità',
        'SH goals Scored:': 'ST goals segnati:',
        'D': 'P',
        'First': 'Primo',
        'Last': 'Ultimo',
        'H 1st': 'C 1t',
        'D 1st': 'P 1t',
        'A 1st': 'T 1t',
        'H 2nd': 'C 2t',
        'D 2nd': 'P 2t',
        'A 2nd': 'T 2t',
        'Total': 'Totali',
        'Pos': 'Pos',
        'H/A': 'C/T',
        'Swing': 'Gap',
        'FH': 'PT',
        'SH': 'ST',
        'Attack': 'Attacco',
        'Defense': 'Difesa',
        'Form': 'Forma',
        'H/A Form': 'C/T forma',

        /* Modal elements */

        'Details': 'Dettagli',
        'Home': 'Home',
        'Away': 'Trasf.',
        'FH': 'PT',
        'FT': 'FT',
        'Full Score Table': 'Risultati FT',
        'Standings': 'Classifiche',
        'P': 'G',
        'W': 'V',
        'D': 'P',
        'L': 'S',
        'F': 'F',
        // 'A': 'C',
        'GD': 'DR',
        

        /* === valuestats === */

        'matches': 'incontri',        
        'BTS': 'BTS',
        '1 year': '1 anno',
        '3 years': '3 anni',
        '10 years': '10 anni',
        'Bet365 odds': 'Quote Bet365 ',
        'Betfair prices': 'Quote Betfair ',
        'Recent form': 'Stato di forma',        

        /* Tool Tip */
        'True Odd': 'Quota reale',
        'Stat': 'Stat',


        /* === profile === */
        'Username': 'Nome utente',
        'Select Avatar': 'Immagine profilo',
        'Alias': 'Nome pubblico',
        'Save changes': 'Salva',        
        /* Avatar modal window */
        'Select avatar': 'Immagine profilo',
        'Save': 'Salva',

        /* === nav dashboard === */
        'General Filters': 'Filtri generali',
        'Cup': 'Coppe',
        'Back': 'Punta',
        'Lay': 'Banca',
        'Double Tips': 'Doppi segni',
        'Odd Filters': 'Filtri quote',
        'Matched Filters': 'Filtri abbinate',
        'Commissions': 'Commissioni',
        'Add all events': 'Aggiungi tutti',
        'Clear': 'Pulisci',
        'Clear ended events': 'Pulisci eventi chiusi',

        /* Table Labels*/

        'Match': 'Eventi',
        'Tot. matched': 'Tot.abbinate',
        'Pre Odd': 'Quota pre',
        'Odd': 'Quota',
        'Back': 'Punta',
        'Lay': 'Banca',
        'Status': 'Stato',
        'Minute': 'Minuto',
        'Score': 'Score',
        'Gain/Losses': 'Profitti',

        /* Table inside fields */

        'Back': 'Punta',
        'Lay': 'Banca',
        'Closed': 'Chiuso',
        "Close": "Chiudi",
        'Live': 'Live',
        'Suspended': 'Sospeso',
        'Coming up': 'non iniziato',
        'CLOSED': 'CHIUSO',
        'SUSPENDED': 'SOSPESO',
        'NS': 'non iniziato -',

        /* livestats === */
        'Scheduled Games': 'Prossimi eventi',
        'LIVE Games': 'LIVE Games',
        'Finished Games': 'Eventi conclusi',
        'My Games': 'My Games',
        'Result': 'Score',
        'Total Game': 'Totali',
        'Last 10 minutes': 'Ultimi 10 minuti',
        'Odds': 'Quote',
        'Next goal': 'Prossimo goal',
        'Next Goal': 'Pross. Goal',
        'Matches': 'campione',
        'Last Updated': 'Ultimo aggiorn',

        /* modal window */        
        'Historical Stats': 'Storico statistiche Live',
        'Avg Stats Per Game': 'Media per gioco',
        'Chart': 'Grafico',
        'Odds': 'Quote',

        /* === navbar === */
        'Auto Tip/Cash': 'Auto Tip/Cash',
        'Dashboard': 'Dashboard',
        'Sospeso': 'Sospeso',
        'Live stats': 'Live stats',
        'Admin settings': 'Opzioni admin',
        'Cold Stats': 'Statistiche prematch',
        'Cold Stats1': 'Statistiche prematch',
        'Search stats': 'Ricerca Stats',
        'Team Analysis': 'Analisi Squadre',
        'Today': 'Oggi',
        'Money Manage': 'Gestione cassa',
        'Page Settings': 'Opzioni pagine',
        'User List': 'Lista utenti',
        'User List Page': 'Lista utenti',
        'Main': 'Sospeso WEB',
        'liveStatsNew': 'Live stats',
        'Live Stats Analysis 1': 'Ricerca Stats',
        'AdminView': 'Opzioni admin',
        'Page Setting': 'Opzioni pagine',
        'Feed Page': 'Segnali',

        'League Table': 'League tables',
        'Value stats data': 'Value bets',
        'Live Stats Analysis': 'Live Stats Analysis',
        'Historic Data': 'Storico quote',
        'Nav Dashboard': 'Sospeso Dashboard',
        'League Stats': 'Statistiche di Lega', 

        ' H ': 'Squadra casa',
        ' A ': 'Squadra ospite',
        ' P ': "Numero d'incontri giocati dalla squadra di casa in casa e dalla squadra ospite in trasferta",
        ' 0 - 0 ': "Percentuale d'incontri finiti sul risultato di 0-0 per la squadra di casa in casa e per la squadra ospite in trasferta",
        ' Ov. 1.5 ': "Percentuale d'incontri finiti Over 1.5 per la squadra di casa in casa e per la squadra ospite in trasferta",
        ' Ov. 2.5 ': "Percentuale d'incontri finiti Over 2.5 per la squadra di casa in casa e per la squadra ospite in trasferta",
        ' Ov. 3.5 ': "Percentuale d'incontri finiti Over 3.5 per la squadra di casa in casa e per la squadra ospite in trasferta",
        ' Scored ': "Percentuale d'incontri in cui la squadra ha segnato almeno un goal, la squadra di casa in casa e la squadra ospite in trasferta",
        ' Conc ': "Percentuale d'incontri in cui la squadra ha concesso almeno un goal, la squadra di casa in casa e la squadra ospite in trasferta",
        ' BTS ': "Percentuale d'incontri in cui le squadre hanno segnato entrambe, la squadra di casa in casa e la squadra ospite in trasferta",
        ' 1 + 1st ': "Percentuale d'incontri con almeno 1 goal nel primo tempo, la squadra di casa in casa e la squadra ospite in trasferta",
        ' 2 + 1st ': "Percentuale d'incontri con almeno 2 goal nel primo tempo, la squadra di casa in casa e la squadra ospite in trasferta",
        ' 1 + 2st ': "Percentuale d'incontri con almeno 1 goal nel secondo tempo, la squadra di casa in casa e la squadra ospite in trasferta",
        ' 2 + 2st ': "Percentuale d'incontri con almeno 2 goal nel secondo tempo, la squadra di casa in casa e la squadra ospite in trasferta",
        ' Red card ': 'Filtra gli incontri con almeno un cartellino, nel primo o nel secondo tempo o in entrambi i tempi',
        ' Show last ': 'Mostra gli ultimi incontri giocati',
        ' Home lineup ': 'Mostra gli incontri giocati dalla squadra di casa che utilizza una formazione specifica',
        ' Away lineup ': 'Mostra gli incontri giocati dalla squadra ospite che utilizza una formazione specifica',
        ' Home team ': 'Mostra gli incontri giocati dalla squadra di casa contro la squadra ospite di una specifica zona di classifica',
        ' Away team ': 'Mostra gli incontri giocati dalla squadra ospite contro la squadra di casa di una specifica zona di classifica',

        ' G+ ': 'Numero di goal segnati dalla squadra di casa in casa e dalla squadra ospite in trasferta',
        ' G- ': 'Numero di goal subiti dalla squadra di casa in casa e dalla squadra ospite in trasferta',
        ' 0 - 15 ': 'Percentuale di eventi con goals segnati e subiti per segmenti di tempo dalla squadra di casa in casa e dalla squadra ospite in trasferta',
        ' 16 - 30 ': 'Percentuale di eventi con goals segnati e subiti per segmenti di tempo dalla squadra di casa in casa e dalla squadra ospite in trasferta',
        ' 31 - 45 ': 'Percentuale di eventi con goals segnati e subiti per segmenti di tempo dalla squadra di casa in casa e dalla squadra ospite in trasferta',
        ' 46 - 60 ': 'Percentuale di eventi con goals segnati e subiti per segmenti di tempo dalla squadra di casa in casa e dalla squadra ospite in trasferta',
        ' 61 - 75 ': 'Percentuale di eventi con goals segnati e subiti per segmenti di tempo dalla squadra di casa in casa e dalla squadra ospite in trasferta',
        ' 76 - 90 ': 'Percentuale di eventi con goals segnati e subiti per segmenti di tempo dalla squadra di casa in casa e dalla squadra ospite in trasferta',
        ' GS1 ': 'Percentuale di goal segnati nel primo tempo dalla squadra di casa in casa e dalla squadra ospite in trasferta',
        ' GS2 ': 'Percentuale di goal segnati nel secondo tempo dalla squadra di casa in casa e dalla squadra ospite in trasferta',
        ' GC1 ': 'Percentuale di goal subiti nel primo tempo dalla squadra di casa in casa e dalla squadra ospite in trasferta',
        ' GC2 ': 'Percentuale di goal subiti nel secondo tempo dalla squadra di casa in casa e dalla squadra ospite in trasferta',
        ' 40+ ': 'Percentuale di inconttri in cui viene segnato almeno 1 goal negli ultimi 5 minuti del primo tempo',
        ' 85+ ': 'Percentuale di inconttri in cui viene segnato almeno 1 goal negli ultimi 5 minuti del secondo tempo',
        ' H_AVG ': 'Media delle percentuali degli incontri vinti dalla squadra di casa in casa e persi dalla squadra ospite in traserta',
        ' D_AVG ': 'Media delle percentuali degli incontri pareggiati dalla squadra di casa in casa e pareggiati dalla squadra ospite in traserta',
        ' A_AVG ': 'Media delle percentuali degli incontri persi dalla squadra di casa in casa e vinti dalla squadra ospite in traserta',
        ' 1-0 ': "Media delle percentuali degli incontri che iniziano sull' 1-0 segnato dalla squadra di casa in casa e subito dalla squadra ospite in trasferta.",
        ' 1-1 ': "Media delle percentuali degli incontri che si portaano sull' 1-1 dopo l' 1-0 segnato dalla squadra di casa in casa e subito dalla squadra ospite in trasferta",
        ' 2-0 ': "Media delle percentuali degli incontri che si portaano sull' 2-0 dopo l' 1-0 segnato dalla squadra di casa in casa e subito dalla squadra ospite in trasferta",
        ' 0-1 ': "Media delle percentuali degli incontri che iniziano sullo 0-1 subito dalla squadra di casa in casa e segnato dalla squadra ospite in trasferta.",
        ' 1-1_2 ': "Media delle percentuali degli incontri che si portaano sull' 1-1 dopo lo 0-1 subito dalla squadra di casa in casa e segnato dalla squadra ospite in trasferta",
        ' 0-2 ': "Media delle percentuali degli incontri che si portaano sullo 0-2 dopo lo 0-1 subito dalla squadra di casa in casa e segnato dalla squadra ospite in trasferta",
        ' First ': "Percentuale d'incontri in cui la squadra segna per prima, la squadra di casa in casa e la squadra ospite in trasferta",
        ' Last ': "Percentuale d'incontri in cui la squadra segna per ultima, la squadra di casa in casa e la squadra ospite in trasferta",
        ' 2+ ': 'Media delle percentuali degli incontri in cui la squadra si porta 2 goals avanti in qualunque momento della partita, la squadra di casa in casa e la squadra ospite in trasferta',
        ' 2- ': 'Media delle percentuali degli incontri in cui la squadra va sotto di 2 goals in qualunque momento della partita, la squadra di casa in casa e la squadra ospite in trasferta',
        ' H 1st ': 'Media delle percentuali degli incontri vinti nel primo tempo dalla squadra di casa in casa e persi dalla squadra ospite in traserta',
        ' D 1st ': 'Media delle percentuali degli incontri pareggiati nel primo tempo dalla squadra di casa in casa e pareggiati dalla squadra ospite in traserta',
        ' A 1st ': 'Media delle percentuali degli incontri persi nel primo tempo dalla squadra di casa in casa e vinti dalla squadra ospite in traserta',
        ' H 2nd ': "Media delle percentuali degli incontri vinti nel secondo tempo dalla squadra di casa in casa e persi dalla squadra ospite in traserta'.",
        ' D 2nd ': 'Media delle percentuali degli incontri pareggiati nel secondo tempo dalla squadra di casa in casa e pareggiati dalla squadra ospite in traserta',
        ' A 2nd ': 'Media delle percentuali degli incontri persi nel secondo tempo dalla squadra di casa in casa e vinti dalla squadra ospite in traserta',
        'Current ranking position': 'Posizione in classifica attuale',
        ' H/A ': 'Posizione virtuale di classifica fatta in base agli incontri disputati in casa dalla squadra di casa, e gli incontri disputati in trasferta per la squadra ospite',
        ' Gap1 ': 'è la differenza virtuale tra la posizione in classifica attuale e la posizione in classifica casa/trasferta',
        ' FH ': 'Posizione virtuale di classifica in base ai risultati del primo tempo',
        ' Gap2 ': 'è la differenza virtuale tra la posizione in classifica attuale e la posizione in classifica in base ai risultati a fine primo tempo',
        ' SH ': 'Posizione virtuale di classifica in base ai risultati del secondo tempo',
        ' Gap3 ': 'è la differenza virtuale tra la posizione in classifica attuale e la posizione in classifica in base ai risultati a fine secondo tempo',
        ' Attack ': 'Posizione virtuale di classifica in base al maggior numero di goal segnati',
        ' Defense ': 'Posizione virtuale di classifica in base al minor numero di goal subiti',
        ' Form ': 'Posizione virtuale di classifica in base ai punti vinti nelle ultime 6 partite in totale',
        ' H/A form ': 'Posizione virtuale di classifica in base ai punti vinti nelle ultime 6 partite, in casa dalla squadra di casa ed in trasferta dalla squadra ospite',

        /* modal window - Standings tab */

        ' # ': 'Posizione in classifica',
        ' PM ': 'Partite disputate',
        ' W ': 'Vittorie',
        ' D ': 'Pareggi',
        ' L ': 'Sconfitte',
        ' F ': 'Goal fatti',
        ' GA ': 'Goal subiti',
        ' GD ': 'Differenza reti',
        ' PW ': 'Punti vinti',

        /* Player Roles tooltips */

        'GK': 'Portiere',
        'DEF': 'Difensore',
        'MID': 'Centrocampista',
        'FWD': 'Attaccante',

        'GK': 'Portiere',
        'RB': 'Terzino destro',
        'CB': 'Centrale difensivo',
        'LB': 'Terzino sinistro',
        'DM': 'Centrocampista difensivo',
        'CM': 'Centrocampista centrale',
        'RM': 'Centrocampista di destra',
        'LM': 'Centroampista di sinistra',
        'AM': 'Trequartista',
        'LW': "Ala sinistra d'attacco",
        'RW': "Ala destra d'attacco",
        'SS': 'Seconda punta',
        'CF': 'Attaccante centrale',
        

        /* pre match table - Home */
        /* pre match table - Away */

        'Lineup (pre): ': "Modulo di gioco della squadra prima dell'inizio dell'incontro",
        'Lineup (live): ': "Modulo di gioco della squadra durante l'incontro",
        'Used:': 'Numero e percentuale delle volte che il Modulo di gioco è stato usato nei precedenti incontri della stagione',
        'Manual: ': 'Selezionare manualmente il modulo di gioco in caso non sia disponibile',
        ' S.Role ': 'Ruoli specifici del modulo di gioco ',
        ' M.R ': 'Ruoli generali del modulo di gioco',
        ' Line Up Home ': 'Formazione dei giocatori in campo per la squadra di casa',
        ' Line Up Away ': 'Formazione dei giocatori in campo per la squadra ospite',
        ' Sub ': 'minuto della sostituzione',
        ' Market Value ': 'Valore di mercato attuale di ciascun giocatore',
        ' P.M.Role ': 'Ruolo generale del giocatore',
        ' Primary_Role ': 'Ruolo specifico principale del giocatore',
        ' Alt.Role1 ': 'Ruolo specifico alternativo del giocatore',
        ' Alt.Role2 ': 'Ruolo specifico alternativo del giocatore',
        ' PreRate ': 'Indice medio della prestazione del giocatore, pre partita',
        ' LiveRate ': "Indice medio della prestazione del giocatore durante il gioco, il colore cambia se il valore è migliore (verde) o peggiore (rosso) rispetto all'indice di prestazione pre partita.",
        ' Titularity % ': 'Percentuale delle presenze del giocatore in stagione, affianco il numero totale di incontri disputati',

         

        /* Home Team Rating by unit */
        /* Away Team Rating by unit */

        ' average rate pre ': 'Indice di prestazione medio di ciascun reparto pre partita',
        ' average rate live ': 'Indice di prestazione medio di ciascun reparto durante il gioco',
        ' Diff rate pre/live % ': 'Differenza degli indici di prestazione dei reparti pre partita e in gioco',

        /* Home VS Away teams by unit */

        ' Pre ': 'Comparazione degli indici di performance dei reparti pre partita',
        ' Live ': 'Comparazione degli indici di performance dei reparti durante il gioco',
        ' Diff ': 'Comparazione delle differenze tra i reparti pre partita e durante il gioco',    

        /* Home Bench */
        /* Away Bench */

        ' Rating ': 'Indice medio della prestazione del giocatore, pre partita',
        ' Goal ': 'Numero di goal segnati dal giocatore in stagione, con percentuale di incisività',
        ' Assist ': 'Numero di assist forniti dal giocatore in stagione',    
        ' S_Role ': 'Ruolo specifico principale del giocatore',

        /* Total */

        ' On ': 'Tiri in porta',
        ' Off ': 'Tiri fuori porta',
        ' Blk ': 'Tiri respinti',
        ' In ': "Tiri da dentro l'area",
        ' Out ': 'Tiri da fuori area',
        ' Cnr ': "Calci d'angolo",
        ' DA ': 'Attacchi pericolosi',
        ' Poss ': 'Possesso palla',
        ' Red ': 'Cartellini rossi',
        ' Yel ': 'Cartellini gialli',
        ' Sbst ': 'Sostituzioni',
        ' Ini ': "Indice d'incisività, può essere negativo o positivo in base alle statistiche medie passate",
        ' PFM ': 'Indice di performance, può essere negativo o positivo in base alle statistiche medie passate',

        
        ' Rtg ': 'Rating, indice di pressing ed attacco',

        /* Other labels */

        ' 1 X 2 ': 'Probabilità di casa, pareggio o trasferta, con quote aggiornate e valore',
        ' O / U ': 'Probabilità sui prossimi Over / Under, con quote aggiornate e valore',
        ' Next Goal ': 'Probabilità sul prossimo goal: casa, trasferta o nessuno',
        ' GB (%) ': 'Probabilità che venga segnato un goal nei prossimi segmenti di tempo',

        /* Modal - historical stats */

        ' Avg Stats Per Game ': 'Statistiche medie degli incontri passati',

        ' P-Number ': 'Numero di incontri giocati in casa dalla squadra di casa e fuori casa dalla squadra ospite',
        ' Goals ': 'Goals',        
        ' Pos ': 'Possesso palla',
        ' Pas ': 'Passaggi',
        ' Acc ': 'Precisione nei passaggi',
        ' Atk ': 'Attacchi totali',
        ' Ofs ': 'Fuorigioco',
        ' Sav ': 'Salvataggi in difesa',
        ' Sbst ': 'Sostituzioni',
        ' Fou ': 'Falli',
        ' G_att ': 'Tentativi di goal',
        ' Safe ': 'Azioni sventate',
        ' Rtg ': 'Rating, indice di pressing ed attacco',

        // cold stats filters
        "League filter": "Filtri campionato",
        "Leagues": "Campionati",
        "Matches percentage": "Percentuali campionati",
        "Type to search": "Digita per ricercare",
        "All leagues": "Tutti i campionati",
        "Prediction filter": "Filtri segni",
        "Time bands filter": "Filtri minutaggi",
        "Score filter": "Filtri score",
        "League table filter": "Filtri tabelle di lega",
        "Home": "Casa",
        "Away": "Trasferta",
        "Home, Away": "Casa, Trasferta",
        "Home = Away": "Casa = Trasferta",
        "Home OR Away": "Casa O Trasferta",
        "Home AND Away": "Casa E Trasferta",
        "Home > Away": "Casa > Trasferta",
        "Home < Away": "Casa < Trasferta",
        "Home OR Away > Home OR Away": "Casa O Trasferta > Casa O Trasferta",
        "None": "Nessuno",

        "Advanced search": "Ricerca avanzata",
        "Search filters": "Applica filtri",
        "Clear filters": "Rimuovi filtri", 

        // log in component
        "subscribe now!": "abbonati ora!",
        "Forgot password? Reset here": "Password dimenticata? Resettala qua",
        "incorrect password, please try again or reset it": "password errata, per favore tenta nuovamente o prova a cambiarla",
        "this username does not exist, please try with another one": "questo nome utente non esiste, per favore tenta con un altro",
        "this account has expired, please subscribe from the link below": "questo account è scaduto, puoi rinnovare l'abbonamento dal link in basso",

        // cold stats filter       

        'Create preset': 'Crea preset',
        'Load preset': 'Carica preset',
        'Filter name': 'Nome filtro',
        'Save Filter': 'Salva filtro',
        'Saved filters list': 'Lista filtri salvati',
        'Load Filter': 'Carica filtro',
        'Delete Filter': 'Elimina filtro',
        'Edit Filter': 'Modifica filtro',
        'Update Filter': 'Aggiorna filtro',
        "Edit filter name": "Rinomina nome filtro",
        "Filtered list": "Lista filtrata",
        "choose filters": "scegli filtri",
        "Sorry, no alerts available at the moment, please try later": "Non ci sono segnali al momento, per favore riprova più tardi",
        "Sorry, no tips available at the moment, please try later": "Non ci sono tips al momento, per favore riprova più tardi",
        "Post your tip now!": "Pubblica la tua tip!",
        'Settings and profile options': 'Settaggi e opzioni profilo',
        "Don't ask more in future": "Non chiedere più",

        "Time min": "Tempo min",
        "Time max": "Tempo max",

        "operational": "operazioni",

        "home(A), away(B)": "casa(A), trasferta(B)",
        "favourite(A), underdog(B)": "favorita(A), sfavorita(B)",
        "winning(A), losing(B)": "in vantaggio(A), in svantaggio(B)",

        "sum greater than": "somma maggiore di",
        "sum minor than": "somma minore di",
        "diff greater than": "differenza maggiore di",
        "diff minor than": "differenza minore di",

        "Save to My Game": "Salva in My games",
        "Hide search": "Nascondi ricerca",
        "Apply filters": "Applica filtri",
        "Hide load preset": "Nascondi carica preset",
        "Hide create preset": "Nascondi crea preset",

        "HOW TO RECEIVE ROBOT ALERTS": "COME RICEVERE I SEGNALI DEI ROBOTS",
        "Be sure to follow the next steps using a device which has installed Telegram app. Can be any device: PC, smartphone or anything else.": "Assicurati che il dispositivo che stai usando abbia installata la app di Telegram. Puoi usare qualsiasi dispositivo: PC, smartphone o altri.",
        "To get your telegram user ID please click on the following link:": "Per ottenere il tuo 'telegram user ID' clicca sul link qui in basso:",
        "Click on 'Send message'. Then write '/start'. You'll see your ID which is composed by 9 numbers.": "Clicca su 'Send message'. Successivamente scrivi '/start'. Riceverai un messaggio con il tuo ID composto da nove cifre.",
        "Copy the ID number and put it in the 'telegram user ID' form above.": "Copia il numero di 9 cifre ed inseriscilo nel campo 'telegram user ID' in alto.",
        "Then save button below": "Attiva le notifiche dal tasto 'attiva notifiche', infine clicca sul bottone 'Salva' in basso alla finestra.",
        "Please click on the link below to access to 'Goal Traders RoBot' and receive alerts from the robots:": "Clicca sul link in basso per accedere a 'Goal Traders RoBot' e ricevere gli alerts:",
        "Then, click on 'Send message', then write '/start', alerts will come soon as they are available.": "Successivamente, clicca su 'Send message', scrivi '/start'. , Complimenti, gli alerts comincieranno ad arrivare non appena disponibili.",
        "For further help please watch the video in the tutorials area:": "Per ulteriore aiuto puoi consultare il video apposito nell'area tutorial:",
        "You can stop/start to receive notification at any time just turning off/on the button 'active notification' above.": "Puoi disattivare/riattivare le notifiche telegram in qualsiasi momento dal tasto 'attiva notifiche' in alto. ",
        'Active notification': 'Attiva notifiche',

        "home fh": "casa pt",
        "draw fh": "pareggio pt",
        "away fh": "trasferta pt",
        "Second Half Overs %": "Over secondo tempo %",
        "0.5 SH": "0.5 ST",
        "1.5 SH": "1.5 ST",
        "2.5 SH": "2.5 ST",
        "1st goal avg min": "minuto primo goal",

        //financial strategy page
        "Back increment %": "Punta incr. %",
        "Lay increment %": "Banca incr. %",
        "min odd": "min quota",
        "max odd": "max quota",
        "tot bets filtered": "tot operazioni",
        "liability": "responsabilità",
        "payout": "payout",
        "Swap Result": "Swap  Risultati",
        "Without CO": "Escludi CO",
        "Leverage stake": "Puntata Fissa",
        "start bankroll": "Banca iniziale",
        "size %": "size %",
        "Gross profit": "Profitto lordo",
        "Gross loss": "Perdite lorde",
        "Profit factor": "Profit factor",
        "DDMAX %": "DDMAX %",
        "Net Profit": "Profitti netti",
        "investimento": "investimento",
        "ROI": "ROI",
        "ROE": "ROE",
        "Avg Odd": "Q.ta media",
        "W/Rate": "W/Rate",
        "Single bets list": "Lista Operazioni",
        "tip": "tip",
        "cover": "cover",
        "Post Date": "Data post",
        "P/L Points": "P/L Punti",
        "P/L Leverage stake": "P/L Puntata fissa",
        "P/L compounding": "P/L compounding",
        "Lay (Payout)": "Banca (Payout)",
        "Lay (liability)": "Banca (responsabilità)",
        "Prediction": "Pronostico",
        "Bet Side": "Punta/Banca",
        "tip/cover": "tip/cover",
        "Entry min": "Entrata minuto",
        "Cash out": "Cash out",
        "Bet 365 Entry": "Quota entrata",
        "Bet 365 CO Odds": "Quota Cashout",
        "stake": "Stake Pt",
        "Back Odd": "Quota Punta",
        "Lay Odd": "Quota Banca",
        "Outcome": "Risultato",
        "Lay Risk": "Rischio Banca",
        "Payout": "Payout",
        "liab stake": "stake responsabilità",
        "liab risk": "rischio responsabilità",
        "Liability": "Responsabilità",
        "current Bank": "Banca corrente",
        "stake Back": "Stake Punta",
        "draw Down": "draw Down",
        "stake Lay": "Stake responsabilità",
        "lay risk": "Rischio Banca",
        "Without Cover": "Escludi Cover",


        //weather report
        "Weather": "Meteo",
        "Temperature": "Temperatura",
        "Clouds": "Nuvolosità",
        "Humidity": "Umidità",
        "Pressure": "Pressione",
        "Wind": "Vento",
        "Coordidates": "Coordinate",

        "clear sky": "cielo sereno",
        "few clouds": "poco nuvoloso",
        "scattered clouds": "nubi sparse",
        "broken clouds": "nuvole sparse",
        "shower rain": "pioggia continua",
        "rain": "pioggia",
        "thunderstorm": "temporali",
        "snow": "neve",
        "mist": "foschia",
        "clouds": "nuvoloso",
        "moderate rain": "pioggia moderata",
        "haze": "velato",
        "light intensity shower rain": "pioggia continua di lieve intensità",
        "light rain": "pioggia lieve",
        "overcast clouds": "coperto",
        "light intensity drizzle": "pioggerella di lieve intensità",
        "fog": "nebbia",
        "heavy intensity rain": "pioggia di grande intensità",
        "thunderstorm with light rain": "temporale con pioggia lieve",
        "thunderstorm with rain": "temporale con pioggia",
        "drizzle": "pioggierella",
        "heavy intensity drizzle": "pioggierella di grande intensità",
        "light intensity drizzle rain": "pioggerella di lieve intensità",
        "drizzle rain": "pioggerella",
        "heavy intensity drizzle rain": "pioggierella di grande intensità",
        "shower rain and drizzle": "pioggia continua e pioggerella",
        "heavy shower rain and drizzle": "pioggia continua pesante e pioggerella",
        "shower drizzle": "pioggerella continua",
        "light snow": "nevicata lieve",
        "snow": "nevicata",
        "heavy snow": "forte nevicata",
        "sleet":"nevischio",
        "light shower sleet": "nevischio lieve continuo",
        "shower sleet": "nevischio continuo",
        "light rain and snow": "pioggia lieve e neve",
        "rain and snow": "pioggia e neve",
        "light shower snow": "nevicata lieve continua",
        "shower snow": "nevicata continua",
        "heavy shower snow": "forte nevicata continua",


        "Venue": "Stadio",
        "name": "nome",
        "surface": "superficie", 
        "city": "città",
        "capacity": "capienza",
        "grass": "erba",

        "Home team coach": "Allenatore squadra di casa",
        "Away team coach": "Allenatore squadra ospite",
        "Common name": "Nome",
        "Nationality": "Nazionalità",

        //money management
        "Save progresses": "Salva progressi",
        "Strategy Name": "Nome Strategia",
        "Strikes left": "Prese mancanti",
        "New": "Nuovo",
        "Target": "traguardo",
        "richieste": "richieste",
        "N. prese": "N. prese",
        "ROI ($)": "Pari a",
        "Max. Risk": "Max. Esp.",
        "Achieved": "Conseguita",
        "Current": "Attuale",
        "Won:Part": "Vinte : Parz.",
        "Won": "Vinte",
        "Loss:Part": "Perse : Parz.",
        "Loss": "Perse",
        "Stake": "Piazza",
        "Real profit": "Utile Trade",
        "Max gross": "Utile lordo",
        "profit.": "Potenziale",
        "profit": "utile",
        "Net profit": "Utile netto",
        "Progressive": "Progress.",
        "Current.": "Capitale",
        "bank": "residuo",
        "Success!": "Fatto!",
        "Create new money management data succesfully": 'Nuovo money management creato!',
        "End": "Fine",
        "L ": "P",
        "Annulla": "Annulla",
        "Yes": "Si",
        "No": "No",

        "Team vs Team": "Squadra vs Squadra",
        "Season": "Stagione",

        "Select Season...": "Seleziona Stagione...",
        "Select League...": "Seleziona Lega...",
        "Select Home...": "Select Casa...",
        "Select Away...": "Select Ospite...",
        "Please select your teams": "Seleziona le squadre",
        "current season": "stagione corrente",
        "last season": "stagione passata",

        'Operations By League': 'Operazioni per Campionato',
        "Sample": "Campione",
        "avg Odds Bet365": "Media quote Bet365",
        "avg Entry odds": "Media quote entrata",
        "avg CO odds": "Media quote CO",
        "Entry": "Entrata",
        "current": "attuale",
        "best": "Max",
        "worst": "Max",
        "Profits in row": "Profitti consecutivi",
        "Losses in row": "Perdite consecutive",
        "Last Bet (W or L)": "Ultima operazione",
        "avg": "media",
        "trend 1": "freq 1",
        "trend 2": "freq 2",

        //search stats page
         // "Search filters": "Filtri di ricerca",
         "League": "Lega",
         "Type to search": "digita",
         "Press enter to select": "seleziona",
         "Press enter to remove": "rimuovi",
         "Season": "Stagione",
         "select season": "seleziona stagione",
         "Current season": "Stagione corrente",
         "Last 2 seasons": "Ultime 2 stagioni",
         "Last 3 seasons": "Ultime 3 stagioni",
         "Last 4 seasons": "Ultime 4 stagioni",
         "Last 5 seasons": "Ultime 5 stagioni",
         "Team": "Squadra",
         "All teams": "Tutte le squadre",
         "Selected":"Selezionato",
         "Role": "Casa/Trasferta",
         "Both": "Entrambe",
         "Odds filters": "Filtri quote",
         "Over odds": "Filtri Over",
         "Under odds": "Filtri Under",
         "Results Filter": "Filtri Mercati",
         "From minute": "Dal minuto",
         "To minute": "al minuto",
         "Odd ": "Dispari",
         "Even": "Pari",
         "Score time Filter": "Filtro risultati",
         "Result at 15'": "Risultato al 15'",
         "Result at 30'": "Risultato al 30'",
         "Result at HT'": "Risultato al PT'",
         "Result at 60'": "Risultato al 60'",
         "Result at 75'": "Risultato al 75'",
         "Result at FT'": "Risultato FT'",
         "Home Score": "Punteggio Casa",
         "Away Score": "Punteggio Trasferta",
         "Home Live stats filter": "Filtro statistiche live Casa",
         "From": "Dal minuto",
         "To": "al minuto",
         "Away Live stats filter": "Filtro statistiche live Trasferta",
         "Get Data": "Esegui Ricerca",
         "Results": "Risultati Ricerca",
         "Sample Size": "Campione",
         "View Matches": "Vedi Incontri",
         "First Half and Second Half Markets": "Mercati Primo tempo e Secondo tempo",
         "First Half Markets": "Mercati Primo tempo",
         "Match Odds (Half Time Market)": "1X2 (Primo Tempo)",
         "First Half goals 0.5": "Goals 0.5 PT",
         "First Half goals 1.5": "Goals 1.5 PT",
         "First Half goals 2.5": "Goals 2.5 PT",
         "Probability%": "Probabilità %",
         "Half Time Score": "Risultati Primo tempo",
         "Home win": "Casa",
         "Away Win": "Trasferta",
         "AUQ": "Altri",
         "2nd Half Only": "Solo Secondo tempo",
         "2nd Half Match Odd": "1X2 Secondo Tempo",
         "Full Match Markets": "Mercati Finali",
         "Full Time Main Markets": "Mercati FT",
         "Main Odds": "Quote 1X2",
         "Next Goal": "Prossimo Goal",
         "Yes": "Si",
         "No": "No",
         "Over/Under 0.5": "Over/Under 0.5",
         "Over/Under 1.5": "Over/Under 1.5",
         "Over/Under 2.5": "Over/Under 2.5",
         "Over/Under 3.5": "Over/Under 3.5",
         "Over/Under 4.5": "Over/Under 4.5",
         "Correct Score": "Risultati Esatti",
         "AOHW": "Altri",
         "AOD": "Altri",
         "AOAW": "Altri",
         "Stats by Segment Times": "Statistiche Mercati per minutaggi",
         "League stats": "Statistiche per Lega",
         "Filter": "Filtri",
         "type string...": "digita...",
         "Avg Odd, ROI by Leagues": "ROI e quote Medie per Lega",
         "Avg Odd, ROI by Teams": "ROI e quote Medie per Squadra",
         "Next Games": "Prossimi incontri",
         "From date": "da data",
         "To date": "a data",
         "No items": "Dati non disponibili",
         "Chart and stats": "Grafici e statistiche",
         "Market": "Mercato",
         "Home - FT": "Casa - FT",
         "Away - FT": "Trasferta - FT",
         "Draw - FT": "Pareggio - FT",
         "Home - HT": "Casa - PT",
         "Away - HT": "Trasferta - PT",
         "Draw - HT": "Pareggio - PT",
         "Over - 0.5 - FT": "Over - 0.5 - FT",
         "Over - 1.5 - FT": "Over - 1.5 - FT",
         "Over - 2.5 - FT": "Over - 2.5 - FT",
         "Over - 3.5 - FT": "Over - 3.5 - FT",
         "Under - 0.5 - FT": "Under - 0.5 - FT",
         "Under - 1.5 - FT": "Under - 1.5 - FT",
         "Under - 2.5 - FT": "Under - 2.5 - FT",
         "Under - 3.5 - FT": "Under - 3.5 - FT",
         "Over - 0.5 - HT": "Over - 0.5 - PT",
         "Over - 1.5 - HT": "Over - 1.5 - PT",
         "Under - 0.5 - HT": "Under - 0.5 - PT",
         "Under - 1.5 - HT": "Under - 1.5 - PT",
         "BTS - FT": "BTS - FT",
         "No BTS - FT": "No BTS - FT",
         "Filter": "Filtri",
         "Apply": "Applica",
         "Cancel": "Chiudi",
         "League table filter": "Filtri per lega",
         "Team table filter": "Filtri per squadra",
         "Total sample": "Totale campioni",
         "Operations per month": "Operazioni per mese",
         "Avg Odd": "Quota media",
         "Profit PTS":"Profitti PTS",

         //Historical data

        "Select date": "Selezionare date",
        "from": "da",
        "to": "fino a",
        "year": "anno",
        "month": "mese",
        "day": "giorno",
        "League": "Lega",
        "select league": "selezionare lega",
        "Search": "Ricerca",
        "Reset": "Reset",
        "Team": "Squadra",
        "Home/Away": "Casa/Trasferta",
        "select team": "selezionare squadra",
        "Event Name": "Incontro",
        "select event": "selezionare incontro",
        "Market Name": "Mercato",
        "select market": "selezionare mercato",
        "MATCH_ODDS": "ESITO FINALE",
        "HALF_TIME": "PRIMO TEMPO",
        "FIRST_HALF_GOALS_05": "PRIMO TEMPO UNDER/OVER 0.5",
        "OVER_UNDER_05": "UNDER/OVER 0.5",
        "OVER_UNDER_15": "UNDER/OVER 1.5",
        "OVER_UNDER_25": "UNDER/OVER 2.5",
        "OVER_UNDER_35": "UNDER/OVER 3.5",
        "event Name": "Nome evento",
        "event Id": "Id evento",
        "Market Id": "Id mercato",
        "Market Type": "Tipo Mercato",
        "League": "Lega",
        "Market Info": "Informazioni mercato",
        "Home": "Casa",
        "Away": "Trasferta",
        "Draw": "Pareggio",
        "Runner Id": "Id segno",
        "Status": "Stato",
        "InPlay": "In gioco",
        "Time": "Tempo",
        "Price": "Quota",
        "OPEN": "APERTO",
        "SUSPENDED": "SOSPESO",
        "false": "falso",
        "true": "vero",
        "Prematch": "Prematch",
        "First Half": "Primo tempo",
        "Interval": "Intervallo",
        "Second Half": "Secondo tempo",

        "Comparison filter Home/Away": "Filtro comparativo Casa/Trasferta",
        "Clear fields": "Pulisci",
        "Filter updated successfully": "Filtro aggiornato con successo",
        'Show firsts': 'Mostra prime',

        "Investments": "Investimenti",

        //investments page
        "Favorite":"Favorita",
        "today": "oggi",
        "tomorrow": "domani",
        'Competition ': 'Competizione',
        "Time ": "Orario",
        "event": "Incontro",
        "Stats Last 10 Chance": "Statistiche Ultimi 10 incontri",
        "Fav Label Best Bet": "Favorita Punti e Migliore Bet",
        "fav Label": "Tipo Bet",
        "Match Odds": "Quote Esito Finale",

        "Fixture": "Incontro",
        "Home Back": "Casa Punta",
        "Home Lay": "Casa Banca",
        "Draw Back": "Pareggio Punta",
        "Draw Lay": "Pareggio Banca",
        "Away Back": "Trasferta Punta",  
        "Away Lay": "Trasferta Banca",   
        
        //wrong to adjust the original labels -->> 
        "Bookie Pts and ROI": "ROI e Punti",
        "lay price is calculated by adding 3% onto back price":  "il prezzo del lato banca è calcolato incrementando del 3% il prezzo del lato punta",
        //end adjustments
        
        'Averages for League and Last 20, 10, 5 matches': 'Medie per Lega ed Ultimi 20, 10, 5 incontri',
        "League Averages": "Media Lega",
        "Team Favorite (Based on start odds)": "Media per Tipo di incontro",
        "Implied Odds": "Quote implicite",
        "home": "casa",
        "away": "trasferta",
        "Chance": "Percentuale",
        "Last 20 matches - Long Term": "Ultimi 20 incontri - Lungo Termine",
        "Last 10 matches - Medium Term": "Ultimi 10 incontri - Medio Termine",
        "Last 5 matches - Short Term": "Ultimi 5 incontri - Breve Termine",

        "LayHome": "Banca Casa",
        "LayAway": "Banca Trasferta",
        "BackHome": "Punta Casa",
        "BackAway": "Punta Trasferta",
        "LayDraw": "Banca Pareggio",
        "BackDraw": "Punta Pareggio",
    },

    'pt': {
        // investments main
        "Equilibrata": "Equilibrado",
        "Ospite_med_fav": "Fora_med_fav",
        "Ospite_min_fav": "Fora_min_fav",
        "Casa_med_fav": "Casa_med_fav",
        "Casa_min_fav": "Casa_min_fav",
        "Ospite_max_fav": "Fora_max_fav",
        "Casa_max_fav":"Casa_max_fav",
        
        "Operation by All leagues": "Operações por liga totais",
        "Operation by single leagues": "Operações por liga",
        "no strategy tips": "tips sem estratégia",
        'Match': 'Jogo',
        'Select Match': 'Selecionar jogo',
        'Coming Up': 'Em breve',
        'Competition ': 'Competição',
        'Open': 'Abrir',  
        'Responsibility': 'responsabilidade',
        'Lay X': 'X Lay',
        'Back X': 'X Back',
        'Lay 1': '1 Lay',
        'Lay 2': '2 Lay',
        'Back Over 0.5': 'Mais 0.5',
        'Back Over 1.5': 'Mais 1.5',
        'Back Over 2.5': 'Mais 2.5',
        'Back Under 2.5': 'Menos 2.5',
        'Back Under 3.5': 'Menos 3.5',
        'Alert Stats FT': 'Estatísticas FT',
        'Select CS': 'Inserir RC',
        'Save Data': 'Salvar Dados',
        'Delete Data': 'Excluir Dados',
        'NS': 'em breve..',

      
        // 'General Filters': 'Filtri Generali',
        'Odd Filters': 'Filtros Cotas',
        'Odds': 'Cotas',
        'Total Live Stats': 'Estatísticas totais ao vivo',
        'Last 10 minutes Live Stats': 'Estatísticas ao vivo últimos 10 min.',
        'atk chart': 'gráfico atk',
        'Cancel': 'Cancelar',
        'Select': 'Inserir',
        'Enter the Odd': 'Inserir Cota',
        'Enter the Stake': 'Inserir Aposta',
        'pre-match Odd': 'Cota pré-jogo',
        'Responsability': 'Risco',
        'Bookmaker': 'Bookmaker',
        'Correct Score': 'Resultado Correto',
        'Enter CS Odd': 'Inserir Cota RC',
        'Enter CS Stake': 'Inserir Aposta RC',
        'Stake to cover': 'Cobertura Aposta',
        'CS Odds': 'Cota RC',
        'Back': 'Back', 
        'Lay': 'Lay',
        'Total Matched': 'Correspondido',
        'Select Risk Trading': 'Selecionar Risco Trading',
        'Easy': 'Fácil',
        'Medium': 'Médio',
        'Risky': 'Arriscado',
        'Select Strategy': 'Selecionar estratégia',
        'Alerts': 'Alertas',
        'Events': 'Jogos',
        'Odd': 'Cota',
        'Min': 'Min',
        'Score': 'Placar',
        'Strategy': 'Estratégia',
        'C': 'C',
        'Messages': 'Mensagens',
        'Cash out bar': 'Aviso Cash out',
        'Insert Odd and Stake': 'Inserir Cota e Aposta',
        'Max profit': 'Lucro máximo',
        'Current Profit': 'Lucro atual',
        'Correct Score bar': 'Aviso Resultado Correto',
        'Insert CS Odd and Stake': 'Inserir Cota e Aposta RC',
        'Equalization Bar': 'Cash Out Parcial',
        'cold stats': 'Estatísticas pré-jogo',
        'CLICK HERE TO LOAD COLD STATS': 'CLIQUE AQUI PARA CARREGAR AS ESTATÍSTICAS',
        'team analysis': 'Análises dos times',
        'CLICK HERE TO LOAD TEAM ANALYSIS DATA.': "CLIQUE AQUI PARA CARREGAR AS ANALISES DOS TIMES",

        /* === homepage ===*/
        'Welcome to Goal Traders by Sospeso!': 'Bem-vindo a Goal Traders da Sospeso Softwares!',
        'Welcome!': 'Bem-vindo!',
        'How to start ?': 'Onde começar?',
        'It is important to start with the right foot: for a better trading experience have a look on user’s video tutorial.': "É importante começar com o pé direito: para uma melhor experiência de utilização, siga os tutoriais em vídeo.",
        'Click here': 'Clique aqui',
        'What’s new ?': "Tem alguma novidade?",
        'The best platform tool for sport trading is here! Goal Traders by Sospeso is always updated to give you the best that you can have. We will let you know here if some updating is coming soon…': "A melhor plataforma de estatísticas para trading esportivo online está aqui! O Goal Traders da Sospeso está sempre se atualizando para oferecer as melhores ferramentas que você pode ter. Fique de olho nesta seção para saber das próximas novidades...",
        'Let’s keep in touch': 'Ficamos em contato',
        'For every support that you need you can contact us to:': 'Para qualquer ajuda que você precisar, envie um email:',
        'supporto.info@nicoladefontetipster.com': 'supporto.info@nicoladefontetipster.com',
        'Our social channels': 'Nossas redes sociais',

        /* === feedpage ===*/
        'Refresh': 'Atualizar',
        /* Posts */
        'Posted': 'Postado',
        'Public': 'Tip Pública',
        'Private': 'Tip Privada',
        'Tips': 'Tip:',
        'Odd': 'Cota:',
        'Stake pts': 'Aposta pts',
        'Strategy': 'Estratégia',
        'Cash out details': 'Cash Out info',
        'Tip Cash Out': 'Tip Cashed out',
        'Cover Cash Out': 'Cobertura Cashed out',
        'Current profit': 'Lucro atual',
        'Note': 'Anotações',
        'write here your comment': 'escreva seu comentário aqui',
        'Post Comment': 'Enviar comentário',
        'PTS (total)': 'PTS (totais)',
        /* Tooltips Buttons */
        'Like this tip': 'Curtir essa tip',
        'You already liked this tip': 'Já está curtindo essa tip',
        'Follow this tip': 'Seguir essa tip',
        'You already followed this tip': 'Já está seguindo essa tip',
        'Follow this tipster': 'Seguir esse tipster',
        'You already followed this tipster': 'Já está seguindo esse tipster',
        /* Auto */
        'Auto': 'Auto',
        'Auto cash out (TIP)': 'Auto cashout (TIP)',
        'Auto cash out (COVER)': 'Auto cashout (COBERTURA)',
        'profit pts': 'pts lucro',
        'profit %': 'lucro %',
        'stop loss %': 'stop loss %',
        'next odd (higher than)': 'próxima cotação (maior que)',
        'next odd (lower than)': 'próxima cotação (menor que)',
        'minute': 'minuto',
        'score': 'placar',
        'attempt to accept (Max:10)': 'tentativas de cashout (Máx: 10)',
        'OK': 'OK',
        'Cancel': 'Cancelar',
        'Clean': 'Limpar',

        /* === userpage === */
        'Filter': 'Filtrar',
        'type string': 'pesquisar...',
        'User': 'Usuário',
        'Total Tips': 'Tips totais',
        'Pending Tips': 'Tips abertas',
        'ROI%': 'Roi %',
        'Profit pts': 'Lucro pts',
        'W/Rate': 'W/Rate',
        'Followers': 'Seguidores',
        'Follow': 'Seguir',

        /* === top bar menu === */
        /* Bell menu */
        'Notifications': 'Notificações',
        'Updates': 'Updates',
        'Messages': 'Mensagens',
        'Settled Tips': 'Tips definidas',
        'Comments': 'Comentários',
        /* User menu */
        'My Tips and Stats': 'Minhas tips e Estatísticas',
        'Settings': 'Configurações',
        'Profile': 'Perfil',        
        'Payments': 'Pagamentos',
        'Logout': 'Sair',

        /* === usersetting === */
        'Default Bf com': 'Taxa Betfair por padrão',
        'Goal sound': 'som Gol',
        'New alert sound': 'som Alertas',
        'Currency': 'Moeda',
        'Language': 'Idioma',
        'Timezone': 'fuso horário',
        'Update': 'Atualizar',

        /* === post a tip === */
        'Date': 'Data',
        'Country': 'País',
        'League': 'Liga',
        'Event': 'Jogo',
        'Prediction type available': 'Seleções disponíveis',
        'Status': 'Estado',
        'Score': 'Placar',
        'Odd': 'Cota',
        'Stake': 'Aposta',
        'Visibility': 'Visibilidade',
        'Add to Strategy': 'Adicionar à estratégia',
        'Note': 'Anotações',
        'Last Updated': 'Última atualização',
        'Reset': 'Limpar',
        'Post tip': 'Publicar Tip',
        /* Date input fields */
        'select...': ' selecionar...',
        'Today': 'Hoje',
        'Tomorrow': 'Amanhã',
        'Live Events': 'Jogos ao vivo',
        'Private': 'Tip Privada',
        'Public': 'Pública',

        /* === usertipPost === */
        'Tips': 'Tips',
        'Profit PTs': 'Lucro PTs',
        'ROI %': 'ROI %',
        'W/Rate': 'W/Rate',
        'Followers': 'Seguidores',
        'My tips': 'Minhas tips',
        'Strategies': 'Estratégias',
        'Stats': 'Estatísticas',
        'Options': 'Opções',
        'Pending Tips': 'Tips Abertas',
        'Settled Tips': 'Tips Definidas',
        'Create a strategy': 'Criar estratégia',
        'Name': ' Nome',
        'Description': 'Descrição da estratégia',
        'e.g.strategy 43': 'exemplo: estratégia número 43',
        'e.g.This strategy is for testing over 2.5 at half time when the home team is leadig at half time': 'exemplo: essa estratégia é para testar os mais de 2,5 gols, etc...',
        'Create': 'Criar',
        'Strategy list': 'Lista de estratégias',
        'Filter': 'Filtrar',
        'type string': 'pesquisar...',
        'Stats': 'Estatísticas',
        'Details': 'Detalhes',
        'Delete': 'Remover',
        'Strategy name': 'Nome Estratégia',
        'Stats': 'Estatísticas',
        'Stats by league': 'Estatísticas por liga',
        'Reset details': 'Detalhes Reset',
        'Reset Count': 'Número de Reset realizados',
        'Reset stat': ' Resetar Estatísticas',

        /* === league stats === */
        'League': 'Liga',
        'Match Result %': 'Resultado jogo %',
        'Average Goals': 'Média Gols',
        'Fist Half Overs %': 'Mais gols primeiro tempo %',
        'Full Match Overs %': 'Mais gols %',
        'Goal Bands [% of matches with at least one goal in time period': 'Intervalos de Gols [% de jogos com pelo menos um gol em cada intervalo]',
        'First To Score': 'Primeiro a marcar',
        'Country': 'País',
        'League': 'Liga',
        'Tier': 'Camada',
        'Matches': 'Jogos',
        'home': 'Casa',
        'draw': 'Empate',
        'away': 'Fora',
        'Total': 'Totais',
        '0.5 FH': '0.5 PT',
        '1.5 FH': '1.5 PT',
        '2.5 FH': '2.5 PT',
        'Bts': 'ATM',
        'H Win': 'Casa vence',
        'League Data by Start Price': 'Dados da liga por cotação inicial',
        'H_StrongFav': ' H_StrongFav',
        'H_MediumFav': ' H_MediumFav',
        'H_SmallFav': ' H_SmallFav',
        'SuperCompetative': ' SuperCompetative',
        'A_StrongFav': ' A_StrongFav',
        'A_MediumFav': ' A_MediumFav',
        'A_SmallFav': ' A_SmallFav',
        '15 minutes': '15 minutos',
        '30 minutes': '30 minutos',
        '45 minutes': '45 minutos',
        '60 minutes': '60 minutos',
        '75 minutes': '75 minutos',
        'all': 'todos',
        'scorelines that lead to more goals': 'Placares que levam a mais gols',
        'Shots on Target to Goal Averages': 'Chutes a gol e média de gols ',
        'Goal+ Home': 'Gol+ Casa',
        'Goal+ Away': 'Gol+ Fora',
        'Shot On Target': 'Chutes a gol',
        'Goal Avg': 'Média de gols',
        'Fixture': 'Jogos',
        'Date': 'Data',
        'Label': 'Tipo',
        'Odds': 'Cotas',
        'Goal Times': 'Intervalos de Gols',
        'Red': 'Vermelho',
        'Cards?': 'Cartão?',
        'BTTS': 'ATM',
        'Results': 'Resultados',
        'HT': 'PT',
        'FT': 'RF',
        'Home': 'Casa',
        'Draw': 'Empate',
        'Away': 'Fora',
        'Y': 'S',
        'N': 'N',

        /* === membership page === */
        'This page is not allowed for your current membership plan.': 'Esta página não é permitida para seu plano de assinatura atual.',
        'Please upgrade your plan': 'Por favor, assine um plano superior ',
        'here': 'aqui',
        'or contact the administrator': " ou entre em contato com o administrador",
        'Upgrade plan': 'Atualizar plano',

        /* === money management page === */
        'Create money management': 'Criar money management',
        'Insert a name': 'Nome',
        'Starting Bank': 'Budget inicial',
        'Target profit': 'Objetivo lucro',
        'Stop Losses': 'Stop loss',
        'Currency': 'Moeda',
        'Management name': 'Nome money management',
        'Add': 'Criar',
        'Money manangement list': 'Lista Money manangement',
        'Name': 'Nome',
        'Starting Bank(€)': 'Budget inicial',
        'Target Profit(%)': 'Target Profit(%)',
        'Stop Loss(%)': 'Stop Loss(%)',
        'P / L %': 'L / P %',
        'Actions': ' ',
        'View': 'Detalhes',
        'Delete': 'Cancelar',
        // detal
        'Money management detail': 'Nome Money management',
        'Detail': 'Detalhes',
        'moneyDetail': 'Detalhes',
        'Starting Bank': 'Budget inicial',
        'Target Profit': 'Objetivo lucro',
        'Today in profits': 'Lucro hoje',
        'Daily stop losses': 'Stop loss diário',
        'Today losses': 'Perdas hoje',
        'Current bank': 'Budget atual',
        'Profit / Losses': 'Lucros / Perdas',
        'Trades in profits': 'Operações em lucros',
        'Best profit': 'Max lucro',
        'Trades losses': 'Operações em perdas',
        'Worse loss': 'Max perdas',
        'Today in profits': 'Lucro hoje',
        'Today losses': 'Perdas hoje',
        'round stake values 0,50 multiple': 'arredondar o valor das apostas por múltiplos de 0,50',
        'Index': 'n°',
        'Events': 'Jogos',
        'Date': 'Data',
        'Current Bank': 'Budget atual',
        'Stake (points)': 'Aposta (points)',
        'Back/Lay': 'Back / Lay',
        'Odd': 'Cota',
        'Stake': 'Aposta',
        'Profit': 'Lucro',
        'Risk': 'Risco',
        'Real Profit': 'Lucro real',
        'Balance': 'Saldo',
        'Edit': 'Alterar',
        'Back': 'Back',
        'Lay': 'Lay',

        /* === league table === */
        'Please select...': 'selecionar...',
        'Full': 'Tudo',
        'Home - Away': 'Casa - Fora',
        'First Half': 'Primeiro tempo',
        'Second Half': 'Segundo tempo',
        'Form - Overall': 'Forma - total',
        'Form - 3 Matches': 'Forma - 3 jogos',
        'Form - 6 Matches': 'Forma - 6 jogos',
        'Home Attack v Away Defence': 'Ataque Casa v Defesa Fora',
        'Home Defence v Away Attack': 'Defesa Casa v Ataque Fora',
        'Team': 'Time',
        'Home Attack': 'Ataque casa',
        'Away Attack': 'Ataque fora',
        'Away Defence': 'Defesa fora',
        'Home Defence': 'Defesa casa',
        'Points': 'Pontos',

        /* === coldstats === */
        'Search fixtures for today': ' pesquisar jogos para hoje ',
        'Search fixtures for tomorrow': ' pesquisar jogos para amanhã ',
        'Search fixtures for ': ' pesquisar jogos para ',
        'Monday': 'segunda feira ',
        'Tuesday': 'terça feira ',
        'Wednesday': 'quarta feira ',
        'Thursday': 'quinta feira ',
        'Fryday': 'sexta feira ',
        'Saturday': 'sabado ',
        'Sunday': 'domingo ',
        'Competition': 'por liga',
        'Time': 'por hora de início',
        'Team': 'Time',
        'H': 'C',
        'A': 'F',
        'Scored': 'Marcados',
        'Conc.': 'Sofridos',
        'Average': 'Média',
        'Filters': 'Filtros',
        'Red Card': 'Cartões Vermelhos',
        'FH': 'PT',
        'SH': 'ST',
        'Show last': 'Mostrar ultimos',
        'ALL': 'Todos',
        'days': 'rodadas',
        'Home Lineup': 'Esquema Casa',
        'All': 'Todos',
        'Away Lineup': 'Esquema Fora',
        
        'HomeTeam': 'Casa',
        'AwayTeam': 'Fora',
        'vs All': 'vs Todos',
        'vs High rank': 'vs tabela alta',
        'vs middle-high rank': 'vs tabela média-alta',
        'vs middle-low rank': 'vs tabela média-baixa',
        'vs low rank': 'vs tabela baixa',
        'FH goals Scored:': 'PT gols marcados:',
        'home': 'Casa',
        'away': 'Fora',
        'probability': 'probabilidade',
        'SH goals Scored:': 'ST gols marcados:',
        'D': 'E',
        'First': 'Primeiro',
        'Last': 'Último',
        'H 1st': 'C 1t',
        'D 1st': 'E 1t',
        'A 1st': 'F 1t',
        'H 2nd': 'C 2t',
        'D 2nd': 'E 2t',
        'A 2nd': 'F 2t',
        'Total': 'Totais',
        'Pos': 'Tabela',
        'H/A': 'C/F',
        'Swing': 'Gap',
        'FH': 'PT',
        'SH': 'ST',
        'Attack': 'Ataque',
        'Defense': 'Defesa',
        'Form': 'Forma',
        'H/A Form': 'C/F forma',

        /* Modal elements */

        'Details': 'Detalhes',
        'Home': 'Casa',
        'Away': 'Fora',
        'FH': 'PT',
        'FT': 'FT',
        'Full Score Table': 'Resultados FT',
        'Standings': 'Tabelas',
        'P': 'J',
        'W': 'V',
        'D': 'E',
        'L': 'D',
        'F': 'M',
        //'A': 'S',
        'GD': 'DG',
        

        /* === valuestats === */

        'matches': 'Jogos',        
        'BTS': 'ATM',
        '1 year': '1 ano',
        '3 years': '3 anos',
        '10 years': '10 anos',
        'Bet365 odds': 'Cotas Bet365 ',
        'Betfair prices': 'Cotas Betfair ',
        'Recent form': 'Estado de forma',        

        /* Tool Tip */
        'True Odd': 'Cota real',
        'Stat': 'Estat',


        /* === profile === */
        'Username': 'Usuário',
        'Select Avatar': 'Foto do perfil',
        'Alias': 'Nome a ser exibido',
        'Save changes': 'Salvar',        
        /* Avatar modal window */
        'Select avatar': 'Foto do perfil',
        'Save': 'Salvar',

        /* === nav dashboard === */
        'General Filters': 'Filtros Gerais',
        'Cup': 'Taças',
        'Back': 'Back',
        'Lay': 'Lay',
        'Double Tips': 'Tips Dupla',
        'Odd Filters': 'Filtros Cotas',
        'Matched Filters': 'Filtros Correspondido',
        'Commissions': 'Taxa',
        'Add all events': 'Adicionar todos os jogos',
        'Clear': 'Limpar',
        'Clear ended events': 'Limpar jogos terminados',

        /* Table Labels*/

        'Match': 'Jogos',
        'Tot. matched': 'Tot.correspondido',
        'Pre Odd': 'Cota pre',
        'Odd': 'Cota',
        'Back': 'Back',
        'Lay': 'Lay',
        'Status': 'Estado',
        'Minute': 'Minuto',
        'Score': 'Placar',
        'Gain/Losses': 'Lucro',

        /* Table inside fields */

        'Back': 'Back',
        'Lay': 'Lay',
        'Closed': 'Terminado',
        "Close": "Fechar",
        'Live': 'Ao Vivo',
        'Suspended': 'Suspenso',
        'Coming up': 'A seguir',

        /* livestats === */
        'Scheduled Games': 'Jogos a seguir',
        'LIVE Games': 'Jogos AO VIVO',
        'Finished Games': 'Jogos Terminados',
        'My Games': 'Meus Jogos',
        'Result': 'Placar',
        'Total Game': 'Totais',
        'Last 10 minutes': 'Últimos 10 minutos',
        'Odds': 'Cotas',
        'Next goal': 'Próximo gol',
        'Next Goal': 'Próx. Gol',
        'Matches': 'amostra',
        'Last Updated': 'Última atualização',

        /* modal window */        
        'Historical Stats': 'Histórico de estatísticas ao vivo',
        'Avg Stats Per Game': 'Estatísticas médias por jogo',
        'Chart': 'Gráfico',
        'Odds': 'Cotas',

        /* === navbar === */
        'Auto Tip/Cash': 'Auto Tip/Cash',
        'Dashboard': 'Dashboard',
        'Sospeso': 'Sospeso',
        'Live stats': 'Estatisticas Ao Vivo',
        'Admin settings': 'Configurações admin',
        'Cold Stats': 'Estatisticas pré-jogo',
        'Cold Stats1': 'Estatisticas pré-jogo',
        'Search stats': 'Pesquisar Estatisticas',
        'Team Analysis': 'Análise de time',
        'Today': 'Hoje',
        'Money Manage': 'Gestão dinheiro',
        'Page Settings': 'Configurações páginas',
        'User List': 'Lista usuários',
        'User List Page': 'Usuários',
        'Main': 'Sospeso WEB',
        'liveStatsNew': 'Estatisticas Ao Vivo',
        'Live Stats Analysis 1': 'Pesquisar Estatisticas',
        'AdminView': 'Configurações admin',
        'Page Setting': 'Configurações páginas',
        'Feed Page': 'Alertas',

        'League Table': 'Tabelas das ligas',
        'Value stats data': 'Apostas de valor',
        'Live Stats Analysis': 'Live Stats Analysis',
        'Historic Data': 'Histórico de cotas',
        'Nav Dashboard': 'Sospeso Dashboard',
        'League Stats': 'Estatísticas das Ligas', 

        /* === cold stats tooltips === */

        ' H ': 'Time casa',
        ' A ': 'Time fora',
        ' P ': "Número de jogos disputados pelo time da casa em casa e pelo time visitante fora de casa",
        ' 0 - 0 ': "Porcentagem de jogos terminados com resultado de 0-0 para o time da casa em casa e para o time visitante fora de casa",
        ' Ov. 1.5 ': "Porcentagem de jogos acima de 1,5 gols para o time da casa em casa e para o time visitante fora de casa",
        ' Ov. 2.5 ': "Porcentagem de jogos acima de 2,5 gols para o time da casa em casa e para o time visitante fora de casa",
        ' Ov. 3.5 ': "Porcentagem de jogos acima de 3,5 gols para o time da casa em casa e para o time visitante fora de casa",
        ' Scored ': "Porcentagem de jogos em que o time marcou pelo menos um gol, o time da casa em casa e o time visitante fora",
        ' Conc ': "Porcentagem de jogos em que o time sofreu pelo menos um gol, o time da casa em casa e o time visitante fora",
        ' BTS ': "Porcentagem de jogos em que os dois times marcaram, o time da casa em casa e o time visitante fora",
        ' 1 + 1st ': "Porcentagem de jogos com pelo menos 1 gol na primeira parte, o time da casa em casa e o time visitante fora",
        ' 2 + 1st ': "Porcentagem de jogos com pelo menos 2 gols na primeira parte, o time da casa em casa e o time visitante fora",
        ' 1 + 2st ': "Porcentagem de jogos com pelo menos 1 gol na segunda parte, o time da casa em casa e o time visitante fora",
        ' 2 + 2st ': "Porcentagem de jogos com pelo menos 2 gols na segunda parte, o time da casa em casa e o time visitante fora",
        ' Red card ': 'Filtros para jogos com pelo menos um cartão vermelho, no primeiro ou segundo tempo ou em ambos os tempos',
        ' Show last ': 'Mostra os últimos jogos disputados',
        ' Home lineup ': 'Mostra os jogos disputados pelo time da casa usando um esquema específico',
        ' Away lineup ': 'Mostra os jogos disputados pelo time de fora usando um esquema específico',
        ' Home team ': 'Mostra os jogos disputados pelo time da casa contra o time visitante de uma zona de tabela específica',
        ' Away team ': 'Mostra os jogos disputados pelo time visitante contra o time da casa de uma zona de tabela específica',

        ' G+ ': 'Número de gols marcados pelo time da casa em casa e pelo time visitante fora',
        ' G- ': 'Número de gols sofridos pelo time da casa em casa e pelo time visitante fora',
        ' 0 - 15 ': 'Porcentagem de eventos com gols marcados e sofridos por intervalos de tempo pelo time da casa em casa e pelo time visitante fora',
        ' 16 - 30 ': 'Porcentagem de eventos com gols marcados e sofridos por intervalos de tempo pelo time da casa em casa e pelo time visitante fora',
        ' 31 - 45 ': 'Porcentagem de eventos com gols marcados e sofridos por intervalos de tempo pelo time da casa em casa e pelo time visitante fora',
        ' 46 - 60 ': 'Porcentagem de eventos com gols marcados e sofridos por intervalos de tempo pelo time da casa em casa e pelo time visitante fora',
        ' 61 - 75 ': 'Porcentagem de eventos com gols marcados e sofridos por intervalos de tempo pelo time da casa em casa e pelo time visitante fora',
        ' 76 - 90 ': 'Porcentagem de eventos com gols marcados e sofridos por intervalos de tempo pelo time da casa em casa e pelo time visitante fora',
        ' GS1 ': 'Porcentagem de gols marcados na primeira parte pelo time da casa em casa e pelo time visitante fora',
        ' GS2 ': 'Porcentagem de gols marcados na segunda parte pelo time da casa em casa e pelo time visitante fora',
        ' GC1 ': 'Porcentagem de gols sofridos na primeira parte pelo time da casa em casa e pelo time visitante fora',
        ' GC2 ': 'Porcentagem de gols sofridos na segunda parte pelo time da casa em casa e pelo time visitante fora',
        ' 40+ ': 'Porcentagem de jogos em que foi marcado pelo menos 1 gol nos últimos 5 minutos da primeira parte',
        ' 85+ ': 'Porcentagem de jogos em que foi marcado pelo menos 1 gol nos últimos 5 minutos da segunda parte',
        ' H_AVG ': 'Média das porcentagens dos jogos vencidos pelo time da casa em casa e derrotas do time visitante fora de casa',
        ' D_AVG ': 'Média das porcentagens dos jogos empatados pelo time da casa em casa e empatados do time visitante fora de casa',
        ' A_AVG ': 'Média das porcentagens dos jogos perdidos pelo time da casa em casa e vencidos do time visitante fora de casa',
        ' 1-0 ': "Média entre as porcentagens dos jogos com placar de 1 a 0 marcados pelo time da casa em casa e sofridos pelo time visitante fora",
        ' 1-1 ': "Média das porcentagens dos jogos com placar de 1-1 após o 1-0 marcados pelo time da casa em casa e sofridos pelo time visitante fora",
        ' 2-0 ': "Média das porcentagens dos jogos com placar de 2-0 após o 1-0 marcados pelo time da casa em casa e sofridos pelo time visitante fora",
        ' 0-1 ': "Média entre as porcentagens dos jogos com placar de 0 a 1 sofridos pelo time da casa em casa e marcados pelo time visitante fora",
        ' 1-1_2 ': "Média das porcentagens dos jogos com placar de 1-1 após o 0-1 sofridos pelo time da casa em casa e marcadoss pelo time visitante fora",
        ' 0-2 ': "Média das porcentagens dos jogos com placar de 0-2 após o 0-1 sofridos pelo time da casa em casa e marcadoss pelo time visitante fora",
        ' First ': "Porcentagem dos jogos em que o time marca primeiro, o time da casa em casa e o time visitante fora",
        ' Last ': "Porcentagem dos jogos em que o time marca por último, o time da casa em casa e o time visitante fora",
        ' 2+ ': 'Média das porcentagens dos jogos em que o time marcou 2 gols em qualquer altura do jogo, o time da casa em casa e o time visitante fora',
        ' 2- ': 'Média das porcentagens dos jogos em que o time sofreu 2 gols em qualquer altura do jogo, o time da casa em casa e o time visitante fora',
        ' H 1st ': 'Média das porcentagens de vitórias no primeiro tempo pelo time da casa em casa e de derrotas pelo time visitante fora',
        ' D 1st ': 'Média das porcentagens de empates no primeiro tempo pelo time da casa em casa e de empates pelo time visitante fora',
        ' A 1st ': 'Média das porcentagens de derrotas no primeiro tempo pelo time da casa em casa e de vitórias pelo time visitante fora',
        ' H 2nd ': "Média das porcentagens de vitórias no segundo tempo pelo time da casa em casa e de derrotas pelo time visitante fora",
        ' D 2nd ': 'Média das porcentagens de empates no segundo tempo pelo time da casa em casa e de empates pelo time visitante fora',
        ' A 2nd ': 'Média das porcentagens de derrotas no segundo tempo pelo time da casa em casa e de vitórias pelo time visitante fora',
        'Current ranking position': 'Ranking atual',
        ' H/A ': 'Ranking virtual baseado nos jogos disputados em casa pelo time da casa e nos jogos disputados fora do time visitante',
        ' Gap1 ': 'É a diferença virtual entre o ranking atual e o ranking em casa pelo time da casa e fora pelo time visitante',
        ' FH ': 'Ranking virtual com base nos resultados do primeiro tempo',
        ' Gap2 ': 'É a diferença virtual entre o ranking atual e o ranking com base nos resultados no primeiro tempo',
        ' SH ': 'Ranking virtual com base nos resultados do segundo tempo',
        ' Gap3 ': 'É a diferença virtual entre o ranking atual e o ranking com base nos resultados no segundo tempo',
        ' Attack ': 'Ranking com base no maior número de gols marcados',
        ' Defense ': 'Ranking com base no menor número de gols sofridos',
        ' Form ': 'Ranking virtual baseado em pontos ganhos nos últimos 6 jogos',
        ' H/A form ': 'Ranking virtual baseado em pontos ganhos nos últimos 6 jogos, em casa pelo time da casa e fora pelo time visitante',

        /* modal window - Standings tab tooltips */

        ' # ': 'Ranking',
        ' PM ': 'Jogos disputados',
        ' W ': 'Vitórias',
        ' D ': 'Empates',
        ' L ': 'Derrotas',
        ' F ': 'Gol marcados',
        ' GA ': 'Gol sofridos',
        ' GD ': 'Diferença de gols',
        ' PW ': 'Pontos',

        /* Player Roles tooltips */

        'GK': 'Goleiro',
        'DEF': 'Defesa',
        'MID': 'Meio-campo',
        'FWD': 'Ataque',

        'GK': 'Goleiro',
        'RB': 'Lateral direito',
        'CB': 'Zagueiro',
        'LB': 'Lateral esquerdo',
        'DM': 'Médio Defensivo',
        'CM': 'Médio Centro',
        'RM': 'Meio-campista Lateral direito',
        'LM': 'Meio-campista Lateral esquerdo',
        'AM': 'Apoiador',
        'LW': "Ala esquerda",
        'RW': "Ala direita",
        'SS': 'Segundo Atacante',
        'CF': 'Centroavante',
        

        /* pre match table - Home */
        /* pre match table - Away */

        'Lineup (pre): ': "Esquema de jogo do time antes do início do jogo",
        'Lineup (live): ': "Esquema de jogo do time durante o jogo",
        'Used:': 'Número e porcentagem de vezes que o esquema de jogo foi usado em jogos anteriores da temporada',
        'Manual: ': 'Selecione manualmente o esquema de jogo se não estiver disponível',
        ' S.Role ': 'Sub-posições do esquema de jogo ',
        ' M.R ': 'Posições base do esquema de jogo',
        ' Line Up Home ': 'Titulares para o time da casa',
        ' Line Up Away ': 'Titulares para o time de fora',
        ' Sub ': 'Minuto de substituição',
        ' Market Value ': 'Valor atual de mercado de cada jogador',
        ' P.M.Role ': 'Posição básica do jogador',
        ' Primary_Role ': 'Sub-posição principal do jogador',
        ' Alt.Role1 ': 'Sub-posição alternativa do jogador',
        ' Alt.Role2 ': 'Sub-posição alternativa do jogador',
        ' PreRate ': 'Índice médio de desempenho do jogador, pré-jogo',
        ' LiveRate ': "Índice médio de desempenho do jogador durante o jogo, a cor muda se o valor for superior (verde) ou menor (vermelho) do que o índice de desempenho pré-jogo",
        ' Titularity % ': 'Porcentagem de aparições do jogador na temporada. Ao lado, o número total de jogos disputados pelo time',

         

        /* Home Team Rating by unit */
        /* Away Team Rating by unit */

        ' average rate pre ': 'Índice de desempenho médio de cada posição, antes do jogo',
        ' average rate live ': 'Índice de desempenho médio de cada posição, ao vivo',
        ' Diff rate pre/live % ': 'Diferença entre os índices de desempenho das posições pré-jogo e ao vivo',

        /* Home VS Away teams by unit */

        ' Pre ': 'Comparação dos índices de desempenho das posições pré-jogo',
        ' Live ': 'Comparação dos índices de desempenho das posições ao vivo',
        ' Diff ': 'Comparação das diferenças entre as posições pré-jogo e ao vivo',    

        /* Home Bench */
        /* Away Bench */

        ' Rating ': 'Índice médio de desempenho do jogador, pré-jogo',
        ' Goal ': 'Número de gols marcados pelo jogador na temporada, com porcentagem de eficacia',
        ' Assist ': 'Número de assistências do jogador na temporada',    
        ' S_Role ': 'Sub-posição principal do jogador',

        /* Total */

        ' On ': 'Finalizações',
        ' Off ': 'Chutes fora',
        ' Blk ': 'Chutes bloqueados',
        ' In ': "Chutes de dentro da área",
        ' Out ': 'Chutes de fora da área',
        ' Cnr ': "Escanteios",
        ' DA ': 'Ataques Perigosos',
        ' Poss ': 'Posse de bola',
        ' Red ': 'Cartões vermelhos',
        ' Yel ': 'Cartões amarelos',
        ' Sbst ': 'Substituçoes',
        ' Ini ': "Índice de eficacia, pode ser negativo ou positivo com base nas estatísticas médias anteriores",
        ' PFM ': 'Índice de desempenho, pode ser negativo ou positivo com base nas estatísticas médias anteriores',

        
        ' Rtg ': 'Rating, índice de pressão e ataque',

        /* Other labels */

        ' 1 X 2 ': 'Probabilidades dos resultados: casa, empate ou fora. Com cotas atualizadas e valor',
        ' O / U ': 'Probabilidades dos próximos Mais / Menos gols, com cotas atualizadas e valor',
        ' Next Goal ': 'Probabilidades dos times marcar o próximo gol: casa, fora ou ninguém',
        ' GB (%) ': 'Probabilidades de um gol ser marcado nos próximos intervalos de tempo',

        /* Modal - historical stats */

        ' Avg Stats Per Game ': 'Estatísticas médias dos jogos anteriores',

        ' P-Number ': 'Número de jogos disputados em casa pelo time da casa e fora pelo time visitante',
        ' Goals ': 'Gols',        
        ' Pos ': 'Posse de bola',
        ' Pas ': 'Passes',
        ' Acc ': 'Precisão dos passes',
        ' Atk ': 'Ataques totais',
        ' Ofs ': 'Impedimentos',
        ' Sav ': 'Bloqueios da defesa',
        ' Sbst ': 'Substituçoes',
        ' Fou ': 'Faltas',
        ' G_att ': 'Tentativas de gol',
        ' Safe ': 'Açoes neutralizadas',
        ' Rtg ': 'Rating, índice de pressão e ataque',

        // cold stats filters
        "League filter": "Filtrar ligas",
        "Leagues": "Ligas",
        "Matches percentage": "Porcentagens ligas",
        "Type to search": "digite para pesquisar",
        "All leagues": "todas as ligas",
        "Prediction filter": "Filtros seleçoes",
        "Time bands filter": "Filtros minutos",
        "Score filter": "Filtros placares",
        "League table filter": "Filtros tabelas das ligas",
        "Home": "Casa",
        "Away": "Fora",
        "Home, Away": "Casa, Fora",
        "Home = Away": "Casa = Fora",
        "Home OR Away": "Casa OU Fora",
        "Home AND Away": "Casa E Fora",
        "Home > Away": "Casa > Fora",
        "Home < Away": "Casa < Fora",
        "Home OR Away > Home OR Away": "Casa OU Fora > Casa OU Fora",
        "None": "Nenhum",

        "Advanced search": "Pesquisa avançada",
        "Search filters": "Aplicar filtros",
        "Clear filters": "Remover filtros", 

        // log in component
        "subscribe now!": "assine agora!",
        "Forgot password? Reset here": "Esqueceu sua senha? Alterar aqui",
        "incorrect password, please try again or reset it": "senha errada, por favor, tente novamente ou tente alterá-la",
        "this username does not exist, please try with another one": "este usuário não existe, por favor, tente outro",
        "this account has expired, please subscribe from the link below": "esta conta expirou, você pode renovar sua assinatura no link abaixo",

        // cold stats filter       

        'Create preset': 'Criar preset',
        'Load preset': 'Carregar preset',
        'Filter name': 'Nome filtro',
        'Save Filter': 'Salvar filtro',
        'Saved filters list': 'Lista filtros criados',
        'Load Filter': 'Carregar filtro',
        'Delete Filter': 'Excluir filtro',
        'Edit Filter': 'Alterar filtro',
        'Update Filter': 'Atualizar filtro',
        "Edit filter name": "Renomear filtro",
        "Filtered list": "Lista filtrada",
        "choose filters": "Escolher filtros",

        "Sorry, no tips available at the moment, please try later": "Não há tips no momento, por favor, tente novamente mais tarde",
        "Post your tip now!": "Publique sua tip!",
        'Settings and profile options': 'Configurações e opções de perfil',
        "Don't ask more in future": "Não perguntar mais",

        "Time min": "Tempo min",
        "Time max": "Tempo max",

        "operational": "modo",

        "home(A), away(B)": "casa(A), fora(B)",
        "favourite(A), underdog(B)": "favorita(A), underdog(B)",
        "winning(A), losing(B)": "ganhando(A), perdendo(B)",

        "sum greater than": "soma maior que",
        "sum minor than": "soma menor que",
        "diff greater than": "diferença maior que",
        "diff minor than": "diferença menor que",

        "Save to My Game": "Salvar nos Meus jogos",
        "Hide search": "Ocultar pesquisa",
        "Apply filters": "Aplicar filtros",
        "Hide load preset": "Ocultar carregar preset",
        "Hide create preset": "Ocultar criar preset",

        "HOW TO RECEIVE ROBOT ALERTS": "COMO RECEBER OS ALERTAS DOS ROBÔS",
        "Be sure to follow the next steps using a device which has installed Telegram app. Can be any device: PC, smartphone or anything else.": "Verifique se o dispositivo que você está usando possui o aplicativo Telegram instalado. Você pode usar qualquer dispositivo: PC, smartphone ou outros.",
        "To get your telegram user ID please click on the following link:": "Para obter o seu 'ID de usuário do Telegram', clique no link abaixo:",
        "Click on 'Send message'. Then write '/start'. You'll see your ID which is composed by 9 numbers.": "Clique em 'Send message'. Então escreva '/start'. Você receberá uma mensagem com seu ID de nove dígitos.",
        "Copy the ID number and put it in the 'telegram user ID' form above.": "Copie o número de 9 dígitos e coloque-o no campo 'telegram user ID' acima.",
        "Then save button below": "Ative as notificações no botão 'ativar notificações' e, por fim, clique no botão 'Salvar' na parte inferior da janela.",
        "Please click on the link below to access to 'Goal Traders RoBot' and receive alerts from the robots:": "Clique no link abaixo para acessar o 'Goal Traders RoBot' e receber os alertas:",
        "Then, click on 'Send message', then write '/start', alerts will come soon as they are available.": "Em seguida, clique em 'Send message', escreva '/start'. Parabéns, os alertas começarão a chegar assim que estiverem disponíveis.",
        "For further help please watch the video in the tutorials area:": "Para mais ajuda, você pode consultar o vídeo específico na área tutorial:",
        "You can stop/start to receive notification at any time just turning off/on the button 'active notification' above.": "Você pode desativar/reativar as notificações do Telegram a qualquer momento a partir do botão 'ativar notificações' acima. ",
        'Active notification': 'Ativar notificações',

        //personal stats page
        "home fh": "casa pt",
        "draw fh": "empate pt",
        "away fh": "fora pt",
        "Second Half Overs %": "Mais gols segundo tempo %",
        "0.5 SH": "0.5 ST",
        "1.5 SH": "1.5 ST",
        "2.5 SH": "2.5 ST",
        "1st goal avg min": "minuto primeiro gol",

        //financial strategy page
        "Back increment %": "Back aument. %",
        "Lay increment %": "Lay aument. %",
        "min odd": "cota min",
        "max odd": "cota max",
        "tot bets filtered": "operações totais",
        "liability": "risco",
        "payout": "pagamento",
        "Swap Result": "Swap Placares",
        "Without CO": "Excluir CO",
        "Leverage stake": "Aposta fixa",
        "start bankroll": "Budget inicial",
        "size %": "size %",
        "Gross profit": "Lucro bruto",
        "Gross loss": "Perdas brutas",
        "Profit factor": "Profit factor",
        "DDMAX %": "DDMAX %",
        "Net Profit": "Lucro liquido",
        "investimento": "investimento",
        "ROI": "ROI",
        "ROE": "ROE",
        "Avg Odd": "Cota média",
        "W/Rate": "W/Rate",
        "Single bets list": "Lista operações",
        "tip": "tip",
        "cover": "cobertura",
        "Post Date": "Data",
        "P/L Points": "L/P Pontos",
        "P/L Leverage stake": "L/P Aposta fixa",
        "P/L compounding": "L/P Compounding",
        "Lay (Payout)": "Lay (Pagamento)",
        "Lay (liability)": "Lay (Risco)",
        "Prediction": "Prognóstico",
        "Bet Side": "Back/Lay",
        "tip/cover": "tip/cobertura",
        "Entry min": "Minuto de entrada",
        "Cash out": "Cash out",
        "Bet 365 Entry": "Cota de entrada",
        "Bet 365 CO Odds": "Cota de Cash out",
        "stake": "Aposta Pt",
        "Back Odd": "Cota Back",
        "Lay Odd": "Cota Lay",
        "Outcome": "Resultado",
        "Lay Risk": "Risco Lay",
        "Payout": "Pagamento",
        "liab stake": "Aposta risco",
        "liab risk": "Risco",
        "Liability": "Risco",
        "current Bank": "Budget atual",
        "stake Back": "Aposta Back",
        "draw Down": "Draw Down",
        "stake Lay": "Aposta Risco",
        "lay risk": "Risco Lay",
        "Without Cover": "Excluir cobertura",


        //weather report
        "Weather": "Tempo",
        "Temperature": "Temperatura",
        "Clouds": "Nuvens",
        "Humidity": "Umidade",
        "Pressure": "Pressão atmosférica",
        "Wind": "Vento",
        "Coordidates": "Coordenadas",

        "clear sky": "céu limpo",
        "few clouds": "pouco nublado",
        "scattered clouds": "nuvens espalhadas",
        "broken clouds": "nuvens espalhadas",
        "shower rain": "chuva constante",
        "rain": "chuva",
        "thunderstorm": "trovoada",
        "snow": "neve",
        "mist": "névoa",
        "clouds": "nublado",
        "moderate rain": "chuva moderada",
        "haze": "neblina",
        "light intensity shower rain": "chuva leve contínua",
        "light rain": "chuva leve",
        "overcast clouds": "coberto",
        "light intensity drizzle": "chuvisco de leve intensidade",
        "fog": "névoa",
        "heavy intensity rain": "chuva pesada",
        "thunderstorm with light rain": "trovoada com chuva fraca",
        "thunderstorm with rain": "trovoada com chuva",
        "drizzle": "chuvisco",
        "heavy intensity drizzle": "chuvisco de grande intensidade",
        "light intensity drizzle rain": "chuvisco de leve intensidade",
        "drizzle rain": "chuvisco",
        "heavy intensity drizzle rain": "chuvisco de grande intensidade",
        "shower rain and drizzle": "chuva constante e chuvisco",
        "heavy shower rain and drizzle": "chuva constante pesada e chuvisco",
        "shower drizzle": "chuvisco constante",
        "light snow": "queda de neve leve",
        "snow": "queda de neve",
        "heavy snow": "queda de neve pesada",
        "sleet":"granizo",
        "light shower sleet": "granizo constante leve",
        "shower sleet": "granizo constante",
        "light rain and snow": "chuva fraca e neve",
        "rain and snow": "chuva e neve",
        "light shower snow": "queda de neve constante leve",
        "shower snow": "queda de neve constante",
        "heavy shower snow": "queda de neve constante pesada",


        "Venue": "Estádio",
        "name": "nome",
        "surface": "superfície", 
        "city": "cidade",
        "capacity": "capacidade",
        "grass": "grama",

        "Home team coach": "Técnico do time da casa",
        "Away team coach": "Técnico do time de fora",
        "Common name": "Nome",
        "Nationality": "Nacionalidade",

        //money management
        "Save progresses": "Salvar progressos",
        "Strategy Name": "Nome Estratégia",
        "Strikes left": "Etapas restantes",
        "New": "Novo",
        "Target": "Meta",
        "richieste": "definidas",
        "N. prese": "N. etapas",
        "ROI ($)": "Igual a",
        "Max. Risk": "Max. Risco",
        "Achieved": "alcançado",
        "Current": "Atual",
        "Won:Part": "Vencidas : Parc.",
        "Won": "Vencidas",
        "Loss:Part": "Perdidas : Parc.",
        "Loss": "Perdidas",
        "Stake": "Aposta",
        "Real profit": "Lucro real",
        "Max gross": "Lucro bruto",
        "profit.": "Potencial",
        "profit": "lucro",
        "Net profit": "Lucro liquido",
        "Progressive": "Progress.",
        "Current.": "Budget",
        "bank": "Atual",
        "Success!": "Feito!",
        "Create new money management data succesfully": 'Novo money management criado!',
        "End": "Fim",
        "L ": "P",
        "Annulla": "Cancelar",
        "Yes": "Sim",
        "No": "Não",

        "Team vs Team": "Time vs Time",
        "Season": "Temporada",

        "Select Season...": "Selecionar  Temporada...",
        "Select League...": "Selecionar  Liga...",
        "Select Home...": "Selecionar  Casa...",
        "Select Away...": "Selecionar  Fora...",
        "Please select your teams": "Por favor selecione os times",
        "current season": "temporada atual",
        "last season": "temporada passada",

        'Operations By League': 'Operações por liga',
        "Sample": "Amostra",
        "avg Odds Bet365": "Média cotas Bet365",
        "avg Entry odds": "Média cotas entrada",
        "avg CO odds": "Média cotas CO",
        "Entry": "Entrata",
        "current": "atual",
        "best": "melhor",
        "worst": "pior",
        "Profits in row": "Lucros consecutivos",
        "Losses in row": "Perdas Consecutivas",
        "Last Bet (W or L)": "última operação",
        "avg": "media",
        "trend 1": "freq 1",
        "trend 2": "freq 2",

        //search stats page
         "Search filters": "Search filters",
         "League": "League",
         "Type to search": "Type to search",
         "Press enter to select": "Click to select",
         "Press enter to remove": "Click to remove",
         "Season": "Season",
         "select season": "select season",
         "Current season": "Current season",
         "Last 2 seasons": "Last 2 seasons",
         "Last 3 seasons": "Last 3 seasons",
         "Last 4 seasons": "Last 4 seasons",
         "Last 5 seasons": "Last 5 seasons",
         "Team": "Team",
         "All teams": "All teams",
         "Selected":"Selected",
         "Role": "Home/Away",
         "Both": "Both",
         "Odds filters": "Odds filters",
         "Over odds": "Over odds",
         "Under odds": "Under odds",
         "Results Filter": "Results Filter",
         "From minute": "From minute",
         "To minute": "To minute",
         "Odd ": "Odd",
         "Even": "Even",
         "Score time Filter": "Score time Filter",
         "Result at 15'": "Result at 15'",
         "Result at 30'": "Result at 30'",
         "Result at HT'": "Result at HT'",
         "Result at 60'": "Result at 60'",
         "Result at 75'": "Result at 75'",
         "Result at FT'": "Result at FT'",
         "Home Score": "Home Score",
         "Away Score": "Away Score",
         "Home Live stats filter": "Home Live stats filter",
         "From": "From minute",
         "To": "To minute",
         "Away Live stats filter": "Away Live stats filter",
         "Get Data": "Get Data",
         "Results": "Results",
         "Sample Size": "Sample Size",
         "View Matches": "View Matches",
         "First Half and Second Half Markets": "First Half and Second Half Markets",
         "First Half Markets": "First Half Markets",
         "Match Odds (Half Time Market)": "Match Odds (Half Time Market)",
         "First Half goals 0.5": "First Half goals 0.5",
         "First Half goals 1.5": "First Half goals 1.5",
         "First Half goals 2.5": "First Half goals 2.5",
         "Probability%": "Probability%",
         "Half Time Score": "Half Time Score",
         "Home win": "Home win",
         "Away Win": "Away Win",
         "AUQ": "AUQ",
         "2nd Half Only": "2nd Half Only",
         "2nd Half Match Odd": "2nd Half Match Odd",
         "Full Match Markets": "Full Match Markets",
         "Full Time Main Markets": "Full Time Main Markets",
         "Main Odds": "Main Odds",
         "Next Goal": "Next Goal",
         "Yes": "Yes",
         "No": "No",
         "Over/Under 0.5": "Over/Under 0.5",
         "Over/Under 1.5": "Over/Under 1.5",
         "Over/Under 2.5": "Over/Under 2.5",
         "Over/Under 3.5": "Over/Under 3.5",
         "Over/Under 4.5": "Over/Under 4.5",
         "Correct Score": "Correct Score",
         "AOHW": "AOHW",
         "AOD": "AOD",
         "AOAW": "AOAW",
         "Stats by Segment Times": "Stats by Segment Times",
         "League stats": "League stats",
         "Filter": "Filter",
         "type string...": "type string...",
         "Avg Odd, ROI by Leagues": "Avg Odd, ROI by Leagues",
         "Avg Odd, ROI by Teams": "Avg Odd, ROI by Teams",
         "Next Games": "Próximos jogos",
         "From date": "da data",
         "To date": "até data",
         "No items": "No items",
         "Chart and stats": "Chart and stats",
         "Market": "Market",
         "Home - FT": "Home - FT",
         "Away - FT": "Away - FT",
         "Draw - FT": "Draw - FT",
         "Home - HT": "Home - HT",
         "Away - HT": "Away - HT",
         "Draw - HT": "Draw - HT",
         "Over - 0.5 - FT": "Over - 0.5 - FT",
         "Over - 1.5 - FT": "Over - 1.5 - FT",
         "Over - 2.5 - FT": "Over - 2.5 - FT",
         "Over - 3.5 - FT": "Over - 3.5 - FT",
         "Under - 0.5 - FT": "Under - 0.5 - FT",
         "Under - 1.5 - FT": "Under - 1.5 - FT",
         "Under - 2.5 - FT": "Under - 2.5 - FT",
         "Under - 3.5 - FT": "Under - 3.5 - FT",
         "Over - 0.5 - HT": "Over - 0.5 - HT",
         "Over - 1.5 - HT": "Over - 1.5 - HT",
         "Under - 0.5 - HT": "Under - 0.5 - HT",
         "Under - 1.5 - HT": "Under - 1.5 - HT",
         "BTS - FT": "BTS - FT",
         "No BTS - FT": "No BTS - FT",
         "Filter": "Filter",
         "Apply": "Apply",
         "Cancel": "Cancel",
         "League table filter": "League table filter",
         "Team table filter": "Team table filter",
         "Total sample": "Total sample",
         "Operations per month": "Operations per month",
         "Avg Odd": "Avg Odd",
         "Profit PTS":"Profit PTS",
          //Historical data

        "Select date": "Selecionar data",
        "from": "desde",
        "to": "até",
        "year": "ano",
        "month": "mês",
        "day": "dia",
        "League": "Liga",
        "select league": "selecionar liga",
        "Search": "Pesquisar",
        "Reset": "Reset",
        "Team": "Time",
        "Home/Away": "Casa/Fora",
        "select team": "selecionar time",
        "Event Name": "Jogo",
        "select event": "selecionar jogo",
        "Market Name": "Nome mercado",
        "select market": "selecionar mercado",
        "MATCH_ODDS": "RESULTADO FINAL",
        "HALF_TIME": "1° TEMPO",
        "FIRST_HALF_GOALS_05": "1° TEMPO MAIS/MENOS 0.5",
        "OVER_UNDER_05": "MAIS/MENOS 0.5",
        "OVER_UNDER_15": "MAIS/MENOS 1.5",
        "OVER_UNDER_25": "MAIS/MENOS 2.5",
        "OVER_UNDER_35": "MAIS/MENOS 3.5",
        "event Name": "Nome jogo",
        "event Id": "Id jogo",
        "Market Id": "Id mercado",
        "Market Type": "Tipo mercado",
        "League": "Liga",
        "Market Info": "Info mercado",
        "Home": "Casa",
        "Away": "Fora",
        "Draw": "Empate",
        "Runner Id": "Runner Id",
        "Status": "Status",
        "InPlay": "AoVivo",
        "Time": "Tempo",
        "Price": "Odd",
        "OPEN": "ABERTO",
        "SUSPENDED": "SUSPENSO",
        "false": "Sim",
        "true": "Não",
        "Prematch": "Pré-jogo",
        "First Half": "Primeiro tempo",
        "Interval": "Intervalo",
        "Second Half": "Segundo tempo",

        "Comparison filter Home/Away": "Comparison filter Home/Away",
        "Clear fields": "Clear fields",
        "Filter updated successfully": "Filter updated successfully",
        'Show firsts': 'Mostrar primeiros',

        "Investments": "Investimentos",

        //investments page
        "Favorite": "Favorido",
        "today": "hoje",
        "tomorrow": "amanhã",
        'Competition ': 'Liga',
        "Time ": "Hora de início",
        "event": "Jogo",
        "Stats Last 10 Chance": "Estatísticas dos últimos 10 jogos",
        "Fav Label Best Bet": "Favorido Pontos e Melhor Bet",
        "fav Label": "Tipo Bet",
        "Match Odds": "Odds Resultado Final",

        "Fixture": "Encontro",
        "Home Back": "Casa Back",
        "Home Lay": "Casa Lay",
        "Draw Back": "Empate Back",
        "Draw Lay": "Empate Lay",
        "Away Back": "Fora Back",  
        "Away Lay": "Fora Lay",     

        // investments main
       "SuperCompetative": "SuperCompetitiva",
        
        //wrong to adjust the original labels -->> 
        "Bookie Pts and ROI": "ROI e Pontos",
        "lay price is calculated by adding 3% onto back price":  "a odd do lado lay è calculado aumentando o preço do lado back em 3%",
        //end adjustments
        
        'Averages for League and Last 20, 10, 5 matches': 'Médias da Liga e dos últimos 20, 10, 5 jogos',
        "League Averages": "Média Liga",
        "Team Favorite (Based on start odds)": "Média por tipo de partida",
        "Implied Odds": "Odds Implícitas",
        "home": "casa",
        "away": "fora",
        "Chance": "Chance",
        "Last 20 matches - Long Term": "Últimos 20 jogos - Longo Prazo",
        "Last 10 matches - Medium Term": "Últimos 10 jogos - Médio Prazo",
        "Last 5 matches - Short Term": "Últimos 5 jogos - Curto Prazo",

        "LayHome": "Lay Casa",
        "LayAway": "Lay Fora",
        "BackHome": "Back Casa",
        "BackAway": "Back Fora",
        "LayDraw": "Lay Empate",
        "BackDraw": "Back Empate",

    },

    'es': {
        match_main: 'Match',
        select_match_main: 'Select Match',
        coming_up_main: 'Coming Up',

        // investments main
        "Equilibrata": "Competitive",
        "Ospite_med_fav": "Away_med_fav",
        "Ospite_min_fav": "Away_min_fav",
        "Casa_med_fav": "Home_med_fav",
        "Casa_min_fav": "Home_min_fav",
        "Ospite_max_fav": "Away_max_fav",
        "Casa_max_fav":"Home_max_fav",

        /* === label tooltip === */
        ' H ': 'Home team',
        ' A ': 'Away team',
        ' P ': 'Played matches for local team at home and played matches for visitor team away.',
        ' 0 - 0 ': 'Percentage of matches that went 0 - 0 for local team at home and for visitor team away.',
        ' Ov. 1.5 ': 'Percentage of matches that went over than 1.5 total goals for local team at home and for visitor team away.',
        ' Ov. 2.5 ': 'Percentage of matches that went over than 2.5 total goals for local team at home and for visitor team away.',
        ' Ov. 3.5 ': 'Percentage of matches that went over than 3.5 total goals for local team at home and for visitor team away.',
        ' Scored ': 'Percentage of the matches that a team scored at aleast a goal, local team at home and visitor team away.',
        ' Conc ': 'Percentage of the matches that a team conceded at aleast a goal, local team at home and visitor team away.',
        ' BTS ': 'Percentage of the matches that both teams scored a goal, local team at home and visitor team away.',
        ' 1 + 1st ': 'Percentage of the matches with at least 1 goal in the first half, local team at home and visitor team away.',
        ' 2 + 1st ': 'Percentage of the matches with at least 2 goals in the first half, local team at home and visitor team away.',
        ' 1 + 2st ': 'Percentage of the matches with at least 1 goal in the second half, local team at home and visitor team away.',
        ' 2 + 2st ': 'Percentage of the matches with at least 2 goals in the second half, local team at home and visitor team away.',
        ' Red card ': 'To filter the matches with at least a Red card, on first or second half or on both halves.',
        ' Show last ': 'To filter the last matches played',
        ' Home lineup ': 'To filter the matches played by the local team with a particular lineup',
        ' Away lineup ': 'To filter the matches played by the visitor team with a particular lineup',
        ' Home team ': 'To filter the matches played by the local team against visitor team with a particular rank',
        ' Away team ': 'To filter the matches played by the visitor team against local team with a particular rank',

        ' G+ ': 'Amount of goals scored by the local team at home and visitor team away',
        ' G- ': 'Amount of goals conceded by the local team at home and visitor team away',
        ' 0 - 15 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 16 - 30 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 31 - 45 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 46 - 60 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 61 - 75 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 76 - 90 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' GS1 ': 'Percentage of goals scored in the first half by the local team at home and visitor team away',
        ' GS2 ': 'Percentage of goals scored in the second half by the local team at home and visitor team away',
        ' GC1 ': 'Percentage of goals conceded in the first half by the local team at home and visitor team away',
        ' GC2 ': 'Percentage of goals conceded in the second half by the local team at home and visitor team away',
        ' 40+ ': 'Percentage of matches in which they scored at least 1 goal in the last 5 minutes of the first half',
        ' 85+ ': 'Percentage of matches in which they scored at least 1 goal in the last 5 minutes of the second half',
        ' H_AVG ': 'Average between percentages of matches won by the local team at home and lost by the visitor team away.',
        ' D_AVG ': 'Average between percentages of matches drawn by the local team at home and drawn by the visitor team away.',
        ' A_AVG ': 'Average between percentages of matches lost by the local team at home and won by the visitor team away.',
        ' 1-0 ': 'Average between percentages of matches that went on 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 1-1 ': 'Average between percentages of matches that went on 1-1 after starting 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 2-0 ': 'Average between percentages of matches that went on 2-0 after starting 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 0-1 ': 'Average between percentages of matches that went on 0-1 allowed by local team at home and scored by the visitor team away.',
        ' 1-1_2 ': 'Average between percentages of matches that went on 1-1 after starting 0-1 allowed by local team at home and scored by visitor team away.',
        ' 0-2 ': 'Average between percentages of matches that went on 0-2 after starting 0-1 allowed by local team at home and scored by visitor team away.',
        ' First ': 'Percentages of matches in which a team scores the first goal, local team at home and visitor team away',
        ' Last ': 'Percentages of matches in which a team scores the last goal, local team at home and visitor team away',
        ' 2+ ': 'Average between percentages of matches that went 2 goals ahead at any moment of the game, scored for local team and allowed for visitor team',
        ' 2- ': 'Average between percentages of matches that went 2 goals down at any moment of the game, conceded for local team and scored for visitor team',
        ' H 1st ': 'Average between percentages of matches won in the first half by the local team at home and lost by the visitor team away.',
        ' D 1st ': 'Average between percentages of matches drawn in the first half by the local team at home and drawn by the visitor team away.',
        ' A 1st ': 'Average between percentages of matches lost in the first half by the local team at home and won by the visitor team away.',
        ' H 2nd ': 'Average between percentages of matches won in the second half by the local team at home and lost by the visitor team away.',
        ' D 2nd ': 'Average between percentages of matches drawn in the second half by the local team at home and drawn by the visitor team away.',
        ' A 2nd ': 'Average between percentages of matches lost in the second half by the local team at home and won by the visitor team away.',
        'Current ranking position': 'Current ranking position',
        ' H/A ': 'Virtual ranking position considering matches played at home by the local team, and matches played away by the visitor team only',
        ' Gap1 ': 'Its the virtual gap between the current ranking and H/A Ranking',
        ' FH ': 'Virtual ranking position considering matches results at the end of the first half',
        ' Gap2 ': 'Its the virtual gap between the current ranking and FH Ranking',
        ' SH ': 'Virtual ranking position considering matches results at the end of the second half',
        ' Gap3 ': 'Its the virtual gap between current ranking and SH Ranking',
        ' Attack ': 'Virtual ranking position considering the higher number of goals scored by a team',
        ' Defense ': 'Virtual ranking position considering the smaller number of goals allowed by a team',
        ' Form ': 'Virtual ranking position considering the points won in the last 6 matches, overall',
        ' H/A form ': 'Virtual ranking position considering the points won in the last 6 matches, at home by local team and away by visitor team ',

        /* modal window - Standing tab */

        ' # ': 'Ranking position',
        ' PM ': 'Played matches',
        ' W ': 'Victories',
        ' D ': 'Draws',
        ' L ': 'Lost',
        ' F ': 'Goals scored',
        ' GA ': 'Goals allowed',
        ' GD ': 'Goal difference',
        ' PW ': 'Points won',

        /* Player Roles tooltips */

        'GK': 'Goalkeeper',
        'DEF': 'Defender',
        'MID': 'Midfielder',
        'FWD': 'Forward',

        'GK': 'Goalkeeper',
        'RB': 'Right fullback',
        'CB': 'Center back',
        'LB': 'Left fullback',
        'DM': 'Defending midfielder',
        'CM': 'Central midfielder',
        'RM': 'Right midfielder',
        'LM': 'Left midfielder',
        'AM': 'Attacking midfielder',
        'LW': 'Left winger',
        'RW': 'Right winger',
        'SS': 'Second striker',
        'CF': 'Central forward',

        /* pre match table - Home */
        /* pre match table - Away */

        'Lineup (pre): ': 'Lineup of the team before the match starts',
        'Lineup (live): ': 'Lineup of the team in play',
        'Used:': 'Amount and percentage of the times that such lineup has been used in the last events',
        'Manual: ': 'Select manually the lineup in case is not available',
        ' S.Role ': 'Specific Roles of the lineup',
        ' M.R ': 'Main roles of the lineup',
        ' Line Up Home ': 'List of the players on the pitch for home team',
        ' Line Up Away ': 'List of the players on the pitch for away team',
        ' Sub ': 'minute of substitution',
        ' Market Value ': 'current price value on market for each player',
        ' P.M.Role ': 'Main role of the player',
        ' Primary_Role ': 'Primary specific role of the player',
        ' Alt.Role1 ': 'Alternative role of the player',
        ' Alt.Role2 ': 'Alternative role of the player',
        ' PreRate ': 'Average index of performance of the player pre-match',
        ' LiveRate ': 'Index of performance of the player inplay, it changes color if a player is playing better (green) or worse (red) than usual',
        ' Titularity % ': "Percentage of the appearances in the current season, beside it there's total events amount",

        /* Home Bench */
        /* Away Bench */

        ' Rating ': 'Average index of performance of the player pre-match',
        ' Goal ': 'Amount of goals scored in the current season by the player, with incisivity percentage',
        ' Assist ': 'Amount of assistance provided by the player in the current season',
        ' S_Role ': 'Primary specific role of the player',

        /* Home Team Rating by unit */
        /* Away Team Rating by unit */

        ' average rate pre ': 'Average rating of each unit pre match',
        ' average rate live ': 'Average rating of each unit in play',
        ' Diff rate pre/live % ': 'Difference between pre match and live rating units',

        /* Home VS Away teams by unit */

        ' Pre ': 'Pre-match rating comparison between teams units',
        ' Live ': 'Inplay rating comparison between teams units',
        ' Diff ': 'Inplay comparison of the differences between pre match and live rating units of the teams',

        /* Total */

        ' On ': 'Shots on target',
        ' Off ': 'Shots off target',
        ' Blk ': 'Shots blocked',
        ' In ': 'Shots inside the penalty area',
        ' Out ': 'Shots outside the penalty area',
        ' Cnr ': 'Corners',
        ' DA ': 'Dangerous attacks',
        ' Poss ': 'Ball possesion',
        ' Red ': 'Red cards',
        ' Yel ': 'Yellow cards',
        ' Sbst ': 'Substitutions',
        ' Ini ': 'Incisivity index, can be negative or positive depending on the past average incisivity',
        ' PFM ': 'Performance index, can be negative or positive depending on the past average performances',
        
        ' Goal ': 'Goals scored',
        ' Rtg ': 'Rating, attack and forcing index',

        /* Other labels */

        ' 1 X 2 ': 'Home, draw or away final time chances, with current odds and values',
        ' O / U ': 'nexts Over and Under chances, with currents odds and values',
        ' Next Goal ': 'Next goal chances for home, away or none',
        ' GB (%) ': 'Chances to have a goal in the nexts time bands',

        /* Modal - historical stats */

        ' Avg Stats Per Game ': 'Average statistics of the matches played',

        ' P-Number ': 'Number of matches played at home for home team, and away for visitor team',        
        ' On ': 'Shots on target',
        ' Off ': 'Shots off target',
        ' Blk ': 'Shots blocked',
        ' In ': 'Shots inside the penalty area',
        ' Out ': 'Shots outside the penalty area',
        ' Cnr ': 'Corners',
        ' DA ': 'Dangerous attacks',
        ' Pos ': 'Ball possesion',
        ' Pas ': 'Passagges',
        ' Acc ': 'Passagges accuracy',
        ' Atk ': 'Total attacks',
        ' Ofs ': 'Offsides',
        ' Sav ': 'Saves by the defense',
        ' Sbst ': 'Substitutions',
        ' Fou ': 'Fouls',
        ' G_att ': 'Goal attempts',
        ' Safe ': 'Ball safe',
        ' Rtg ': 'Rating, attack and forcing index'


    },

    'fr': {
        match_main: 'Match',
        select_match_main: 'Select Match',
        coming_up_main: 'Coming Up',

        /* === label tooltip === */
        ' H ': 'Home team',
        ' A ': 'Away team',
        ' P ': 'Played matches for local team at home and played matches for visitor team away.',
        ' 0 - 0 ': 'Percentage of matches that went 0 - 0 for local team at home and for visitor team away.',
        ' Ov. 1.5 ': 'Percentage of matches that went over than 1.5 total goals for local team at home and for visitor team away.',
        ' Ov. 2.5 ': 'Percentage of matches that went over than 2.5 total goals for local team at home and for visitor team away.',
        ' Ov. 3.5 ': 'Percentage of matches that went over than 3.5 total goals for local team at home and for visitor team away.',
        ' Scored ': 'Percentage of the matches that a team scored at aleast a goal, local team at home and visitor team away.',
        ' Conc ': 'Percentage of the matches that a team conceded at aleast a goal, local team at home and visitor team away.',
        ' BTS ': 'Percentage of the matches that both teams scored a goal, local team at home and visitor team away.',
        ' 1 + 1st ': 'Percentage of the matches with at least 1 goal in the first half, local team at home and visitor team away.',
        ' 2 + 1st ': 'Percentage of the matches with at least 2 goals in the first half, local team at home and visitor team away.',
        ' 1 + 2st ': 'Percentage of the matches with at least 1 goal in the second half, local team at home and visitor team away.',
        ' 2 + 2st ': 'Percentage of the matches with at least 2 goals in the second half, local team at home and visitor team away.',
        ' Red card ': 'To filter the matches with at least a Red card, on first or second half or on both halves.',
        ' Show last ': 'To filter the last matches played',
        ' Home lineup ': 'To filter the matches played by the local team with a particular lineup',
        ' Away lineup ': 'To filter the matches played by the visitor team with a particular lineup',
        ' Home team ': 'To filter the matches played by the local team against visitor team with a particular rank',
        ' Away team ': 'To filter the matches played by the visitor team against local team with a particular rank',

        ' G+ ': 'Amount of goals scored by the local team at home and visitor team away',
        ' G- ': 'Amount of goals conceded by the local team at home and visitor team away',
        ' 0 - 15 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 16 - 30 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 31 - 45 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 46 - 60 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 61 - 75 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 76 - 90 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' GS1 ': 'Percentage of goals scored in the first half by the local team at home and visitor team away',
        ' GS2 ': 'Percentage of goals scored in the second half by the local team at home and visitor team away',
        ' GC1 ': 'Percentage of goals conceded in the first half by the local team at home and visitor team away',
        ' GC2 ': 'Percentage of goals conceded in the second half by the local team at home and visitor team away',
        ' 40+ ': 'Percentage of matches in which they scored at least 1 goal in the last 5 minutes of the first half',
        ' 85+ ': 'Percentage of matches in which they scored at least 1 goal in the last 5 minutes of the second half',
        ' H_AVG ': 'Average between percentages of matches won by the local team at home and lost by the visitor team away.',
        ' D_AVG ': 'Average between percentages of matches drawn by the local team at home and drawn by the visitor team away.',
        ' A_AVG ': 'Average between percentages of matches lost by the local team at home and won by the visitor team away.',
        ' 1-0 ': 'Average between percentages of matches that went on 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 1-1 ': 'Average between percentages of matches that went on 1-1 after starting 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 2-0 ': 'Average between percentages of matches that went on 2-0 after starting 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 0-1 ': 'Average between percentages of matches that went on 0-1 allowed by local team at home and scored by the visitor team away.',
        ' 1-1_2 ': 'Average between percentages of matches that went on 1-1 after starting 0-1 allowed by local team at home and scored by visitor team away.',
        ' 0-2 ': 'Average between percentages of matches that went on 0-2 after starting 0-1 allowed by local team at home and scored by visitor team away.',
        ' First ': 'Percentages of matches in which a team scores the first goal, local team at home and visitor team away',
        ' Last ': 'Percentages of matches in which a team scores the last goal, local team at home and visitor team away',
        ' 2+ ': 'Average between percentages of matches that went 2 goals ahead at any moment of the game, scored for local team and allowed for visitor team',
        ' 2- ': 'Average between percentages of matches that went 2 goals down at any moment of the game, conceded for local team and scored for visitor team',
        ' H 1st ': 'Average between percentages of matches won in the first half by the local team at home and lost by the visitor team away.',
        ' D 1st ': 'Average between percentages of matches drawn in the first half by the local team at home and drawn by the visitor team away.',
        ' A 1st ': 'Average between percentages of matches lost in the first half by the local team at home and won by the visitor team away.',
        ' H 2nd ': 'Average between percentages of matches won in the second half by the local team at home and lost by the visitor team away.',
        ' D 2nd ': 'Average between percentages of matches drawn in the second half by the local team at home and drawn by the visitor team away.',
        ' A 2nd ': 'Average between percentages of matches lost in the second half by the local team at home and won by the visitor team away.',
        'Current ranking position': 'Current ranking position',
        ' H/A ': 'Virtual ranking position considering matches played at home by the local team, and matches played away by the visitor team only',
        ' Gap1 ': 'Its the virtual gap between the current ranking and H/A Ranking',
        ' FH ': 'Virtual ranking position considering matches results at the end of the first half',
        ' Gap2 ': 'Its the virtual gap between the current ranking and FH Ranking',
        ' SH ': 'Virtual ranking position considering matches results at the end of the second half',
        ' Gap3 ': 'Its the virtual gap between current ranking and SH Ranking',
        ' Attack ': 'Virtual ranking position considering the higher number of goals scored by a team',
        ' Defense ': 'Virtual ranking position considering the smaller number of goals allowed by a team',
        ' Form ': 'Virtual ranking position considering the points won in the last 6 matches, overall',
        ' H/A form ': 'Virtual ranking position considering the points won in the last 6 matches, at home by local team and away by visitor team ',

        /* modal window - Standing tab */

        ' # ': 'Ranking position',
        ' PM ': 'Played matches',
        ' W ': 'Victories',
        ' D ': 'Draws',
        ' L ': 'Lost',
        ' F ': 'Goals scored',
        ' GA ': 'Goals allowed',
        ' GD ': 'Goal difference',
        ' PW ': 'Points won',

        /* Player Roles tooltips */

        'GK': 'Goalkeeper',
        'DEF': 'Defender',
        'MID': 'Midfielder',
        'FWD': 'Forward',

        'GK': 'Goalkeeper',
        'RB': 'Right fullback',
        'CB': 'Center back',
        'LB': 'Left fullback',
        'DM': 'Defending midfielder',
        'CM': 'Central midfielder',
        'RM': 'Right midfielder',
        'LM': 'Left midfielder',
        'AM': 'Attacking midfielder',
        'LW': 'Left winger',
        'RW': 'Right winger',
        'SS': 'Second striker',
        'CF': 'Central forward',

        /* pre match table - Home */
        /* pre match table - Away */

        'Lineup (pre): ': 'Lineup of the team before the match starts',
        'Lineup (live): ': 'Lineup of the team in play',
        'Used:': 'Amount and percentage of the times that such lineup has been used in the last events',
        'Manual: ': 'Select manually the lineup in case is not available',
        ' S.Role ': 'Specific Roles of the lineup',
        ' M.R ': 'Main roles of the lineup',
        ' Line Up Home ': 'List of the players on the pitch for home team',
        ' Line Up Away ': 'List of the players on the pitch for away team',
        ' Sub ': 'minute of substitution',
        ' Market Value ': 'current price value on market for each player',
        ' P.M.Role ': 'Main role of the player',
        ' Primary_Role ': 'Primary specific role of the player',
        ' Alt.Role1 ': 'Alternative role of the player',
        ' Alt.Role2 ': 'Alternative role of the player',
        ' PreRate ': 'Average index of performance of the player pre-match',
        ' LiveRate ': 'Index of performance of the player inplay, it changes color if a player is playing better (green) or worse (red) than usual',
        ' Titularity % ': "Percentage of the appearances in the current season, beside it there's total events amount",

        /* Home Bench */
        /* Away Bench */

        ' Rating ': 'Average index of performance of the player pre-match',
        ' Goal ': 'Amount of goals scored in the current season by the player, with incisivity percentage',
        ' Assist ': 'Amount of assistance provided by the player in the current season',
        ' S_Role ': 'Primary specific role of the player',

        /* Home Team Rating by unit */
        /* Away Team Rating by unit */

        ' average rate pre ': 'Average rating of each unit pre match',
        ' average rate live ': 'Average rating of each unit in play',
        ' Diff rate pre/live % ': 'Difference between pre match and live rating units',

        /* Home VS Away teams by unit */

        ' Pre ': 'Pre-match rating comparison between teams units',
        ' Live ': 'Inplay rating comparison between teams units',
        ' Diff ': 'Inplay comparison of the differences between pre match and live rating units of the teams',

        /* Total */

        ' On ': 'Shots on target',
        ' Off ': 'Shots off target',
        ' Blk ': 'Shots blocked',
        ' In ': 'Shots inside the penalty area',
        ' Out ': 'Shots outside the penalty area',
        ' Cnr ': 'Corners',
        ' DA ': 'Dangerous attacks',
        ' Poss ': 'Ball possesion',
        ' Red ': 'Red cards',
        ' Yel ': 'Yellow cards',
        ' Sbst ': 'Substitutions',
        ' Ini ': 'Incisivity index, can be negative or positive depending on the past average incisivity',
        ' PFM ': 'Performance index, can be negative or positive depending on the past average performances',
        
        ' Goal ': 'Goals scored',
        ' Rtg ': 'Rating, attack and forcing index',

        /* Other labels */

        ' 1 X 2 ': 'Home, draw or away final time chances, with current odds and values',
        ' O / U ': 'nexts Over and Under chances, with currents odds and values',
        ' Next Goal ': 'Next goal chances for home, away or none',
        ' GB (%) ': 'Chances to have a goal in the nexts time bands',

        /* Modal - historical stats */

        ' Avg Stats Per Game ': 'Average statistics of the matches played',

        ' P-Number ': 'Number of matches played at home for home team, and away for visitor team',        
        ' On ': 'Shots on target',
        ' Off ': 'Shots off target',
        ' Blk ': 'Shots blocked',
        ' In ': 'Shots inside the penalty area',
        ' Out ': 'Shots outside the penalty area',
        ' Cnr ': 'Corners',
        ' DA ': 'Dangerous attacks',
        ' Pos ': 'Ball possesion',
        ' Pas ': 'Passagges',
        ' Acc ': 'Passagges accuracy',
        ' Atk ': 'Total attacks',
        ' Ofs ': 'Offsides',
        ' Sav ': 'Saves by the defense',
        ' Sbst ': 'Substitutions',
        ' Fou ': 'Fouls',
        ' G_att ': 'Goal attempts',
        ' Safe ': 'Ball safe',
        ' Rtg ': 'Rating, attack and forcing index'
    },

    'de': {
        match_main: 'Match',
        select_match_main: 'Select Match',
        coming_up_main: 'Coming Up',

        /* === label tooltip === */
        ' H ': 'Home team',
        ' A ': 'Away team',
        ' P ': 'Played matches for local team at home and played matches for visitor team away.',
        ' 0 - 0 ': 'Percentage of matches that went 0 - 0 for local team at home and for visitor team away.',
        ' Ov. 1.5 ': 'Percentage of matches that went over than 1.5 total goals for local team at home and for visitor team away.',
        ' Ov. 2.5 ': 'Percentage of matches that went over than 2.5 total goals for local team at home and for visitor team away.',
        ' Ov. 3.5 ': 'Percentage of matches that went over than 3.5 total goals for local team at home and for visitor team away.',
        ' Scored ': 'Percentage of the matches that a team scored at aleast a goal, local team at home and visitor team away.',
        ' Conc ': 'Percentage of the matches that a team conceded at aleast a goal, local team at home and visitor team away.',
        ' BTS ': 'Percentage of the matches that both teams scored a goal, local team at home and visitor team away.',
        ' 1 + 1st ': 'Percentage of the matches with at least 1 goal in the first half, local team at home and visitor team away.',
        ' 2 + 1st ': 'Percentage of the matches with at least 2 goals in the first half, local team at home and visitor team away.',
        ' 1 + 2st ': 'Percentage of the matches with at least 1 goal in the second half, local team at home and visitor team away.',
        ' 2 + 2st ': 'Percentage of the matches with at least 2 goals in the second half, local team at home and visitor team away.',
        ' Red card ': 'To filter the matches with at least a Red card, on first or second half or on both halves.',
        ' Show last ': 'To filter the last matches played',
        ' Home lineup ': 'To filter the matches played by the local team with a particular lineup',
        ' Away lineup ': 'To filter the matches played by the visitor team with a particular lineup',
        ' Home team ': 'To filter the matches played by the local team against visitor team with a particular rank',
        ' Away team ': 'To filter the matches played by the visitor team against local team with a particular rank',

        ' G+ ': 'Amount of goals scored by the local team at home and visitor team away',
        ' G- ': 'Amount of goals conceded by the local team at home and visitor team away',
        ' 0 - 15 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 16 - 30 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 31 - 45 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 46 - 60 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 61 - 75 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 76 - 90 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' GS1 ': 'Percentage of goals scored in the first half by the local team at home and visitor team away',
        ' GS2 ': 'Percentage of goals scored in the second half by the local team at home and visitor team away',
        ' GC1 ': 'Percentage of goals conceded in the first half by the local team at home and visitor team away',
        ' GC2 ': 'Percentage of goals conceded in the second half by the local team at home and visitor team away',
        ' 40+ ': 'Percentage of matches in which they scored at least 1 goal in the last 5 minutes of the first half',
        ' 85+ ': 'Percentage of matches in which they scored at least 1 goal in the last 5 minutes of the second half',
        ' H_AVG ': 'Average between percentages of matches won by the local team at home and lost by the visitor team away.',
        ' D_AVG ': 'Average between percentages of matches drawn by the local team at home and drawn by the visitor team away.',
        ' A_AVG ': 'Average between percentages of matches lost by the local team at home and won by the visitor team away.',
        ' 1-0 ': 'Average between percentages of matches that went on 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 1-1 ': 'Average between percentages of matches that went on 1-1 after starting 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 2-0 ': 'Average between percentages of matches that went on 2-0 after starting 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 0-1 ': 'Average between percentages of matches that went on 0-1 allowed by local team at home and scored by the visitor team away.',
        ' 1-1_2 ': 'Average between percentages of matches that went on 1-1 after starting 0-1 allowed by local team at home and scored by visitor team away.',
        ' 0-2 ': 'Average between percentages of matches that went on 0-2 after starting 0-1 allowed by local team at home and scored by visitor team away.',
        ' First ': 'Percentages of matches in which a team scores the first goal, local team at home and visitor team away',
        ' Last ': 'Percentages of matches in which a team scores the last goal, local team at home and visitor team away',
        ' 2+ ': 'Average between percentages of matches that went 2 goals ahead at any moment of the game, scored for local team and allowed for visitor team',
        ' 2- ': 'Average between percentages of matches that went 2 goals down at any moment of the game, conceded for local team and scored for visitor team',
        ' H 1st ': 'Average between percentages of matches won in the first half by the local team at home and lost by the visitor team away.',
        ' D 1st ': 'Average between percentages of matches drawn in the first half by the local team at home and drawn by the visitor team away.',
        ' A 1st ': 'Average between percentages of matches lost in the first half by the local team at home and won by the visitor team away.',
        ' H 2nd ': 'Average between percentages of matches won in the second half by the local team at home and lost by the visitor team away.',
        ' D 2nd ': 'Average between percentages of matches drawn in the second half by the local team at home and drawn by the visitor team away.',
        ' A 2nd ': 'Average between percentages of matches lost in the second half by the local team at home and won by the visitor team away.',
        'Current ranking position': 'Current ranking position',
        ' H/A ': 'Virtual ranking position considering matches played at home by the local team, and matches played away by the visitor team only',
        ' Gap1 ': 'Its the virtual gap between the current ranking and H/A Ranking',
        ' FH ': 'Virtual ranking position considering matches results at the end of the first half',
        ' Gap2 ': 'Its the virtual gap between the current ranking and FH Ranking',
        ' SH ': 'Virtual ranking position considering matches results at the end of the second half',
        ' Gap3 ': 'Its the virtual gap between current ranking and SH Ranking',
        ' Attack ': 'Virtual ranking position considering the higher number of goals scored by a team',
        ' Defense ': 'Virtual ranking position considering the smaller number of goals allowed by a team',
        ' Form ': 'Virtual ranking position considering the points won in the last 6 matches, overall',
        ' H/A form ': 'Virtual ranking position considering the points won in the last 6 matches, at home by local team and away by visitor team ',

        /* modal window - Standing tab */

        ' # ': 'Ranking position',
        ' PM ': 'Played matches',
        ' W ': 'Victories',
        ' D ': 'Draws',
        ' L ': 'Lost',
        ' F ': 'Goals scored',
        ' GA ': 'Goals allowed',
        ' GD ': 'Goal difference',
        ' PW ': 'Points won',

        /* Player Roles tooltips */

        'GK': 'Goalkeeper',
        'DEF': 'Defender',
        'MID': 'Midfielder',
        'FWD': 'Forward',

        'GK': 'Goalkeeper',
        'RB': 'Right fullback',
        'CB': 'Center back',
        'LB': 'Left fullback',
        'DM': 'Defending midfielder',
        'CM': 'Central midfielder',
        'RM': 'Right midfielder',
        'LM': 'Left midfielder',
        'AM': 'Attacking midfielder',
        'LW': 'Left winger',
        'RW': 'Right winger',
        'SS': 'Second striker',
        'CF': 'Central forward',

        /* pre match table - Home */
        /* pre match table - Away */

        'Lineup (pre): ': 'Lineup of the team before the match starts',
        'Lineup (live): ': 'Lineup of the team in play',
        'Used:': 'Amount and percentage of the times that such lineup has been used in the last events',
        'Manual: ': 'Select manually the lineup in case is not available',
        ' S.Role ': 'Specific Roles of the lineup',
        ' M.R ': 'Main roles of the lineup',
        ' Line Up Home ': 'List of the players on the pitch for home team',
        ' Line Up Away ': 'List of the players on the pitch for away team',
        ' Sub ': 'minute of substitution',
        ' Market Value ': 'current price value on market for each player',
        ' P.M.Role ': 'Main role of the player',
        ' Primary_Role ': 'Primary specific role of the player',
        ' Alt.Role1 ': 'Alternative role of the player',
        ' Alt.Role2 ': 'Alternative role of the player',
        ' PreRate ': 'Average index of performance of the player pre-match',
        ' LiveRate ': 'Index of performance of the player inplay, it changes color if a player is playing better (green) or worse (red) than usual',
        ' Titularity % ': "Percentage of the appearances in the current season, beside it there's total events amount",

        /* Home Bench */
        /* Away Bench */

        ' Rating ': 'Average index of performance of the player pre-match',
        ' Goal ': 'Amount of goals scored in the current season by the player, with incisivity percentage',
        ' Assist ': 'Amount of assistance provided by the player in the current season',
        ' S_Role ': 'Primary specific role of the player',

        /* Home Team Rating by unit */
        /* Away Team Rating by unit */

        ' average rate pre ': 'Average rating of each unit pre match',
        ' average rate live ': 'Average rating of each unit in play',
        ' Diff rate pre/live % ': 'Difference between pre match and live rating units',

        /* Home VS Away teams by unit */

        ' Pre ': 'Pre-match rating comparison between teams units',
        ' Live ': 'Inplay rating comparison between teams units',
        ' Diff ': 'Inplay comparison of the differences between pre match and live rating units of the teams',

        /* Total */

        ' On ': 'Shots on target',
        ' Off ': 'Shots off target',
        ' Blk ': 'Shots blocked',
        ' In ': 'Shots inside the penalty area',
        ' Out ': 'Shots outside the penalty area',
        ' Cnr ': 'Corners',
        ' DA ': 'Dangerous attacks',
        ' Poss ': 'Ball possesion',
        ' Red ': 'Red cards',
        ' Yel ': 'Yellow cards',
        ' Sbst ': 'Substitutions',
        ' Ini ': 'Incisivity index, can be negative or positive depending on the past average incisivity',
        ' PFM ': 'Performance index, can be negative or positive depending on the past average performances',
        
        ' Goal ': 'Goals scored',
        ' Rtg ': 'Rating, attack and forcing index',

        /* Other labels */

        ' 1 X 2 ': 'Home, draw or away final time chances, with current odds and values',
        ' O / U ': 'nexts Over and Under chances, with currents odds and values',
        ' Next Goal ': 'Next goal chances for home, away or none',
        ' GB (%) ': 'Chances to have a goal in the nexts time bands',

        /* Modal - historical stats */

        ' Avg Stats Per Game ': 'Average statistics of the matches played',

        ' P-Number ': 'Number of matches played at home for home team, and away for visitor team',        
        ' On ': 'Shots on target',
        ' Off ': 'Shots off target',
        ' Blk ': 'Shots blocked',
        ' In ': 'Shots inside the penalty area',
        ' Out ': 'Shots outside the penalty area',
        ' Cnr ': 'Corners',
        ' DA ': 'Dangerous attacks',
        ' Pos ': 'Ball possesion',
        ' Pas ': 'Passagges',
        ' Acc ': 'Passagges accuracy',
        ' Atk ': 'Total attacks',
        ' Ofs ': 'Offsides',
        ' Sav ': 'Saves by the defense',
        ' Sbst ': 'Substitutions',
        ' Fou ': 'Fouls',
        ' G_att ': 'Goal attempts',
        ' Safe ': 'Ball safe',
        ' Rtg ': 'Rating, attack and forcing index'
    },

    'ru': {
        match_main: 'Match',
        select_match_main: 'Select Match',
        coming_up_main: 'Coming Up',

        /* === label tooltip === */
        ' H ': 'Home team',
        ' A ': 'Away team',
        ' P ': 'Played matches for local team at home and played matches for visitor team away.',
        ' 0 - 0 ': 'Percentage of matches that went 0 - 0 for local team at home and for visitor team away.',
        ' Ov. 1.5 ': 'Percentage of matches that went over than 1.5 total goals for local team at home and for visitor team away.',
        ' Ov. 2.5 ': 'Percentage of matches that went over than 2.5 total goals for local team at home and for visitor team away.',
        ' Ov. 3.5 ': 'Percentage of matches that went over than 3.5 total goals for local team at home and for visitor team away.',
        ' Scored ': 'Percentage of the matches that a team scored at aleast a goal, local team at home and visitor team away.',
        ' Conc ': 'Percentage of the matches that a team conceded at aleast a goal, local team at home and visitor team away.',
        ' BTS ': 'Percentage of the matches that both teams scored a goal, local team at home and visitor team away.',
        ' 1 + 1st ': 'Percentage of the matches with at least 1 goal in the first half, local team at home and visitor team away.',
        ' 2 + 1st ': 'Percentage of the matches with at least 2 goals in the first half, local team at home and visitor team away.',
        ' 1 + 2st ': 'Percentage of the matches with at least 1 goal in the second half, local team at home and visitor team away.',
        ' 2 + 2st ': 'Percentage of the matches with at least 2 goals in the second half, local team at home and visitor team away.',
        ' Red card ': 'To filter the matches with at least a Red card, on first or second half or on both halves.',
        ' Show last ': 'To filter the last matches played',
        ' Home lineup ': 'To filter the matches played by the local team with a particular lineup',
        ' Away lineup ': 'To filter the matches played by the visitor team with a particular lineup',
        ' Home team ': 'To filter the matches played by the local team against visitor team with a particular rank',
        ' Away team ': 'To filter the matches played by the visitor team against local team with a particular rank',

        ' G+ ': 'Amount of goals scored by the local team at home and visitor team away',
        ' G- ': 'Amount of goals conceded by the local team at home and visitor team away',
        ' 0 - 15 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 16 - 30 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 31 - 45 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 46 - 60 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 61 - 75 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' 76 - 90 ': 'Percentage of events which had scored and conceded by range of time by the local team at home and visitor team away.',
        ' GS1 ': 'Percentage of goals scored in the first half by the local team at home and visitor team away',
        ' GS2 ': 'Percentage of goals scored in the second half by the local team at home and visitor team away',
        ' GC1 ': 'Percentage of goals conceded in the first half by the local team at home and visitor team away',
        ' GC2 ': 'Percentage of goals conceded in the second half by the local team at home and visitor team away',
        ' 40+ ': 'Percentage of matches in which they scored at least 1 goal in the last 5 minutes of the first half',
        ' 85+ ': 'Percentage of matches in which they scored at least 1 goal in the last 5 minutes of the second half',
        ' H_AVG ': 'Average between percentages of matches won by the local team at home and lost by the visitor team away.',
        ' D_AVG ': 'Average between percentages of matches drawn by the local team at home and drawn by the visitor team away.',
        ' A_AVG ': 'Average between percentages of matches lost by the local team at home and won by the visitor team away.',
        ' 1-0 ': 'Average between percentages of matches that went on 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 1-1 ': 'Average between percentages of matches that went on 1-1 after starting 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 2-0 ': 'Average between percentages of matches that went on 2-0 after starting 1-0 scored by local team at home and allowed by the visitor team away.',
        ' 0-1 ': 'Average between percentages of matches that went on 0-1 allowed by local team at home and scored by the visitor team away.',
        ' 1-1_2 ': 'Average between percentages of matches that went on 1-1 after starting 0-1 allowed by local team at home and scored by visitor team away.',
        ' 0-2 ': 'Average between percentages of matches that went on 0-2 after starting 0-1 allowed by local team at home and scored by visitor team away.',
        ' First ': 'Percentages of matches in which a team scores the first goal, local team at home and visitor team away',
        ' Last ': 'Percentages of matches in which a team scores the last goal, local team at home and visitor team away',
        ' 2+ ': 'Average between percentages of matches that went 2 goals ahead at any moment of the game, scored for local team and allowed for visitor team',
        ' 2- ': 'Average between percentages of matches that went 2 goals down at any moment of the game, conceded for local team and scored for visitor team',
        ' H 1st ': 'Average between percentages of matches won in the first half by the local team at home and lost by the visitor team away.',
        ' D 1st ': 'Average between percentages of matches drawn in the first half by the local team at home and drawn by the visitor team away.',
        ' A 1st ': 'Average between percentages of matches lost in the first half by the local team at home and won by the visitor team away.',
        ' H 2nd ': 'Average between percentages of matches won in the second half by the local team at home and lost by the visitor team away.',
        ' D 2nd ': 'Average between percentages of matches drawn in the second half by the local team at home and drawn by the visitor team away.',
        ' A 2nd ': 'Average between percentages of matches lost in the second half by the local team at home and won by the visitor team away.',
        'Current ranking position': 'Current ranking position',
        ' H/A ': 'Virtual ranking position considering matches played at home by the local team, and matches played away by the visitor team only',
        ' Gap1 ': 'Its the virtual gap between the current ranking and H/A Ranking',
        ' FH ': 'Virtual ranking position considering matches results at the end of the first half',
        ' Gap2 ': 'Its the virtual gap between the current ranking and FH Ranking',
        ' SH ': 'Virtual ranking position considering matches results at the end of the second half',
        ' Gap3 ': 'Its the virtual gap between current ranking and SH Ranking',
        ' Attack ': 'Virtual ranking position considering the higher number of goals scored by a team',
        ' Defense ': 'Virtual ranking position considering the smaller number of goals allowed by a team',
        ' Form ': 'Virtual ranking position considering the points won in the last 6 matches, overall',
        ' H/A form ': 'Virtual ranking position considering the points won in the last 6 matches, at home by local team and away by visitor team ',

        /* modal window - Standing tab */

        ' # ': 'Ranking position',
        ' PM ': 'Played matches',
        ' W ': 'Victories',
        ' D ': 'Draws',
        ' L ': 'Lost',
        ' F ': 'Goals scored',
        ' GA ': 'Goals allowed',
        ' GD ': 'Goal difference',
        ' PW ': 'Points won',

        /* Player Roles tooltips */

        'GK': 'Goalkeeper',
        'DEF': 'Defender',
        'MID': 'Midfielder',
        'FWD': 'Forward',

        'GK': 'Goalkeeper',
        'RB': 'Right fullback',
        'CB': 'Center back',
        'LB': 'Left fullback',
        'DM': 'Defending midfielder',
        'CM': 'Central midfielder',
        'RM': 'Right midfielder',
        'LM': 'Left midfielder',
        'AM': 'Attacking midfielder',
        'LW': 'Left winger',
        'RW': 'Right winger',
        'SS': 'Second striker',
        'CF': 'Central forward',

        /* pre match table - Home */
        /* pre match table - Away */

        'Lineup (pre): ': 'Lineup of the team before the match starts',
        'Lineup (live): ': 'Lineup of the team in play',
        'Used:': 'Amount and percentage of the times that such lineup has been used in the last events',
        'Manual: ': 'Select manually the lineup in case is not available',
        ' S.Role ': 'Specific Roles of the lineup',
        ' M.R ': 'Main roles of the lineup',
        ' Line Up Home ': 'List of the players on the pitch for home team',
        ' Line Up Away ': 'List of the players on the pitch for away team',
        ' Sub ': 'minute of substitution',
        ' Market Value ': 'current price value on market for each player',
        ' P.M.Role ': 'Main role of the player',
        ' Primary_Role ': 'Primary specific role of the player',
        ' Alt.Role1 ': 'Alternative role of the player',
        ' Alt.Role2 ': 'Alternative role of the player',
        ' PreRate ': 'Average index of performance of the player pre-match',
        ' LiveRate ': 'Index of performance of the player inplay, it changes color if a player is playing better (green) or worse (red) than usual',
        ' Titularity % ': "Percentage of the appearances in the current season, beside it there's total events amount",

        /* Home Bench */
        /* Away Bench */

        ' Rating ': 'Average index of performance of the player pre-match',
        ' Goal ': 'Amount of goals scored in the current season by the player, with incisivity percentage',
        ' Assist ': 'Amount of assistance provided by the player in the current season',
        ' S_Role ': 'Primary specific role of the player',

        /* Home Team Rating by unit */
        /* Away Team Rating by unit */

        ' average rate pre ': 'Average rating of each unit pre match',
        ' average rate live ': 'Average rating of each unit in play',
        ' Diff rate pre/live % ': 'Difference between pre match and live rating units',

        /* Home VS Away teams by unit */

        ' Pre ': 'Pre-match rating comparison between teams units',
        ' Live ': 'Inplay rating comparison between teams units',
        ' Diff ': 'Inplay comparison of the differences between pre match and live rating units of the teams',

        /* Total */

        ' On ': 'Shots on target',
        ' Off ': 'Shots off target',
        ' Blk ': 'Shots blocked',
        ' In ': 'Shots inside the penalty area',
        ' Out ': 'Shots outside the penalty area',
        ' Cnr ': 'Corners',
        ' DA ': 'Dangerous attacks',
        ' Poss ': 'Ball possesion',
        ' Red ': 'Red cards',
        ' Yel ': 'Yellow cards',
        ' Sbst ': 'Substitutions',
        ' Ini ': 'Incisivity index, can be negative or positive depending on the past average incisivity',
        ' PFM ': 'Performance index, can be negative or positive depending on the past average performances',
        
        ' Goal ': 'Goals scored',
        ' Rtg ': 'Rating, attack and forcing index',

        /* Other labels */

        ' 1 X 2 ': 'Home, draw or away final time chances, with current odds and values',
        ' O / U ': 'nexts Over and Under chances, with currents odds and values',
        ' Next Goal ': 'Next goal chances for home, away or none',
        ' GB (%) ': 'Chances to have a goal in the nexts time bands',

        /* Modal - historical stats */

        ' Avg Stats Per Game ': 'Average statistics of the matches played',

        ' P-Number ': 'Number of matches played at home for home team, and away for visitor team',        
        ' On ': 'Shots on target',
        ' Off ': 'Shots off target',
        ' Blk ': 'Shots blocked',
        ' In ': 'Shots inside the penalty area',
        ' Out ': 'Shots outside the penalty area',
        ' Cnr ': 'Corners',
        ' DA ': 'Dangerous attacks',
        ' Pos ': 'Ball possesion',
        ' Pas ': 'Passagges',
        ' Acc ': 'Passagges accuracy',
        ' Atk ': 'Total attacks',
        ' Ofs ': 'Offsides',
        ' Sav ': 'Saves by the defense',
        ' Sbst ': 'Substitutions',
        ' Fou ': 'Fouls',
        ' G_att ': 'Goal attempts',
        ' Safe ': 'Ball safe',
        ' Rtg ': 'Rating, attack and forcing index'
    },
};

const i18n = new VueI18n({
    locale: 'en', // set locale
    fallbackLocale: 'es', // set fallback locale
    messages, // set locale messages
});

export default i18n;